{
  "app.nama": "Smova",
  "app.tenantMarketing": "Tenant Marketing",
  "nav.hariIni": "Hari ini",
  "nav.perluDijawab": "Perlu dijawab",
  "nav.prospek": "Prospek",
  "nav.meeting": "Meeting",
  "nav.konten": "Konten",
  "umum.muat": "Memuat…",
  "umum.gagal": "Gagal memuat",
  "umum.cobaLagi": "Coba lagi",
  "umum.kosong": "Belum ada isinya",
  "umum.cari": "Cari…",
  "umum.semua": "Semua",
  "umum.tutup": "Tutup",
  "umum.simpan": "Simpan",
  "umum.simpanPerubahan": "Simpan perubahan",
  "umum.batal": "Batal",
  "umum.kembali": "Kembali",
  "umum.lihat": "Lihat",
  "umum.buka": "Buka",
  "umum.dari": "{{mulai}}–{{akhir}} dari {{total}}",
  "umum.bahasa": "Bahasa",
  "tema.label": "Tema",
  "tema.perangkat": "Perangkat",
  "tema.terang": "Terang",
  "tema.gelap": "Gelap",
  "umum.keluar": "Keluar",
  "umum.jaringanMati": "Tidak bisa menghubungi server. Periksa sambungan, atau dev sedang mati.",
  "umum.sesiHabis": "Sesi Anda habis. Masuk lagi.",
  "login.judul": "Masuk",
  "login.keterangan": "Pakai akun dashboard Anda.",
  "login.username": "Email",
  "login.password": "Kata sandi",
  "login.tombol": "Masuk",
  "login.sedang": "Sedang masuk…",
  "hariIni.judul": "Hari ini",
  "hariIni.keterangan": "Yang menunggu Anda, bukan yang menunggu tim.",
  "hariIni.dmDiambil": "{{n}} DM sudah Anda ambil, belum Anda balas",
  "hariIni.dmBelumDiambil": "{{n}} DM belum diambil siapa pun",
  "hariIni.komentarBelumDijawab": "{{n}} komentar di postingan belum dijawab",
  "hariIni.meetingBerikut": "Meeting berikutnya",
  "hariIni.meetingHariIni": "{{n}} meeting hari ini",
  "hariIni.kontenMenunggu": "{{n}} konten menunggu ditinjau",
  "hariIni.bersih": "Tidak ada yang tertahan. Selamat.",
  "hariIni.angka7hari": "7 hari terakhir",
  "hariIni.dmMasuk": "DM masuk",
  "hariIni.prospekBaru": "Prospek baru",
  "hariIni.kontenTerbit": "Konten terbit",
  "masuk.judul": "Perlu dijawab",
  "masuk.keterangan": "DM dan komentar yang bot tidak sanggup jawab sendiri.",
  "masuk.datang": "Datang",
  "masuk.dari": "Dari",
  "masuk.isi": "Isi",
  "masuk.jenis": "Jenis",
  "masuk.keadaan": "Keadaan",
  "masuk.bot": "Bot",
  "masuk.belumDiambil": "Belum diambil",
  "masuk.andaAmbil": "Anda yang ambil",
  "masuk.diambil": "Diambil {{nama}}",
  "masuk.botHidup": "Hidup",
  "masuk.botDipegang": "Dipegang",
  "masuk.ambil": "Ambil",
  "masuk.abaikan": "Tidak perlu dibalas",
  "masuk.abaikanGagal": "Tidak bisa menandai: {{sebab}}",
  "masuk.balas": "Balas",
  "masuk.dm": "DM",
  "masuk.komentar": "Komentar",
  "masuk.kosong": "Tidak ada yang menunggu dijawab.",
  "prospek.judul": "Prospek",
  "prospek.keterangan": "Dari Instagram, ditambah yang Anda masukkan sendiri.",
  "prospek.perusahaan": "Perusahaan",
  "prospek.asal": "Asal",
  "prospek.tahap": "Tahap",
  "prospek.ditangani": "Ditangani",
  "prospek.bergerak": "Terakhir bergerak",
  "prospek.tambah": "Tambah manual",
  "prospek.kosong": "Belum ada prospek. Yang datang dari Instagram muncul sendiri di sini.",
  "prospek.data": "Data terkumpul",
  "prospek.percakapan": "Percakapan",
  "prospek.ikhtisar": "Ikhtisar",
  "prospek.jadwalkanMeeting": "Jadwalkan meeting",
  "prospek.ubahData": "Ubah data",
  "prospek.ubahCatatan": "Nilai lama tidak hilang — tiap perubahan tersimpan di riwayat beserta nilai sebelumnya.",
  "prospek.tambahCatatan": "Tambah catatan",
  "prospek.simpanCatatan": "Simpan catatan",
  "prospek.simpanMeeting": "Jadwalkan",
  "prospek.alamat": "Alamat",
  "prospek.pic": "PIC",
  "prospek.email": "Email",
  "prospek.telepon": "Telepon",
  "prospek.cJudul": "Apa yang terjadi",
  "prospek.cContoh": "Ditelepon, minta proposal",
  "prospek.cKapan": "Tanggal kejadian",
  "prospek.cKeterangan": "Keterangan",
  "prospek.mTanggal": "Tanggal",
  "prospek.mJam": "Jam",
  "prospek.mTautan": "Tautan meeting",
  "prospek.mLokasi": "Lokasi",
  "prospek.meeting": "Meeting",
  "prospek.meetingHitung": "{{n}} meeting",
  "prospek.meetingCatatan": "Satu prospek boleh punya banyak meeting. Semuanya terikat pada prospek ini — hapus prospeknya, meetingnya ikut.",
  "prospek.meetingKosong": "Belum pernah meeting",
  "prospek.meetingKosongKet": "Meeting yang dijadwalkan lewat bot maupun dijadwalkan tangan akan muncul di sini.",
  "prospek.meetingBerikutnya": "Meeting berikutnya · {{kapan}}",
  "prospek.mKapan": "Kapan",
  "prospek.mBentuk": "Bentuk",
  "prospek.mSiapa": "Yang menjalankan",
  "prospek.mAgenda": "Agenda",
  "prospek.koreksiJadwal": "Koreksi catatan jadwal lama (tanpa pemberitahuan)",
  "prospek.waktuTidakAda": "Jam ini tidak ada di zona waktu tenant. Pilih jam lain.",
  "meetingStatus.scheduled": "Terjadwal",
  "meetingStatus.pending_confirmation": "Menunggu konfirmasi",
  "meetingStatus.done": "Selesai",
  "meetingStatus.no_show": "Tidak hadir",
  "meetingStatus.cancelled": "Dibatalkan",
  "meetingStatus.claimed": "Terjadwal",
  "meetingStatus.pending_claim": "Terjadwal",
  "prospek.mHasil": "Hasil",
  "prospek.mRekaman": "Rekaman",
  "prospek.adaRingkasan": "Ada ringkasan",
  "prospek.tanpaRekaman": "Tanpa rekaman",
  "prospek.belumAdaHasil": "belum diisi",
  "prospek.belumDijadwalkan": "belum dijadwalkan",
  "prospek.online": "Online",
  "prospek.offline": "Offline",
  "prospek.bentukBelum": "belum ditentukan",
  "prospek.siapaMembalas": "Siapa yang membalas percakapan ini",
  "prospek.siapaMembalasCatatan": "Orang yang pernah mengambil alih. Selain nama di sini, yang membalas bot.",
  "prospek.belumAdaPenangan": "Belum ada yang mengambil alih — seluruh balasan dari bot.",
  "prospek.catatan": "Catatan",
  "prospek.belumDiisi": "belum diisi",
  "prospek.botDipegang": "Anda memegang percakapan ini",
  "prospek.botHidup": "Bot membalas otomatis",
  "prospek.pegang": "Pegang percakapan",
  "prospek.lepas": "Lepas — nyalakan bot lagi",
  "meeting.judul": "Meeting",
  "meeting.keterangan": "Kapan Anda ada meeting, dan kapan Anda tidak bisa.",
  "meeting.jadwalSaya": "Jadwal saya",
  "meeting.ketersediaan": "Ketersediaan saya",
  "meeting.kapan": "Kapan",
  "meeting.dengan": "Dengan",
  "meeting.bentuk": "Bentuk",
  "meeting.bersama": "Bersama",
  "meeting.kosong": "Tidak ada meeting mendatang.",
  "meeting.diblokir": "Tanggal diblokir",
  "meeting.alasan": "Alasan",
  "meeting.blokirKosong": "Belum ada tanggal yang Anda blokir.",
  "konten.judul": "Konten",
  "konten.keterangan": "Yang akan tayang, yang sudah tayang, dan yang menunggu ditinjau.",
  "konten.akanTayang": "Akan tayang",
  "konten.sudahTayang": "Sudah tayang",
  "konten.menungguTinjauan": "Menunggu tinjauan",
  "konten.menungguAnda": "Menunggu Anda",
  "konten.terjadwal": "Terjadwal",
  "konten.setujuiKonsep": "Setujui konsep",
  "konten.stKonsep": "Menunggu persetujuan konsep",
  "konten.tayang": "Tayang",
  "konten.jenis": "Jenis",
  "konten.tujuan": "Tujuan",
  "konten.keadaan": "Keadaan",
  "konten.setujui": "Setujui",
  "konten.tolak": "Tolak",
  "konten.kosong": "Belum ada konten.",
  "konten.jangkauan": "Jangkauan",
  "konten.belumTersedia": "belum tersedia",
  "masuk.semuaKeadaan": "Semua keadaan",
  "masuk.hanyaBelum": "Belum diambil",
  "masuk.hanyaSaya": "Saya yang ambil",
  "masuk.hanyaOrangLain": "Diambil orang lain",
  "masuk.pesan": "Pesan",
  "hariIni.dmMenunggu": "{{n}} DM & komentar menunggu dijawab",
  "app.deskripsi": "Chatbot, prospek, dan konten — satu tempat.",
  "login.selamat": "Selamat datang kembali",
  "login.lupa": "Lupa kata sandi? Hubungi admin perusahaan Anda.",
  "login.lingkungan": "Terhubung ke",
  "login.satuPintu": "Satu akun untuk semua dashboard — yang Anda lihat ditentukan peran Anda.",
  "login.panelJudul": "Otomasi marketing untuk tim bisnis Anda.",
  "login.fitur1": "DM dan komentar dibalas otomatis, berdasarkan pengetahuan perusahaan Anda.",
  "login.fitur2": "Prospek dikenali, lalu tim diberi tahu lewat Telegram untuk mengambil alih.",
  "login.fitur3": "Konten disusun, disetujui tim, lalu terbit sesuai jadwal.",
  "login.tampilkanSandi": "Tampilkan kata sandi",
  "masuk.balasKe": "Balasan untuk {{nama}}",
  "masuk.tulisBalasan": "Tulis balasan yang akan dikirim ke Instagram…",
  "masuk.kirim": "Kirim balasan",
  "masuk.mengirim": "Mengirim…",
  "masuk.langsungTerkirim": "Langsung terkirim ke Instagram, tidak bisa ditarik.",
  "app.smovaAdmin": "Admin",
  "adm.navTenant": "Tenant",
  "adm.navPemakaian": "Pemakaian",
  "adm.navJalurMasuk": "Jalur masuk",
  "adm.navKatalog": "Katalog",
  "adm.navSistem": "Sistem",
  "adm.segera": "segera",
  "adm.belumTersedia": "Belum tersedia — backendnya belum dibangun.",
  "adm.tenantJudul": "Tenant",
  "adm.tenantKeterangan": "Semua klien, dan pintu ke pengaturan masing-masing.",
  "adm.tenantBaru": "Tenant baru",
  "adm.namaTenant": "Nama tenant",
  "adm.namaTenantContoh": "Nama perusahaan klien",
  "adm.lahirDraft": "Tenant baru lahir 'draft': bot diam total, dan konten tidak diterbitkan. Naikkan ke 'test' setelah akun uji terdaftar.",
  "adm.buatTenant": "Buat tenant",
  "adm.membuat": "Membuat…",
  "adm.belumAdaTenant": "Belum ada tenant.",
  "adm.kolNama": "Nama",
  "adm.kolTipe": "Tipe",
  "adm.kolMode": "Mode",
  "adm.kolZona": "Zona waktu",
  "adm.kolDibuat": "Dibuat",
  "adm.detailTenant": "Detail tenant",
  "adm.keOnboarding": "Onboarding tenant ini",
  "adm.tabKoneksi": "Koneksi",
  "adm.tabOrang": "Orang",
  "adm.siapPenuh": "Tenant ini siap dan beroperasi normal.",
  "adm.siapTapiDibatasi": "Secara teknis siap, tapi masih dibatasi mode.",
  "adm.belumSiap": "Belum bisa menerima DM. Yang kurang:",
  "adm.akunPlatform": "Akun platform",
  "adm.akunCatatan": "menjawab \"DM ini milik siapa\"",
  "adm.kolPlatform": "Platform",
  "adm.kolIdAkun": "ID akun",
  "adm.kolKeadaan": "Akun aktif?",
  "adm.aktif": "Aktif",
  "adm.nonaktif": "Nonaktif",
  "adm.aktifkan": "Aktifkan",
  "adm.nonaktifkan": "Nonaktifkan",
  "adm.idAkunInstagram": "ID akun Instagram",
  "adm.daftarkan": "Daftarkan",
  "adm.mendaftarkan": "Mendaftarkan…",
  "adm.kredensial": "Kredensial Meta",
  "adm.kredensialCatatan": "terenkripsi, tidak bisa dibaca kembali",
  "adm.kolPenyedia": "Penyedia",
  "adm.kolJenis": "Jenis",
  "adm.kolKedaluwarsa": "Kedaluwarsa",
  "adm.kolDimuat": "Dimuat",
  "adm.kedaluwarsa": "Kedaluwarsa",
  "adm.tokenMeta": "Token Meta",
  "adm.tokenSekaliTulis": "Sekali tulis. Setelah disimpan ia tidak bisa ditampilkan lagi — memuat yang baru akan merotasi yang lama.",
  "adm.muatToken": "Muat token",
  "adm.memuat": "Memuat…",
  "adm.tokenTermuat": "Token tersimpan dan terenkripsi.",
  "adm.akunUji": "Akun uji",
  "adm.akunUjiCatatan": "hanya berlaku saat mode 'test'",
  "adm.akunUjiKosong": "Belum ada akun uji. Selama mode 'test', bot tidak akan menjawab siapa pun.",
  "adm.tambahAkunUji": "Tambah akun uji",
  "adm.tambah": "Tambah",
  "adm.hapusAkunUji": "Hapus dari daftar",
  "adm.orangJudul": "Orang di tenant ini",
  "adm.orangCatatan": "lewat rute tenant biasa",
  "adm.kolPeran": "Peran",
  "adm.kolTelegram": "Telegram",
  "adm.belumTertaut": "belum tertaut",
  "adm.kolMasukTerakhir": "Masuk terakhir",
  "adm.akunPenjelasan": "Tanpa satu pun akun aktif di sini, webhook Meta tidak menemukan tenant ini dan DM-nya tercatat sebagai 'tanpa tenant'.",
  "adm.grupOperasi": "Operasi",
  "adm.grupDataInduk": "Data induk",
  "peran.smova_admin": "Smova Admin",
  "peran.tenant_admin": "Tenant Admin",
  "peran.tenant_marketing": "Tenant Marketing",
  "jm.judul": "Jalur masuk",
  "jm.keterangan": "Setiap webhook yang sampai, dan yang tersangkut sebelum jadi DM.",
  "jm.kejadian": "Kejadian",
  "jm.semuaTenant": "Semua tenant",
  "jm.tanpaTenant": "Tanpa tenant",
  "jm.semuaStatus": "Semua status",
  "jm.status.diterima": "Diterima",
  "jm.status.diproses": "Diproses",
  "jm.status.gagal": "Gagal",
  "jm.status.tanpa_tenant": "Tanpa tenant",
  "jm.kolWaktu": "Waktu",
  "jm.kolPlatform": "Platform",
  "jm.kolAkun": "ID akun",
  "jm.kolTenant": "Tenant",
  "jm.kolStatus": "Diterima?",
  "jm.kolSebab": "Kenapa gagal",
  "jm.kosong": "Tidak ada kejadian yang cocok.",
  "jm.kosongKeterangan": "Coba longgarkan penyaringnya, atau tunggu webhook berikutnya.",
  "jm.catatanIsi": "Daftar ini tidak membawa isi pesan. Membukanya per kejadian bisa, dan setiap pembukaan tercatat.",
  "jm.bukaPayload": "Buka isi",
  "jm.pembukaanDicatat": "Membuka isi ini tercatat di jejak audit — siapa, kapan, dan kejadian mana.",
  "pk.judul": "Pemakaian",
  "pk.keterangan": "Berapa banyak model dipakai tenant ini, dan oleh siapa.",
  "pk.hari": "{{n}} hari terakhir",
  "pk.totalPanggilan": "Panggilan model",
  "pk.totalToken": "Token terpakai",
  "pk.perModel": "Model yang membalas chat",
  "pk.belumAdaModel": "Belum ada balasan yang tercatat modelnya.",
  "pk.kolModel": "Model",
  "pk.kolBalasan": "Balasan dibuat",
  "pk.perHari": "Per hari",
  "pk.kolTanggal": "Tanggal",
  "pk.kolJenis": "Jenis",
  "pk.kolPelaku": "Pelaku",
  "pk.kolJumlah": "Jumlah",
  "pk.kolToken": "Token",
  "pk.kosong": "Belum ada pemakaian tercatat.",
  "pk.kosongKeterangan": "Tidak ada baris dalam {{n}} hari terakhir. Coba rentang yang lebih panjang.",
  "kt.judul": "Katalog",
  "kt.keterangan": "Data induk: fitur yang bisa dijual, dan model AI yang ada di sistem.",
  "kt.tabModel": "Model AI",
  "kt.tabFitur": "Fitur",
  "kt.fiturJudul": "Katalog fitur",
  "kt.fiturCatatan": "dibaca saja — sumbernya migrasi",
  "kt.modelJudul": "Model AI",
  "kt.modelCatatan": "tingkat 1: apa yang ada di sistem",
  "kt.kolKunci": "Kunci",
  "kt.kolNama": "Nama",
  "kt.kolButuh": "Butuh",
  "kt.kolId": "ID model",
  "kt.kolPenyedia": "Penyedia",
  "kt.kolPeran": "Peran",
  "kt.kolTier": "Tingkatan",
  "kt.kolTarif": "Tarif",
  "kt.kolDipakai": "Tenant memakai",
  "kt.tanpaTier": "(tanpa tingkatan)",
  "kt.tambahModel": "Tambah model",
  "kt.simpanModel": "Simpan model",
  "kt.menambah": "Menyimpan…",
  "kt.aktifkan": "Aktifkan",
  "kt.nonaktifkan": "Nonaktifkan",
  "kt.tarifKosong": "belum diisi",
  "app.tenantAdmin": "Tenant Admin",
  "ta.navFitur": "Fitur",
  "ta.navModel": "Model AI",
  "ta.fiturJudul": "Fitur",
  "ta.fiturKeterangan": "Apa saja yang hidup untuk perusahaan Anda.",
  "ta.fiturCatatan": "Fitur yang saling bergantung tidak bisa dinyalakan sendiri-sendiri — sistem menolak urutan yang tidak masuk akal, bukan membiarkannya lalu gagal diam-diam.",
  "ta.kolFitur": "Fitur",
  "ta.kolButuh": "Butuh",
  "ta.kolKeadaan": "Menyala?",
  "ta.kolAktif": "Aktif?",
  "ta.kolAkunAktif": "Akun aktif?",
  "ta.kolDipakaiBot": "Dipakai bot",
  "ta.hidup": "Hidup",
  "ta.mati": "Mati",
  "ta.nyalakan": "Nyalakan",
  "ta.matikan": "Matikan",
  "ta.modelJudul": "Model AI",
  "ta.modelKeterangan": "Model mana yang boleh dipakai, dan dalam urutan apa.",
  "ta.urutanCadangan": "urutan = rantai cadangan",
  "ta.belumAdaModel": "Belum ada model dipilih. Tanpa ini, jalur tersebut memakai bawaan sistem.",
  "ta.tambahkan": "Tambahkan",
  "ta.buang": "Buang",
  "ta.naik": "Naikkan urutan",
  "ta.turun": "Turunkan urutan",
  "ta.peranChat": "Chatbot — membalas DM & komentar",
  "ta.peranText": "Teks — caption & konsep konten",
  "ta.peranImage": "Gambar — foto konten",
  "ta.peranVideo": "Video — video konten",
  "pk.totalBiaya": "Biaya (USD)",
  "pk.kolBiaya": "Biaya",
  "pk.biayaBelumLengkap": "{{n}} panggilan belum punya tarif di katalog, jadi biaya di halaman ini BATAS BAWAH — bukan total. Isi tarif model itu di layar Katalog supaya angkanya lengkap.",
  "kt.kolKeadaan": "Masih dijual?",
  "kt.fiturDitawarkan": "ditawarkan",
  "kt.fiturDitarik": "ditarik",
  "tk.judul": "Konten",
  "tk.keterangan": "Pengaturan rantai konten keluar — dari pencarian bahan sampai unggahannya.",
  "tk.scrapingJudul": "Sumber & topik",
  "tk.scrapingCatatan": "Sumber bahan untuk konsep yang disusun AI.",
  "tk.scrapingMati": "Fitur Pengambilan tren sedang mati, jadi pengaturannya disembunyikan. Nyalakan di layar Fitur kalau memang mau dipakai — pengaturannya kembali apa adanya, tidak ada yang hilang.",
  "tk.kolTopik": "Topik",
  "tk.topikCatatan": "Pisahkan dengan koma.",
  "tk.kolJadwal": "Jadwal (cron)",
  "tk.jadwalCatatan": "Kapan tren diambil.",
  "tk.otomatis": "otomatis, tanpa ditinjau",
  "umum.menyimpan": "Menyimpan…",
  "ta.navKonten": "Atur Konten",
  "fp.judul": "Field profil",
  "fp.keterangan": "Pertanyaan yang bot ajukan ke prospek. Berlaku pada percakapan berikutnya, tanpa deploy.",
  "fp.daftarJudul": "Data yang dikumpulkan bot",
  "fp.tambah": "Tambah field",
  "fp.simpanField": "Simpan field",
  "fp.kolKunci": "Nama data",
  "fp.kolLabel": "Label yang ditanyakan bot",
  "fp.kolTipe": "Jenis",
  "fp.kolWajib": "Wajib",
  "fp.kolTerisi": "Terisi di",
  "fp.kolKeadaan": "Masih ditanyakan",
  "fp.wajib": "Wajib",
  "fp.opsional": "Opsional",
  "fp.ditanyakan": "Ya",
  "fp.tidakLagi": "Tidak lagi",
  "fp.matikan": "Matikan",
  "fp.nyalakan": "Nyalakan",
  "fp.bawaan": "bawaan",
  "fp.kunciCatatan": "Kunci adalah identitas permanen field ini dan tidak bisa diubah — pertanyaannya yang bebas disunting kapan saja. Kalau kunci ikut berubah, seluruh jawaban yang sudah terkumpul kehilangan tempatnya.",
  "ta.navField": "Field Profil",
  "adm.tabIkhtisar": "Ikhtisar",
  "adm.tabAlur": "Alur pesan",
  "adm.tabPengaturan": "Pengaturan",
  "adm.tabPengetahuan": "Pengetahuan",
  "adm.tabAktivitas": "Aktivitas",
  "adm.ikhPanggilan": "Panggilan model (30 hr)",
  "adm.ikhToken": "Token (30 hr)",
  "adm.ikhBiaya": "Biaya (30 hr)",
  "adm.ikhKurangJudul": "Belum lengkap",
  "adm.ikhKurangCatatan": "Yang masih menahan tenant ini berjalan penuh.",
  "adm.ikhFiturJudul": "Fitur yang mati",
  "adm.ikhFiturCatatan": "Yang menyala tidak didaftar — yang mati yang menjelaskan perilaku.",
  "adm.ikhSemuaNyala": "Semua fitur menyala.",
  "adm.alurCatatan": "Webhook yang sampai ke tenant ini, terbaru dulu.",
  "adm.alurKosong": "Belum ada webhook yang masuk.",
  "adm.alurKosongKet": "Kalau bot tidak membalas dan daftar ini kosong, masalahnya sebelum sistem ini — periksa sambungannya.",
  "adm.setCatatan": "Dibaca saja. Menyuntingnya milik admin tenant — operator yang mengubah setelan klien tanpa klien tahu adalah perubahan yang tidak bisa dijelaskan siapa pun nanti.",
  "adm.kolSetelan": "Setelan",
  "adm.kolNilai": "Nilai",
  "adm.setJadwal": "Jadwal scraping",
  "adm.setTopik": "Topik",
  "adm.setBalasOtomatis": "Balasan otomatis",
  "adm.setAkunUji": "Akun uji",
  "adm.pengCatatan": "Judul dan keadaannya. Isinya tidak ditampilkan — dokumen bisa memuat harga dan syarat kontrak.",
  "adm.pengKosong": "Belum ada dokumen pengetahuan.",
  "adm.pengKosongKet": "Bot akan menjawab tanpa bahan. Muat dokumennya lebih dulu.",
  "adm.kolDokumen": "Dokumen",
  "adm.kolVersi": "Versi",
  "adm.kolPotongan": "Potongan",
  "adm.kolDipakaiBot": "Dipakai bot",
  "adm.belumDiproses": "belum diproses",
  "adm.kolPanjang": "Panjang",
  "adm.aktCatatan": "50 perubahan terakhir di tenant ini.",
  "adm.aktKosong": "Belum ada perubahan tercatat.",
  "adm.kolObjek": "Apa yang diubah",
  "adm.kolAksi": "Tindakan",
  "adm.kolPelaku": "Siapa",
  "adm.kolPerubahan": "Perubahan",
  "adm.kolWaktu": "Waktu",
  "adm.kolDiterima": "Diterima?",
  "adm.kolAkun": "Akun",
  "sis.judul": "Sistem",
  "sis.keterangan": "Kesehatan layanan dan akun operator Smova.",
  "sis.periksaJudul": "Pemeriksaan",
  "sis.periksaCatatan": "Seluruhnya dari database yang sudah dipegang — tidak ada panggilan keluar, jadi membuka halaman ini tidak membakar kuota siapa pun.",
  "sis.kolPeriksa": "Yang diperiksa",
  "sis.kolNilai": "Nilai",
  "sis.kolArti": "Artinya",
  "sis.operatorJudul": "Operator Smova",
  "sis.operatorCatatan": "Akun berperan smova_admin — yang bisa melihat seluruh tenant.",
  "sis.operatorKosong": "Belum ada akun operator.",
  "sis.kolNama": "Nama pengguna",
  "sis.kolPeran": "Peran",
  "sis.kolMasukTerakhir": "Terakhir masuk",
  "sis.belumPernahMasuk": "belum pernah masuk",
  "sis.kolKeadaan": "Akun aktif?",
  "sb.platformJudul": "Akun platform",
  "sb.platformCatatan": "Tiap platform bisa hal yang berbeda — bukan satu saklar.",
  "sb.platformKaki": "Yang bertanda “belum dibangun” bukan berarti hilang: adapternya memang belum ada, jadi mendaftarkan akunnya sekarang cuma melahirkan baris yang tidak melakukan apa pun. Urutan penambahan yang ditetapkan: Facebook Page → LinkedIn → TikTok.",
  "sb.kolPlatform": "Platform",
  "sb.kolAkun": "Akun",
  "sb.belumDihubungkan": "belum dihubungkan",
  "sb.kap.bisa": "bisa",
  "sb.kap.tidak_bisa": "tidak bisa",
  "sb.kap.belum_dibangun": "belum dibangun",
  "sb.grupJudul": "Grup Telegram",
  "sb.grupCatatan": "Tempat notifikasi tim dikirim. Dari chat_id inilah tenant sebuah pesan Telegram ditentukan.",
  "sb.tambahGrup": "Tambah grup",
  "sb.simpanGrup": "Simpan grup",
  "sb.kolChatId": "Chat ID",
  "sb.kolLabel": "Label",
  "sb.kolKeadaan": "Aktif?",
  "sb.kolBisa": "Bisa?",
  "sb.chatIdCatatan": "chat_id grup selalu negatif, mis. -1001234567890. Dapatkan dengan menambahkan bot ke grup lalu buka log webhook-nya. Satu grup hanya boleh milik satu tenant.",
  "sb.grupKosong": "Belum ada grup Telegram.",
  "sb.grupKosongKet": "Tanpa grup, tim tidak menerima notifikasi apa pun — prospek masuk dan tidak ada yang tahu.",
  "ta2.judul": "Tambah akun",
  "ta2.catatan": "Satu alur: pilih platform, isian menyesuaikan.",
  "ta2.platform": "Platform",
  "ta2.idAkun": "ID akun {{platform}}",
  "ta2.token": "Token {{provider}}",
  "ta2.tokenCatatan": "Sekali tulis. Tidak ada layar yang bisa membacanya kembali, dan nilainya tidak pernah masuk catatan audit — yang tercatat cuma peristiwanya.",
  "ta2.tokenSudahAda": "Token {{provider}} sudah ada dan dipakai bersama oleh seluruh platform penyedia ini — jadi tidak ditanyakan lagi. Menggantinya adalah rotasi, dan itu tindakan tersendiri di panel Kredensial.",
  "ta2.terkunci": "{{platform}} belum punya adapter, jadi mendaftarkan akunnya sekarang cuma melahirkan baris yang tidak melakukan apa pun — DM tidak akan diproses dan kegagalannya baru muncul saat pesan pertama datang. Urutan penambahan yang ditetapkan: Facebook Page → LinkedIn → TikTok.",
  "ta2.sambungkan": "Sambungkan",
  "sesi.rusakJudul": "Sesi tidak bisa dipercaya",
  "sesi.rusakKeterangan": "Peran pada sesi ini tidak dikenali ({{peran}}), jadi tidak ada dashboard yang bisa ditampilkan tanpa menebak — dan menebak berarti menampilkan data klien yang salah. Keluar lalu masuk lagi memperbaikinya.",
  "sesi.tanpaPeran": "kosong",
  "sesi.keluarMasuk": "Keluar dan masuk lagi",
  "ta.grupKerja": "Kerja",
  "ta.grupBot": "Pengaturan bot",
  "ta.grupPerusahaan": "Perusahaan",
  "ta.navBeranda": "Beranda",
  "ta.navChatbot": "Chatbot",
  "ta.navMeeting": "Meeting",
  "ta.navPengetahuan": "Pengetahuan",
  "ta.navSambungan": "Sambungan",
  "ta.navTim": "Tim",
  "ta.navPemakaian": "Pemakaian",
  "ta.tabFitur": "Fitur",
  "ta.tabPersona": "Persona & kebijakan",
  "ta.tabDataProspek": "Data prospek",
  "ta.tabJadwalBalas": "Jadwal balas",
  "ta.tabModel": "Model",
  "ta.tabJadwalMeeting": "Jam & hari",
  "ta.tabLibur": "Tanggal libur",
  "ta.personaBelum": "Persona dan kebijakan bot masih ditulis di kode (app/ai/prompts/percakapan.py) dan belum bisa diubah dari sini. Ditampilkan supaya jelas ia direncanakan, bukan hilang — mengubahnya sekarang menuntut deploy.",
  "ta.jadwal.chatbot": "Kapan bot membalas",
  "ta.jadwal.meeting": "Kapan meeting boleh ditawarkan",
  "ta.jadwal.content": "Jadwal konten",
  "ta.jadwalCatatan.chatbot": "Di luar jam ini bot DIAM. Pesannya tetap masuk antrean dan tetap terlihat tim.",
  "ta.jadwalCatatan.meeting": "Hanya hari dan jam ini yang ditawarkan bot saat menjadwalkan.",
  "ta.jadwalCatatan.content": "Kapan rantai konten boleh berjalan.",
  "ta.jadwalMode": "Mode",
  "ta.modeAlways": "Selalu — tidak dibatasi",
  "ta.modeWeekly": "Terjadwal per minggu",
  "ta.jadwalHari": "Hari",
  "ta.jadwalMulai": "Mulai",
  "ta.jadwalSelesai": "Selesai",
  "ta.hariKosong": "Tidak ada hari yang dipilih — artinya TIDAK PERNAH menyala, bukan kembali ke bawaan.",
  "ta.liburJudul": "Tanggal libur sekali jalan",
  "ta.tambahLibur": "Tambah",
  "ta.hapus": "Hapus",
  "ta.kolTanggal": "Tanggal",
  "ta.kolKeterangan": "Keterangan",
  "ta.liburKosong": "Belum ada hari libur.",
  "ta.liburKosongKet": "Tanpa ini, bot menawarkan hari libur nasional seperti hari kerja biasa.",
  "ta.pengJudul": "Dokumen pengetahuan",
  "ta.pengCatatan": "Bahan yang dipakai bot menjawab. Isinya tidak ditampilkan.",
  "ta.pengKosong": "Belum ada dokumen.",
  "ta.pengKosongKet": "Bot akan menjawab tanpa bahan — dan ia tetap menjawab, dengan percaya diri.",
  "ta.pengRingkas": "{{aktif}} aktif dari {{total}} dokumen.",
  "ta.pengUnggahBelum": "Mengunggah dokumen dari layar ini belum ada — pemuatan masih lewat berkas. Ditampilkan supaya jelas ia direncanakan, bukan hilang.",
  "ta.kolDokumen": "Dokumen",
  "ta.kolVersi": "Versi",
  "ta.kolPanjang": "Panjang",
  "ta.berandaJudul": "Yang menunggu Anda",
  "ta.berandaCatatan": "Daftar tugas, bukan angka. Yang sudah beres tidak didaftar.",
  "ta.tidakAdaTugas": "Tidak ada yang tertahan.",
  "ta.tidakAdaTugasKet": "Bot berjalan dengan pengaturan yang sudah Anda tetapkan.",
  "ta.tugasPengetahuan": "Belum ada dokumen pengetahuan",
  "ta.tugasPengetahuanKet": "Bot menjawab tanpa bahan — dan ia tetap menjawab. Muat dokumennya lebih dulu.",
  "ta.tugasFitur": "{{n}} fitur sedang mati",
  "ta.tugasJadwal": "Belum ada jadwal yang diatur",
  "ta.tugasJadwalKet": "Bot menjawab dan menawarkan meeting kapan saja, termasuk tengah malam.",
  "ta.timJudul": "Tim",
  "ta.timCatatan": "Orang yang bisa masuk, perannya, dan penautan Telegram.",
  "ta.timKosong": "Belum ada orang.",
  "ta.belumTertaut": "belum tertaut",
  "ta.kolNama": "Nama",
  "ta.kolPeran": "Peran",
  "ta.kolTelegram": "Telegram",
  "ta.sambunganJudul": "Sambungan",
  "ta.sambunganCatatan": "Akun platform tenant ini.",
  "ta.sambunganBelum": "Menghubungkan akun sendiri dari sini belum tersedia. Rancangannya: Anda login dengan akun Meta sendiri, supaya kredensialnya tidak pernah lewat tangan kami.",
  "ta.sambunganSementara": "Untuk sekarang, penyambungan dikerjakan operator Smova dari konsolnya. Hubungi kami dengan ID akun Instagram Anda.",
  "ta.pemakaianJudul": "Pemakaian",
  "ta.pemakaianKeterangan": "Berapa yang terpakai bulan ini. Batasnya ditetapkan Smova.",
  "ta.biayaBatasBawah": "{{n}} panggilan belum punya tarif di katalog, jadi angka biaya di atas BATAS BAWAH — bukan total.",
  "konten.bahan": "Bahan",
  "konten.buatKonten": "Buat konten",
  "bh.judul": "Bahan dari scraping",
  "bh.catatan": "Kenapa konten otomatis memilih berita tertentu — jawabannya di kolom alasan.",
  "bh.cariSekarang": "Cari bahan sekarang",
  "bh.mencari": "Mencari…",
  "bh.kolJudul": "Judul",
  "bh.kolKataKunci": "Kata kunci",
  "bh.kolSkor": "Skor",
  "bh.kolAlasan": "Kenapa nilainya segitu",
  "bh.kolWaktu": "Diambil",
  "bh.kosong": "Belum ada bahan.",
  "bh.kosongKet": "Scraping berjalan sesuai jadwal, atau tekan Cari bahan sekarang. Kalau tetap kosong sesudah itu, kunci sumbernya belum terisi.",
  "bh.kaki": "Skor rendah tidak dibuang, hanya dipudarkan — barisnya tetap bisa Anda pakai. Penilaian mesin bagus untuk memilih rata-rata; Anda yang tahu satu berita bernilai rendah kebetulan menyangkut calon klien besar minggu ini. Nama situs di judul adalah penerbit artikelnya, bukan sumber pencarian.",
  "bk.judulInternal": "Judul internal",
  "bk.judulCatatan": "Untuk Anda dan tim — tidak ikut terbit.",
  "bk.jenis": "Jenis",
  "bk.foto": "Foto",
  "bk.video": "Video",
  "bk.caption": "Caption",
  "bk.pesanKunci": "Pesan kunci",
  "bk.hashtag": "Hashtag",
  "bk.promptGambar": "Prompt gambar",
  "bk.simpan": "Simpan & jadwalkan",
  "bk.tersimpan": "\"{{judul}}\" masuk jadwal di {{n}} tujuan. Tidak menunggu tinjauan konsep — Anda yang menulisnya.",
  "bk.grupIsi": "Isi konten",
  "bk.grupGambar": "Gambar",
  "bk.grupKapan": "Kapan & ke mana",
  "bk.dariJudul": "Buatkan dari judul",
  "bk.buatkan": "Buatkan",
  "bk.dariCaption": "Buatkan dari caption",
  "bk.templateLabel": "Jenis gambar",
  "bk.templateBawaan": "Bawaan perusahaan (diatur admin)",
  "bk.templateOpsiFoto": "{{nama}} — Foto, tanpa tulisan di gambar",
  "bk.templateOpsiPoster": "{{nama}} — Poster, dengan headline & CTA di gambar",
  "bk.templateKet": "Menentukan gaya prompt yang dibuat AI. “Foto” = gambar polos, teksnya di caption. “Poster” = headline, subheadline, dan tombol CTA digambar di dalam gambarnya. Jenisnya diatur admin di Atur konten › Template prompt.",
  "bk.dikirimJudul": "Lihat yang dikirim ke AI ({{gambar}} gambar dilampirkan)",
  "bk.bagianBahan": "Bahan gambar",
  "bk.bagianBrief": "Brief untuk AI",
  "bk.bagianModel": "Model & rasio",
  "bk.bagianSlide": "Gambar per slide",
  "bk.bagianModelKet": "Berlaku untuk semua slide — collase yang tiap slidenya beda model tidak terlihat satu kesatuan.",
  "bk.briefLabel": "Brief untuk AI",
  "bk.briefContoh": "mis. Pakai template ini sebagai latar, logo jangan digambar ulang. Headline besar + tombol CTA di ruang kosong tengah.",
  "bk.briefKet": "Arahanmu untuk AI penulis prompt — ini yang paling menentukan hasilnya. Boleh dikosongkan; AI akan memakai caption dan gambar yang kamu pilih saja.",
  "bk.briefHitung": "{{jumlah}} / {{maks}} kata",
  "bk.briefLebih": "Kurangi brief sebelum membuat prompt.",
  "bk.promptSemuaSlide": "Buatkan prompt semua slide",
  "bk.promptSedang": "Menulis prompt…",
  "bk.bahanDiabaikan": "Gambar yang kamu pilih TIDAK dilihat AI: model teks yang dipakai tenant ini tidak menerima gambar masukan. Promptnya ditulis dari caption dan brief saja. Minta admin memilih model teks yang menerima gambar.",
  "bk.timpaCaption": "Caption yang sudah kamu sunting akan ditimpa pilihan ini. Lanjutkan?",
  "bk.sudut.masalah": "Mulai dari masalah",
  "bk.sudut.angka": "Mulai dari angka",
  "bk.sudut.cerita": "Mulai dari cerita orang",
  "bk.promptDariCaption": "Buatkan prompt dari caption",
  "bk.promptMasihMelanggar": "Prompt sudah dibuat, tapi masih melanggar aturan berikut. Perbaiki dulu sebelum membuat gambar — atau buat ulang promptnya.",
  "bk.promptCaption": "Tulis satu caption Instagram bahasa Indonesia untuk konten berjudul \"{{judul}}\". Maksimal 3 kalimat, tanpa hashtag, tanpa emoji berlebihan. Balas HANYA captionnya.",
  "bk.promptPesan": "Dari caption ini, tulis SATU kalimat pesan kunci yang paling penting diingat pembaca. Balas hanya kalimatnya.\n\n{{caption}}",
  "bk.promptHashtag": "Dari caption ini, buat 3-5 hashtag Indonesia yang relevan. Balas hanya hashtagnya dipisah spasi, diawali #.\n\n{{caption}}",
  "bk.promptPrompt": "Dari caption ini, tulis satu prompt gambar bahasa Inggris untuk ilustrasi pendukung. Tanpa teks di dalam gambar. Balas hanya promptnya.\n\n{{caption}}",
  "bk.model": "Model",
  "bk.modelBawaan": "Pakai bawaan tenant",
  "bk.modelBawaanCatatan": "Urut pilihan admin; yang berikutnya dipakai bila gagal",
  "bk.modelTanpaTarif": "tarif belum diketahui",
  "bk.modelCatatan": "Hanya dari yang disediakan admin perusahaan Anda. Yang lebih mahal belum tentu lebih cocok — untuk gaya brand yang konsisten, model yang sama dipakai berulang biasanya lebih baik.",
  "bk.buatGambar": "Buat gambar sekarang",
  "bk.membuatGambar": "Membuat gambar…",
  "bk.gambarSiap": "Gambar siap — ikut tersimpan saat Anda menjadwalkan.",
  "bk.tanggalJam": "Tanggal & jam",
  "bk.tanggalCatatan": "Kosongkan untuk memakai slot terbit terdekat berikutnya.",
  "bk.tujuan": "Tujuan",
  "bk.igFeed": "Instagram Feed",
  "bk.igReels": "Instagram Reels",
  "bk.fbPage": "Facebook Page",
  "bk.tujuanCatatan": "Satu konten, beberapa tujuan — caption dan gambarnya sama. Yang dibuat satu baris antrean per tujuan, karena tiap platform bisa gagal sendiri-sendiri.",
  "bk.simpanDraf": "Simpan sebagai draf",
  "bk.alurCatatan": "muncul di \"Akan tayang\", terbit sendiri pada jamnya",
  "bk.tersimpanDraf": "\"{{judul}}\" tersimpan sebagai draf di {{n}} tujuan. Ia tidak masuk jadwal dan tidak akan terbit.",
  "bk.spanduk": "Konten buatan Anda langsung masuk jadwal, tanpa antre tinjauan",
  "bk.spandukIsi": "Anda yang membuatnya, jadi Anda sudah meninjaunya saat menekan simpan. Gerbang tinjauan ada untuk konten otomatis — yang tidak ada manusianya saat dibuat. Menambahkan gerbang di sini cuma menghasilkan baris antrean yang menunggu persetujuan orang yang baru saja menulisnya.",
  "bk.spandukModel": "Model bisa Anda pilih per konten, tapi hanya dari yang disediakan admin perusahaan Anda. Yang lebih mahal belum tentu lebih cocok — untuk gaya brand yang konsisten, model yang sama dipakai berulang biasanya lebih baik daripada yang terbaik.",
  "bk.tigaPilihan": "Buat 3 pilihan",
  "bk.pilihSatu": "Pilih satu — caption, pesan kunci, dan hashtag ikut berganti",
  "bk.promptTiga": "Tulis 3 pilihan caption Instagram bahasa Indonesia untuk konten berjudul \"{{judul}}\". Tiap caption paling banyak 3 kalimat, tanpa hashtag, emoji seperlunya. Balas HANYA sebagai daftar bernomor 1. 2. 3. — satu caption per baris, tanpa penjelasan apa pun.",
  "bk.hargaSetelah": "biaya tampil setelah dibuat",
  "bk.modelTeksKosong": "Admin perusahaan Anda belum memilih model teks. Tombol buatkan tetap jalan memakai rantai bawaan.",
  "bk.modelKosong": "Admin perusahaan Anda belum memilih model untuk jenis konten ini, jadi belum ada yang bisa dipilih per konten. Sistem memakai rantai bawaan.",
  "bk.grupVideo": "Video",
  "bk.buatVideo": "Buat video sekarang",
  "bk.hasil": "Hasil",
  "bk.hasilKosong": "Belum ada gambar. Konten tetap bisa disimpan tanpa gambar, tapi tidak akan terbit sampai ada — penerbit menolak baris yang media_url-nya kosong.",
  "bk.alurJudul": "Simpan & jadwalkan:",
  "bk.stBaru": "baru",
  "bk.alurDraf": "\"Simpan sebagai draf\" tidak masuk jadwal sama sekali dan tidak akan terbit.",
  "bk.belumJudul": "Tiga bagian rancangan belum punya tempat",
  "bk.belumIsi": "Caption, pesan kunci, jenis, jadwal, dan tujuan sudah punya kolomnya di content_queue. Referensi gambar beda jenis: ia masukan, bukan keluaran — butuh penyimpanan berkas dan tabelnya sendiri. Collase butuh dua hal: tempat menyimpan urutan editorialnya, dan jalur terbit carousel — hari ini ig_publish() menerima satu URL saja. Harga per model sebelum memilih juga belum tampil, karena daftar model sengaja tidak membawa tarif; biaya baru terlihat sesudah gambar dibuat.",
  "ta.chatbotJudul": "Chatbot",
  "ta.chatbotKeterangan": "Bagaimana bot berperilaku: apa yang hidup, apa yang ia kumpulkan, kapan ia membalas, dan model apa yang menulis balasannya.",
  "ta.personaJudul": "Persona & kebijakan belum bisa diubah dari sini",
  "ta.meetingKeterangan": "Kapan bot boleh menawarkan meeting, dan tanggal yang tidak boleh ditawarkan sama sekali.",
  "ta.timHitung": "{{n}} orang",
  "ta.akunMedsos": "Akun media sosial",
  "tk.tabBahan": "Cari bahan",
  "tk.tabSlot": "Jadwal terbit",
  "tk.tabGerbang": "Otomatis",
  "tk.tabModel": "Model",
  "tk.slotJudul": "Slot terbit",
  "tk.slotCatatan": "{{n}} konten per hari",
  "tk.slotKosong": "Belum ada slot. Tanpa slot, rantai konten otomatis tidak menghasilkan apa pun.",
  "tk.slotTambah": "+ Tambah slot",
  "tk.slotSimpanCatatan": "Jumlah konten per hari mengikuti banyaknya slot — tidak diisi terpisah.",
  "tk.modelBiayaJudul": "Model gambar paling terasa di biaya, model caption paling terasa di mutu",
  "tk.modelBiayaIsi": "Satu gambar berkali lipat lebih mahal daripada satu caption, jadi mengganti model gambar mengubah pagu bulanan Anda jauh lebih cepat. Sebaliknya, caption yang buruk terbaca oleh pelanggan Anda — bukan oleh tagihan.",
  "meeting.klikUntukBlokir": "klik tanggal untuk memblokir",
  "meeting.blokirSaya": "Saya blokir",
  "meeting.blokirTim": "Diblokir rekan",
  "meeting.adaMeeting": "Ada meeting",
  "meeting.alasanCatatan": "Dipakai untuk blokir berikutnya yang Anda buat. Boleh dikosongkan.",
  "meeting.diblokirHitung": "{{n}} tanggal saya blokir",
  "meeting.bukaBlokir": "Buka blokir",
  "meeting.blokirKosongKet": "Selama kosong, bot boleh menawarkan hari kerja mana pun kepada prospek.",
  "meeting.bentrokJudul": "{{tanggal}} Anda blokir, tapi ada meeting di tanggal itu",
  "meeting.bentrokIsi": "Meeting itu sudah disepakati sebelum blokir ini dibuat. Memblokir tanggal tidak membatalkan meeting yang sudah ada — ia hanya menghentikan tawaran baru. Pindahkan meetingnya atau buka blokirnya.",
  "meeting.hariKerjaJudul": "Akhir pekan tidak dimatikan di sini",
  "meeting.hariKerjaIsi": "Hari kerja ditentukan jadwal fitur meeting yang diatur admin perusahaan Anda, dan layar ini belum boleh membacanya. Jadi semua tanggal bisa ditekan — memblokir hari yang memang bukan hari kerja tidak merusak apa pun, hanya mubazir.",
  "meeting.kosongKet": "Meeting dibuat dari halaman prospeknya — di situlah konteksnya ada.",
  "bk.referensi": "Referensi gambar",
  "bk.refTambah": "+ Tambah",
  "bk.refMengunggah": "Mengunggah…",
  "bk.refBuang": "Pensiunkan referensi ini",
  "bk.refUrutan": "Urutan referensi",
  "bk.refUrutanKe": "Referensi ke-{{n}}",
  "bk.refNaikkan": "Naikkan urutannya",
  "bk.refTurunkan": "Turunkan urutannya",
  "bk.refHilang": "(referensi tidak ada lagi)",
  "bk.refBrand": "B",
  "bk.refBrandKet": "Bahan brand — tampil paling atas dan tidak ikut tenggelam",
  "bk.refJadikanBrand": "Tandai sebagai bahan brand (logo, produk, palet)",
  "bk.refJadikanSekali": "Kembalikan jadi bahan sekali pakai",
  "bk.refUrutanCatatan": "Urutannya berarti: gambar 1 dibaca model lebih dulu. Ubah dengan tombol ↑ ↓.",
  "bk.refCatatan": "Klik untuk memakainya. Urutan klik menentukan urutan yang dibaca AI — maksimal 4 bahan.",
  "bk.refBawaanTakBisa": "Tidak satu pun model gambar yang dipilih admin menerima referensi. Minta admin menambahkan salah satu model yang bisa, atau lepaskan referensinya.",
  "bk.refModelSalah": "Referensi terpilih, tapi model gambarnya tidak menerima gambar masukan. Pilih {{model}}, atau lepaskan referensinya — kalau tidak, pembuatan gambar akan ditolak.",
  "sb.spanduk": "Menghubungkan akun dilakukan bersama tenant, bukan diam-diam oleh kita",
  "sb.spandukIsi": "Yang tetap milik kita: social_accounts.external_account_id unik global dan menentukan webhook Meta masuk ke tenant mana. Salah sambung di sana merusak routing tenant lain — jadi kita harus selalu bisa melihat, menguji, dan mencabutnya.",
  "sb.uji": "Uji koneksi",
  "sb.kredJudul": "Kredensial",
  "sb.kredCatatan": "tenant_credentials · pgcrypto",
  "sb.kredKosong": "Belum ada kredensial",
  "sb.kredKosongKet": "Selama kosong, tidak ada platform yang bisa dihubungi atas nama tenant ini.",
  "sb.kredKaki": "Nilainya tidak ditampilkan, bahkan tersamar. Ia terenkripsi pgcrypto dan Python memang tidak bisa membacanya — layar ini mengikuti batas itu, bukan melawannya. Yang berstatus rotated sengaja ikut tampil: token yang diganti tidak hilang, ia berhenti dipakai.",
  "sb.kolPenyedia": "Penyedia",
  "sb.kolDiisi": "Diisi",
  "sb.kolKedaluwarsa": "Kedaluwarsa",
  "ta.luarJamJudul": "Di luar jam itu, bot melakukan apa?",
  "ta.luarJamTakBerlaku": "Jadwalnya sedang “Selalu”, jadi tidak ada di luar jam — setelan di bawah tidak berlaku sekarang dan tidak akan pernah terkirim. Nilainya tetap tersimpan, dan berlaku lagi begitu jadwalnya diubah ke Mingguan.",
  "ta.luarJamDiam": "Diam saja",
  "ta.luarJamBalas": "Balas singkat",
  "ta.luarJamTeks": "Teks balasannya",
  "ta.luarJamCatatan": "Ini pilihan yang paling sering dilewatkan, dan paling terasa akibatnya. \"Diam saja\" berarti orang mengirim DM jam 9 malam dan tidak mendapat apa-apa — dari sisi mereka, itu tidak bisa dibedakan dari diabaikan. Percakapan tetap masuk ke antrean tim apa pun pilihannya; yang berbeda hanya apakah pengirimnya tahu pesannya sampai.",
  "ta.luarJamBawaan": "Yang tampil sekarang teks bawaan Smova. Menyimpan akan membuat salinan milik perusahaan Anda — bawaannya tidak ikut berubah untuk klien lain.",
  "pk.keMana": "Ke mana perginya",
  "pk.keManaCatatan": "per kegiatan, bukan per model",
  "pk.kolKegiatan": "Kegiatan",
  "pk.tanpaTarif": "{{n}} panggilan tarifnya belum diketahui",
  "sb.gantiToken": "Ganti token",
  "sb.gantiJudul": "Mengganti token {{provider}}",
  "sb.gantiPeringatan": "Token lama ditandai 'rotated' dan berhenti dipakai saat itu juga — ia tidak dihapus, jadi tetap ada jejak kapan ia berhenti. Kalau token baru ini salah, sambungannya mati sampai Anda menggantinya lagi. Penyedia lain tidak tersentuh.",
  "sb.tokenBaru": "Token baru",
  "sb.panjangToken": "{{n}} karakter — token Halaman Facebook biasanya 190–250, Instagram sekitar 185",
  "sb.kedaluwarsaOpsional": "Kedaluwarsa (opsional)",
  "sb.kedaluwarsaCatatan": "Isi kalau tokennya berbatas waktu. Kosongkan kalau debug_token menjawab 'Never'. Yang diisi bisa diperingatkan sebelum mati, yang kosong tidak.",
  "sb.simpanToken": "Simpan token",
  "ta.akunMedsosCatatan": "{{n}} tersambung",
  "ta.kolTerbit": "Terbitkan",
  "ta.sambunganSiapa": "Menambah dan mencabut akun dikerjakan operator Smova. ID akun bersifat unik secara global dan menentukan pesan Meta masuk ke tenant mana — salah sambung di sana merusak tenant lain, jadi tombolnya sengaja tidak ada di sini.",
  "ta.grupCatatanTenant": "tujuan notifikasi tim Anda",
  "ta.grupKosongTenant": "Tanpa grup, notifikasi jatuh ke grup bawaan Smova — tim Anda tidak akan menerimanya. Minta operator Smova mendaftarkan grup Anda.",
  "ta.sambunganRencanaJudul": "Nanti Anda menghubungkannya sendiri",
  "ta.sambunganRencana": "Rencananya satu aplikasi Meta atas nama Seleris, dan Anda melakukan OAuth dari layar ini dengan akun Meta Anda sendiri — supaya kredensialnya tidak pernah lewat tangan kami. Alur itu belum dibangun; sampai ia ada, penyambungan dikerjakan operator dan tokennya memang lewat tangan kami.",
  "ta.identitasJudul": "Identitas bot",
  "ta.namaBot": "Nama bot",
  "ta.namaBotCatatan": "Nama yang ia sebut saat memperkenalkan diri.",
  "ta.atasNama": "Atas nama",
  "ta.atasNamaCatatan": "Perusahaan yang ia wakili. Ini yang dibaca pelanggan Anda.",
  "ta.bidang": "Bidang",
  "ta.bidangCatatan": "Satu kalimat: apa yang perusahaan Anda kerjakan. Dipakai bot saat menjelaskan diri.",
  "ta.emailRujukan": "Email rujukan",
  "ta.emailRujukanCatatan": "Kalau diisi, bot dilarang menyebut alamat email lain. Kosongkan kalau tidak ada.",
  "ta.gayaBahasa": "Gaya bahasa",
  "ta.gayaFormal": "Formal",
  "ta.gayaRamah": "Ramah",
  "ta.gayaSantai": "Santai",
  "ta.kebijakanJudul": "Kebijakan bisnis",
  "ta.melayani": "Melayani",
  "ta.b2b": "B2B saja",
  "ta.b2c": "B2C saja",
  "ta.keduanya": "Keduanya",
  "ta.melayaniCatatan": "Menentukan bagaimana bot menjawab penanya yang di luar sasaran Anda.",
  "ta.demoTrial": "Demo / trial",
  "ta.demoMeeting": "Hanya saat meeting",
  "ta.demoMandiri": "Boleh mandiri",
  "ta.catatanKhusus": "Catatan khusus",
  "ta.catatanKhususCatatan": "Aturan tambahan yang harus bot patuhi. Ditambahkan di ujung instruksi, di atas semua tahap percakapan.",
  "ta.personaBerlaku": "Berlaku pada balasan berikutnya — tidak ada cache.",
  "ta.pratinjauJudul": "Yang benar-benar dibaca bot",
  "ta.pratinjauCatatan": "dirakit backend, bukan tiruan",
  "ta.pratinjauLama": "Ini nilai yang tersimpan sekarang. Simpan dulu untuk melihat akibat perubahan Anda.",
  "ta.pagarJudul": "Pagar keselamatan",
  "ta.pagarIsi": "Bot selalu mengaku sebagai asisten virtual kalau ditanya, dan dilarang mengaku manusia walau pelanggan mendesak. Aturan itu tertanam di kode dan sengaja tidak disediakan sebagai pilihan — bot yang boleh berbohong tentang dirinya sendiri adalah risiko yang tidak seharusnya bisa dinyalakan dari layar.",
  "ta.tabSyarat": "Syarat & format",
  "ta.syaratJudul": "Sebelum bot menawarkan meeting",
  "ta.dataLengkap": "Data harus lengkap",
  "ta.dataLengkapCatatan": "Bot tidak menawarkan meeting sebelum field ini terisi. Kosongkan semua kalau tidak ada syarat. Daftarnya mengikuti Field Profil — field yang Anda nonaktifkan hilang dari sini sendirinya.",
  "ta.tidakAdaField": "Belum ada field profil aktif. Atur dulu di tab Data prospek.",
  "ta.minatMinimal": "Minat minimal",
  "ta.minatCatatan": "Skala 1–5. Makin tinggi, makin jarang bot menawarkan meeting — tapi yang ditawarkan lebih matang.",
  "ta.jedaHari": "Jarak paling cepat",
  "ta.jedaCatatan": "Berapa hari ke depan paling cepat boleh ditawarkan. 0 berarti hari ini juga.",
  "ta.durasi": "Durasi",
  "ta.bentukJudul": "Bentuk pertemuan",
  "ta.format": "Format",
  "ta.onlineSaja": "Online saja",
  "ta.offlineSaja": "Offline saja",
  "ta.lokasiOffline": "Lokasi offline",
  "ta.lokasiCatatan": "Alamat yang bot sebut saat menawarkan tatap muka.",
  "ta.lokasiWajib": "Bentuk yang memuat tatap muka menuntut lokasi — tanpa itu bot menawarkan pertemuan tanpa punya tempat untuk disebut.",
  "tk.tiapJam": "tiap {{n}} jam",
  "tk.mulaiJam": "mulai jam",
  "tk.cronAsing": "Jadwal ini ditulis di luar layar ini dan bentuknya tidak dikenali. Ia tetap berjalan apa adanya — layar ini tidak mengubahnya diam-diam. Tekan tombol di bawah kalau Anda mau menggantinya dengan jadwal biasa.",
  "tk.pakaiJadwalBiasa": "Ganti dengan jadwal biasa",
  "umum.tidakCocok": "Tidak ada yang cocok",
  "bh.cariPlaceholder": "Cari judul, kata kunci, atau alasan…",
  "bh.tidakCocok": "Tidak ada bahan yang cocok",
  "bh.buatDariIni": "Buat konten",
  "bk.dariBahan": "Dibuat dari bahan: {{judul}}",
  "bk.dariBahanIsi": "Judulnya sudah diisi sebagai judul internal, dan prompt gambar disiapkan dari alasan mesin memilihnya: {{alasan}}. Caption sengaja dibiarkan kosong — judul berita adalah ringkasan redaksi, bukan kalimat yang menyapa pembaca. Tekan \"Buatkan dari judul\" untuk menulisnya.",
  "bk.collaseAktif": "collase · {{n}} slide",
  "bk.collaseBiaya": "Tiap slide ditagih terpisah — collase {{n}} slide berbiaya {{n}} kali satu gambar. Gambar juga yang paling dulu dihentikan saat pagu belanja tersentuh.",
  "bk.slideKosong": "belum ada gambar",
  "bk.slidePertama": "terlihat di feed",
  "bk.slidePrompt": "Apa yang harus digambar untuk slide ini?",
  "bk.tambahSlide": "+ Tambah slide",
  "bk.slideRingkas": "{{jadi}} dari {{total}} slide sudah ada gambarnya",
  "bk.slideMaks": "Maksimal {{n}} slide — itu batas Instagram, bukan batas kami.",
  "bk.buatUlang": "Buat ulang",
  "bk.ubahGambar": "Ubah",
  "bk.ubahApa": "Apa yang mau diubah? Contoh: ganti latarnya jadi biru tua",
  "bk.ubahKet": "Yang dikirim hanya gambar yang terpilih + kalimat ini. Referensi brand dan prompt di atas TIDAK ikut — kalau ikut, hasilnya tercampur dan teks di gambar bisa berubah.",
  "bk.ubahTakBisa": "Gambar ini dimuat dari konten lama, jadi belum bisa diubah. Buat ulang atau unggah lagi supaya bisa.",
  "bk.hasilDeret": "Yang akan diubah",
  "bk.hasilKe": "Hasil ke-{{n}}",
  "bk.hasilKet": "Kotak bergaris tebal itu yang dipakai tombol Ubah. Tiap hasil baru masuk ke sini — klik untuk kembali ke salah satunya kalau teksnya mulai memudar.",
  "sb.tukarJudul": "Tukar token Meta jadi panjang-umur",
  "sb.tukarCatatan": "sekali, lalu tidak mati lagi",
  "sb.tukarIsi": "Tempel token PENGGUNA dari Graph API Explorer — bukan token Halaman. Kami yang menukarnya jadi panjang-umur di server (penukaran menuntut app secret, dan itu tidak boleh lewat peramban), lalu mengambil token Halamannya lewat Page ID yang sudah terdaftar. Halaman milik Business Portfolio tidak muncul di /me/accounts, jadi jalur ini yang dipakai — bukan daftar halaman.",
  "sb.tokenPengguna": "Token pengguna",
  "sb.pageIdOpsional": "Page ID (opsional)",
  "sb.pageIdCatatan": "Kosongkan — kami memakai Page ID yang sudah terdaftar untuk tenant ini. Isi hanya kalau Halamannya berbeda dari yang terdaftar.",
  "sb.tukarSekarang": "Tukar & simpan",
  "sb.menukar": "Menukar…",
  "sb.tukarBerhasil": "Tersimpan — Halaman {{nama}}",
  "sb.tukarAbadi": "Token Halamannya tidak berbatas waktu. Ia akan berhenti hanya kalau Anda mencabut izin aplikasi di Setelan Facebook.",
  "sb.tukarMasihBerbatas": "Token Halamannya MASIH berbatas waktu: {{tanggal}}. Ia akan mati pada waktu itu dan sambungan Facebook berhenti tanpa peringatan.",
  "sb.tukarSebabnya": "Sebabnya di langkah penukaran: token pengguna hasil tukar juga berbatas ({{tanggal}}), padahal seharusnya panjang-umur. Biasanya karena token yang ditempel sudah pernah ditukar sebelumnya — ambil token yang benar-benar baru dari Graph API Explorer, jangan token yang sudah dipakai.",
  "bk.refTerlaluBesar": "Berkas itu {{ukuran}} MB — batasnya {{maks}} MB. Kecilkan dulu. Referensi ikut dikirim ke model tiap kali gambar dibuat, jadi yang besar menagih biaya berulang.",
  "bk.refDikecilkan": "Gambarnya dikecilkan sebelum diunggah: {{lebar}}×{{tinggi}} → {{lebarBaru}}×{{tinggiBaru}}, {{dari}} MB → {{jadi}} KB. Referensi ikut dikirim ke model tiap kali gambar dibuat, jadi yang besar menagih biaya berulang — dan model mengecilkannya sendiri di dalam.",
  "ta.timBelumTertaut": "{{n}} orang belum menautkan Telegram — tombol di grup akan menolak mereka. Notifikasinya tetap terbaca; yang berhenti bekerja tombolnya.",
  "ta.timSiapa": "ditambahkan oleh Smova, ditautkan oleh Anda",
  "ta.saringSemua": "Semua",
  "ta.saringBelum": "Belum tertaut",
  "ta.saringSudah": "Sudah tertaut",
  "ta.kolKode": "Kode /join",
  "ta.terbitkanKode": "Terbitkan kode",
  "ta.kodeBaru": "berlaku sampai {{sampai}}",
  "ta.kodeLama": "kode yang sudah ada · berlaku sampai {{sampai}}",
  "ta.kodeSatuOrangJudul": "Kodenya milik SATU orang, dan sekali pakai",
  "ta.kodeSatuOrangIsi": "Bukan satu kode bersama untuk seluruh tim — kode bersama berarti siapa pun yang melihatnya bisa menautkan dirinya sebagai anggota tim Anda. Berikan kodenya ke orangnya, lalu ia mengetik /join KODE sekali di grup Telegram. Tenant ditentukan dari grup tempat ia mengetik, bukan dari kodenya; kode cuma mencocokkan.",
  "pk.bulanIni": "Bulan ini",
  "pk.hariTersisa": "{{n}} hari tersisa",
  "pk.dariPagu": "dari {{pagu}}",
  "pk.persenTerpakai": "{{n}}% terpakai",
  "pk.tanpaPagu": "Tanpa pagu",
  "pk.tanpaPaguCatatan": "Tenant ini belum diberi pagu belanja, jadi tidak ada yang menghentikannya. Hubungi Smova kalau ingin dipasangi batas.",
  "pk.ambangCatatan": "Anda diberi tahu saat menyentuh {{n}}%. Pagunya tidak bisa dinaikkan sendiri — hubungi Smova kalau butuh lebih.",
  "pk.dihentikan": "Sudah dihentikan sekarang: {{daftar}}",
  "pk.urutanJudul": "Kalau pagu tersentuh, yang berhenti berurutan",
  "pk.urutanIsi": "Gambar & video berhenti lebih dulu, lalu penyusunan konten, dan balasan chat ke pelanggan paling akhir — karena tidak ada yang menunggu di seberang saat pekerjaan terjadwal berhenti, sementara chatbot menghadap pelanggan klien Anda.",
  "ta.tabKetersediaan": "Ketersediaan tim",
  "ta.rosterJudul": "Siapa yang bisa ditugaskan",
  "ta.rosterCatatan": "tiap orang menandai tanggalnya sendiri",
  "ta.rosterKosong": "Belum ada anggota tim",
  "ta.rosterKosongKet": "Orang ditambahkan oleh Smova. Hubungi kami untuk menambah anggota tim.",
  "ta.rosterNolBisa": "Tidak satu pun anggota tim boleh ditugaskan — bot berhenti menawarkan meeting sama sekali, tanpa galat apa pun. Nyalakan setidaknya satu orang.",
  "ta.kolBolehDitugaskan": "Boleh ditugaskan",
  "ta.kolDiblokir": "Tanggal diblokir",
  "ta.kolMeetingBulanIni": "Meeting bulan ini",
  "ta.nHari": "{{n}} hari",
  "ta.rosterSatuSumberJudul": "Bot menawarkan tanggal yang benar-benar kosong",
  "ta.rosterSatuSumberIsi": "Ketersediaan diambil dari tanggal yang ditandai tiap anggota tim, dikurangi hari libur, dikurangi meeting yang sudah ada. Satu sumber perhitungan untuk semuanya — tidak ada fitur yang menghitung sendiri.",
  "ta.jedaMenit": "Jeda antar meeting",
  "ta.jedaMenitCatatan": "Napas di antara dua pertemuan pada hari yang sama. Nol berarti bot boleh menawarkan dua meeting yang menempel persis.",
  "umum.ya": "Ya",
  "umum.tidak": "Tidak",
  "umum.tarifTidakDiketahui": "tarif belum diketahui",
  "umum.tarifTidakDiketahuiKet": "Pemakaian model ini tidak dihitung pagu belanja — biayanya muncul sebagai batas bawah (≥) di layar Pemakaian.",
  "ta.kolPlatform": "Platform",
  "ta.kolAkun": "Akun",
  "ta.kolTerakhirTerima": "Terakhir menerima",
  "ta.kolBalasDm": "Balas DM",
  "ta.kolBalasKomentar": "Balas komentar",
  "ta.kolIsiNotifikasi": "Isi notifikasi",
  "ta.kolLabel": "Label",
  "ta.kolChatId": "chat_id",
  "ta.belumDihubungkan": "belum dihubungkan",
  "ta.belumPernah": "belum pernah",
  "ta.kapBisa": "Bisa",
  "ta.kapTidak": "Tidak bisa",
  "ta.kapBelum": "Belum dibangun",
  "ta.kapBedaJudul": "\"Tidak bisa\" dan \"belum dibangun\" dua hal berbeda",
  "ta.kapBedaIsi": "Tidak bisa = platformnya memang tidak menyediakannya; LinkedIn tidak melayani balasan DM otomatis, jadi menghubungkannya menambah kanal terbit, bukan kanal jawab. Belum dibangun = platformnya bisa, kodenya belum ada. Bedanya menentukan apakah pertanyaan \"kapan bisa?\" punya jawaban.",
  "ta.grupJudul": "Grup Telegram",
  "ta.isiNotifikasiSemua": "DM · prospek · meeting",
  "ta.grupBukanIzinJudul": "Menghubungkan grup ≠ orangnya boleh menekan tombol",
  "ta.grupBukanIzinIsi": "Semua orang di grup bisa membaca notifikasi. Tapi tombol seperti \"Ambil & Tangani\" hanya bekerja untuk orang yang sudah menautkan akun Telegram-nya — caranya mengetik /join KODE sekali di grup. Siapa yang belum, terlihat di menu Tim.",
  "ta.kolPotongan": "Potongan",
  "ta.belumDiproses": "belum diproses",
  "ta.ujiAmbilJudul": "Uji ambil",
  "ta.ujiAmbilCatatan": "murah, bisa dijalankan berkali-kali",
  "ta.ujiPlaceholder": "Ketik pertanyaan seperti pelanggan Anda…",
  "ta.ujiJalankan": "Jalankan",
  "ta.ujiJalankanMahal": "Jalankan (berbiaya)",
  "ta.ujiNolJudul": "0 potongan ditemukan",
  "ta.ujiNolIsi": "Pertanyaan ini tidak menemukan apa pun di dokumen Anda. Bot akan tetap menjawabnya — tanpa bahan, dan itu keadaan paling rawan mengarang. Tambahkan bagian yang membahasnya ke salah satu dokumen.",
  "ta.ujiKetemu": "{{n}} potongan ditemukan · {{karakter}} karakter konteks",
  "ta.ujiPercakapanJudul": "Uji percakapan",
  "ta.ujiPercakapanCatatan": "mahal, jalankan saat dokumen berubah",
  "ta.ujiPakaiKonteks": "Jawabannya memakai potongan yang ditemukan ({{n}} potongan).",
  "ta.ujiMengarang": "Jawabannya TIDAK memakai potongan yang ditemukan ({{n}} potongan) — kemungkinan besar dikarang. Periksa dokumen Anda.",
  "ta.duaUjiJudul": "Kenapa dua uji, bukan satu",
  "ta.duaUjiIsi": "Uji ambil menangkap penyebabnya — pertanyaan yang tidak menemukan bahan. Uji percakapan menangkap akibatnya — jawaban yang tetap keluar walau bahannya tidak ada. Satu uji saja akan melewatkan salah satunya.",
  "umum.menunggu": "Menunggu…",
  "tk.kolSumber": "Sumber pencarian",
  "tk.sumberCatatan": "Anda memilih kata kunci, bukan situs berita. Situs mana yang muncul ditentukan hasil pencariannya.",
  "tk.sumberKosong": "Tidak ada sumber terpilih — scraping akan memakai keduanya (bawaan), bukan berhenti.",
  "tk.kolBahasa": "Bahasa",
  "tk.bahasaCatatan": "Menentukan bahasa dan negara hasil pencarian. Kata kunci berbahasa lain dengan setelan Indonesia akan menarik berita yang tidak nyambung — tanpa galat apa pun.",
  "konten.adaGagal": "{{n}} konten gagal terbit",
  "konten.gagalTanpaSebab": "Meta menolaknya tanpa menyebut sebab. Buka barisnya di tabel untuk melihat jadwal dan tujuannya.",
  "adm.tabFitur": "Fitur",
  "adm.tabModel": "Model & pagu",
  "adm.modelPaguJudul": "Model AI yang dipakai",
  "adm.modelPaguCatatan": "dipilih admin tenant — di sini dibaca saja",
  "adm.belumPilihModel": "Tenant ini belum memilih model apa pun.",
  "adm.belumPilihModelKet": "Selama kosong, setiap peran memakai model bawaan Smova. Admin tenant yang memilihnya, di layar Model AI miliknya.",
  "adm.kolUrutanModel": "Urutan dipakai",
  "adm.fiturJudul": "Fitur yang dibeli tenant ini",
  "adm.fiturCatatan": "{{hidup}} dari {{total}} menyala",
  "adm.fiturJualJudul": "Ini yang kita jual, jadi ini wewenang kita",
  "adm.fiturJualIsi": "Admin tenant hanya melihat daftarnya — ia tidak bisa menyalakan apa pun sendiri. Setelan per fitur (topik scraping, field profiling, jadwal meeting) tetap miliknya. Ketergantungan ditegakkan sistem: menyalakan chatbot tanpa rag ditolak, dan mematikan rag selagi chatbot hidup juga ditolak.",
  "ta.fiturSiapaJudul": "Fitur diatur bersama Smova",
  "ta.fiturSiapaIsi": "Daftar ini memperlihatkan apa yang aktif untuk perusahaan Anda. Menyalakan atau mematikannya dilakukan Smova — hubungi kami untuk mengubah paket. Pengaturan di dalam tiap fitur (topik pencarian, data yang dikumpulkan bot, jam operasi) tetap Anda yang atur, di menu masing-masing.",
  "fp.nProspek": "{{n}} prospek",
  "fp.belumAda": "belum ada",
  "st.draft": "Draf — belum ada gambar/jadwal",
  "st.pending_concept": "Konsep — belum disetujui",
  "st.scheduled": "Terjadwal",
  "st.pending_approval": "Sudah jadi — belum ditinjau",
  "st.published": "Sudah tayang",
  "st.rejected": "Ditolak",
  "st.failed": "Gagal terbit",
  "tahap.collecting": "Mengumpulkan data",
  "tahap.profiled": "Data lengkap",
  "tahap.exploring": "Menjajaki",
  "tahap.scheduling": "Mengatur jadwal",
  "tahap.meeting_confirmed": "Meeting disepakati",
  "tahap.wl_invite_sent": "Undangan terkirim",
  "tahap.dropped": "Berhenti",
  "tahap.won": "Jadi pelanggan",
  "pk.perModelCatatan": "hanya balasan chat — pembuatan gambar, video, dan konsep konten belum dirinci per model",
  "pk.modelTakTercatat": "tidak tercatat",
  "adm.kolSambungan": "Sambungan",
  "adm.kolOrang": "Orang",
  "adm.kolDm30": "DM 30 hari",
  "adm.kolProspek": "Prospek",
  "adm.kolToken30": "Token 30 hari",
  "adm.tanpaSambungan": "belum tersambung",
  "jenisTenant.direct": "klien langsung",
  "jenisTenant.agency": "agensi",
  "jenisTenant.internal": "internal",
  "mode.draft": "Draf — bot diam",
  "mode.test": "Uji — hanya akun uji",
  "mode.live": "Live",
  "kt.kolFitur": "Fitur",
  "kt.takadaPemakai": "belum ada",
  "kt.kolModel": "Model",
  "kt.kolMunculDi": "Muncul di",
  "munculDi.chat": "Chatbot",
  "munculDi.text": "Caption konten",
  "munculDi.image": "Gambar",
  "munculDi.video": "Video",
  "ob.judul": "Onboarding · {{nama}}",
  "ob.keterangan": "Boleh ditinggal dan dilanjutkan besok — tidak ada yang perlu diselesaikan dalam satu duduk.",
  "ob.bukaDetail": "Buka detail tenant",
  "ob.majuJudul": "Kemajuan",
  "ob.majuCatatan": "dihitung dari keadaan sekarang, bukan dari centang yang pernah ditekan",
  "ob.dariTujuh": "{{n}} dari 7",
  "ob.tanggaJudul": "Tujuh langkah",
  "ob.tanggaCatatan": "langkah yang belum bisa dimulai menyebut apa yang ditunggunya",
  "ob.keadaan.selesai": "selesai",
  "ob.keadaan.sekarang": "kerjakan sekarang",
  "ob.keadaan.menunggu": "belum",
  "ob.keadaan.terkunci": "terkunci",
  "ob.kolDibutuhkan": "Yang dibutuhkan",
  "ob.kolSudah": "Sudah?",
  "ob.belumAda": "belum ada",
  "ob.urutanJudul": "Urutan langkah di bawah dibalik dari yang alami, dan alasannya harus dibaca",
  "ob.urutanIsi": "Kolom `tenants.mode` punya nilai `draft` yang artinya \"belum aktif\" — tapi kolom itu NOL PEMBACA di jalur masuk. Tidak ada satu baris kode pun yang menahan pemrosesan untuk tenant draft. Akibatnya: begitu Instagram tersambung, bot langsung melayani publik, dengan pengetahuan apa pun yang kebetulan sudah terisi saat itu. Karena itu \"Hubungkan Instagram\" ditaruh di langkah 5, sesudah pengetahuan dan fitur beres.",
  "ob.l1": "1 · Tenant dibuat",
  "ob.l1Isi": "Mode {{mode}} · zona waktu {{zona}} · dibuat {{tanggal}}",
  "ob.l1Hilang": "Tenant dengan id ini tidak ada di daftar. Mungkin sudah dihapus.",
  "ob.l2": "2 · Grup Telegram & tim",
  "ob.l2Isi": "Tempat notifikasi dikirim, dan orang-orang yang boleh menekan tombolnya. Aman dimulai sekarang — belum ada yang menghadap publik. Kode /join diterbitkan sesudah grupnya ada, karena tenant sebuah penautan ditentukan grup tempat orang mengetik, bukan oleh kodenya.",
  "ob.l3": "3 · Dokumen pengetahuan",
  "ob.l3Isi": "Bahan yang dipakai bot menjawab — dan apa pun yang tidak ada di sini, bot tidak boleh mengarangnya. Onboarding paling sering macet di sini, bukan di bagian teknisnya. Menunggu tenant mengirimnya; kita tidak tahu isi bisnis mereka.",
  "ob.l4": "4 · Fitur yang dibeli & pagu belanja",
  "ob.l4Isi": "Mana yang menyala untuk tenant ini, model apa yang boleh dipakai, dan berapa pagu bulanannya. Ini bagian komersial — ditetapkan kita, bukan mereka.",
  "ob.l5": "5 · Hubungkan Instagram",
  "ob.takBisaKembali": "titik tidak bisa kembali",
  "ob.l5Isi": "Admin tenant yang login dengan akun Meta mereka sendiri. Sejak menit akun tersambung, DM masuk diproses dan dibalas ke pelanggan sungguhan — tidak ada tahap percobaan selama `mode` belum ditegakkan. Jangan lakukan ini sebelum langkah 3 dan 4 selesai.",
  "ob.l6": "6 · Uji dengan DM sungguhan",
  "ob.l6Isi": "Kirim DM dari akun pribadi ke Instagram tenant, lalu periksa tiga hal sekaligus: balasannya masuk akal, notifikasinya sampai ke grup Telegram yang benar, dan tombol di notifikasi itu bekerja untuk orang yang sudah /join. Jangan pernah menyerahkan tenant tanpa langkah ini — ketiganya melibatkan empat sistem berbeda, dan tiap sambungannya bisa gagal tanpa memunculkan galat di mana pun.",
  "ob.l6Terkunci": "Terkunci — menunggu langkah 3 dan 5. DM uji yang dikirim sebelum dokumennya masuk akan dijawab bot yang tidak punya bahan, dan hasilnya terbaca sebagai \"botnya jelek\" alih-alih \"belum diberi apa-apa\".",
  "ob.l7": "7 · Serahkan ke klien",
  "ob.l7Isi": "Kirim akses Tenant Admin, dan serahkan yang memang milik mereka: persona bot, data yang dikumpulkan, jadwal balas, jadwal konten. Sejak titik ini kita berhenti mengatur isinya dan mulai mengawasinya.",
  "ob.l7Terkunci": "Terkunci — menunggu langkah 6.",
  "ob.sGrup": "Grup Telegram aktif",
  "ob.nGrup": "{{n}} grup",
  "ob.sOrang": "Orang di roster",
  "ob.nOrang": "{{n}} orang",
  "ob.sTertaut": "Sudah menjalankan /join",
  "ob.nTertaut": "{{n}} dari {{total}}",
  "ob.sDokumen": "Dokumen yang bisa dipakai bot",
  "ob.nDokumen": "{{n}} dari {{total}} dokumen",
  "ob.sFitur": "Fitur menyala",
  "ob.nFitur": "{{n}} dari {{total}}",
  "ob.sModel": "Model dipilih",
  "ob.nModel": "{{n}} pilihan",
  "ob.pakaiBawaan": "pakai bawaan Smova",
  "ob.sPagu": "Pagu bulanan",
  "ob.tanpaPaguTakApa": "belum dipasang — boleh",
  "ob.sWebhook": "Webhook pernah sampai",
  "ob.nWebhook": "{{n}} kejadian",
  "ob.belumPernahSampai": "belum pernah",
  "ob.sAdminMasuk": "Admin tenant pernah masuk",
  "ob.nAdminMasuk": "{{n}} orang",
  "ob.belumPernahMasuk": "belum pernah",
  "ob.keSambungan": "Buka Sambungan",
  "ob.kePengetahuan": "Buka Pengetahuan",
  "ob.keFitur": "Buka Fitur",
  "ob.keJalur": "Buka Jalur masuk",
  "ob.menungguJudul": "Kenapa dua langkah menunggu orang lain, dan itu bukan cacat",
  "ob.menungguIsi": "Langkah 3 menunggu dokumen dari tenant; langkah 5 menunggu mereka login ke Meta. Keduanya tidak bisa kita kerjakan sendiri — kita tidak boleh memegang kata sandi Meta mereka, dan kita tidak tahu isi bisnis mereka. Yang bisa dilakukan layar ini cuma membuat penantiannya TERLIHAT, supaya onboarding yang macet tiga minggu tidak ditemukan secara kebetulan.",
  "ob.turunanJudul": "Centangnya diturunkan, tidak disimpan",
  "ob.turunanIsi": "Tidak ada tabel yang mencatat langkah mana yang sudah ditekan, dan itu disengaja: keadaan yang disimpan terpisah dari kenyataan akan menyimpang darinya — centang \"dokumen sudah masuk\" tetap hijau sesudah dokumennya dihapus. Yang dibaca di sini data yang menggerakkan sistem. Akibatnya halaman ini juga TIDAK bisa menyebut sejak kapan sebuah langkah tertunda; itu butuh tabel riwayat yang belum ada.",
  "ta.liburBedaIsi": "Milik seluruh tenant — berbeda dari blok ketersediaan satu orang. Hari ini tidak akan ditawarkan bot.",
  "ta.fpNonaktifIsi": "Yang dijawab \"Tidak lagi\" berhenti ditanyakan bot, tapi tetap tampil di sini — jawaban yang sudah terkumpul tidak dihapus, dan masih terbaca di layar prospek.",
  "ta.identitasCatatan": "yang didengar pelanggan Anda",
  "ta.kebijakanCatatan": "mengubah cabang percakapan, bukan cuma kata",
  "ta.liburCatatan": "akhir pekan diatur di tab “Jam & hari”",
  "ta.liburBedaJudul": "Ini milik seluruh tenant, bukan satu orang",
  "fp.daftarCatatan": "ditanyakan satu per satu, hanya yang belum terisi",
  "ta.fpNonaktifJudul": "Menonaktifkan field tidak menghapus datanya",
  "ta.pengRingkasJudul": "{{dok}} dokumen · {{potongan}} potongan",
  "ta.kolJenis": "Jenis",
  "ta.kolDiproses": "Diproses",
  "ta.belumDiproses2": "belum diproses",
  "ta.pagarKunci": "dikunci Smova",
  "ta.pagarSelalu": "Selalu berlaku, dan tidak bisa dimatikan siapa pun",
  "ta.pagar1": "Bot tidak boleh mengaku manusia, walaupun pelanggan mendesak atau kecewa.",
  "ta.pagar2": "Bot tidak boleh menyebut nama produk yang tidak ada di dokumen pengetahuan Anda — lebih baik bilang tidak tahu daripada mengarang.",
  "ta.pagar3": "Bot tidak menjanjikan apa pun yang tidak ada di pengaturan ini.",
  "ta.pagarCatatan": "ditampilkan supaya terlihat bahwa ia ADA dan sengaja terkunci",
  "tk.frekuensiJudul": "Berapa kali sehari",
  "tk.frekuensiLabel": "Frekuensi",
  "tk.frekuensiNilai": "{{n}}× sehari",
  "tk.frekuensiTiap": "tiap {{n}} jam",
  "tk.jamJalan": "Jam jalan",
  "tk.kedaluwarsaLabel": "Buang konten menunggu setelah",
  "tk.kedaluwarsaKet": "hari. Konsep dan gambar yang {{n}} hari tidak diputuskan dibuang beserta datanya, dari rantai otomatis maupun /campaign. Isi 0 kalau tidak ingin dibuang sama sekali.",
  "tk.kedaluwarsaMati": "hari — 0 berarti tidak pernah dibuang. Antrean akan terus bertambah.",
  "tk.gayaLabel": "Gaya visual brand",
  "tk.gayaContoh": "Contoh: ilustrasi flat, palet biru tua dan hijau, latar polos, sisakan ruang kosong di sepertiga bawah",
  "tk.gayaKet": "Boleh kosong. Kalau kosong, gaya diambil dari gambar referensi ber-label brand — satu gambar mengajarkan palet, gaya, dan komposisi sekaligus. Kotak ini untuk hal yang tidak bisa ditunjukkan gambar.",
  "tk.hariJalan": "Hari",
  "tk.frekuensiKosong": "Jadwal pencarian belum diatur, jadi tidak ada bahan yang dikumpulkan sendiri.",
  "ta.tujuhHari": "{{n}} hari terakhir",
  "ta.tujuhCatatan": "angka, bukan tugas — sengaja di bawah",
  "ta.angka.dm": "DM masuk",
  "ta.angka.dmDari": "{{n}} dibalas bot",
  "ta.angka.prospek": "Prospek baru",
  "ta.angka.prospekDari": "{{n}} lewat tahap pengumpulan",
  "ta.angka.meeting": "Meeting",
  "ta.angka.meetingDari": "{{n}} belum ada peserta",
  "ta.angka.meetingAman": "semua sudah ada peserta",
  "ta.angka.konten": "Konten terbit",
  "ta.angka.kontenDari": "{{n}} menunggu persetujuan",
  "ta.angka.pagu": "Sisa pagu",
  "ta.angka.paguDari": "{{sisa}} tersisa",
  "ta.angka.tanpaPagu": "tidak dibatasi",
  "ta.tugasTelegram": "{{n}} anggota tim belum menautkan Telegram",
  "ta.tugasTelegramKet": "Tombol di notifikasi grup akan menolak mereka sampai tertaut.",
  "fp.terlaluWajibJudul": "{{n}} field wajib sudah mendekati batas nyaman",
  "fp.terlaluWajibIsi": "Bot menanyakan field wajib satu per satu di dalam percakapan. Makin banyak yang wajib, makin percakapannya terasa seperti formulir — dan calon pembeli berhenti di tengah. Jadikan opsional apa yang bisa ditanyakan manusia nanti saat meeting.",
  "ta.bolehYa": "Boleh",
  "ta.bolehTidak": "Tidak boleh",
  "tk.kolJam": "Jam",
  "tk.kolJenis": "Jenis",
  "tk.kolTujuan": "Tujuan",
  "tk.tujuanKosong": "belum ada platform yang siap menerbitkan",
  "tk.rantaiJudul": "Rantai konten, empat langkah",
  "tk.rantaiCatatan": "urutannya berarti — mematikan langkah 1 membuat sisanya menganggur",
  "tk.langkah.cariBahan": "1 · Cari bahan",
  "tk.langkah.susunKonsep": "2 · Susun konsep",
  "tk.langkah.setujuiKonsep": "3 · Setujui konsep",
  "tk.langkah.setujuiAset": "4 · Setujui gambar",
  "tk.langkahOn.cariBahan": "Bot mencari berita dan tren sendiri, pada jadwal di tab “Cari bahan”.",
  "tk.langkahOff.cariBahan": "Tidak ada bahan baru yang masuk. Tiga langkah berikutnya menganggur.",
  "tk.langkahOn.susunKonsep": "Bahan yang masuk langsung disusun jadi konsep konten.",
  "tk.langkahOff.susunKonsep": "Bahan menumpuk tanpa jadi konsep. Tidak ada biaya model yang keluar di sini.",
  "tk.langkahOn.setujuiKonsep": "Konsep dari rantai otomatis langsung lanjut: prompt gambar ditulis AI, lalu gambarnya dibuat. Tanpa ditinjau siapa pun. Konsep yang diminta orang (/campaign, /analyze, tombol tren) tetap menunggu di Telegram.",
  "tk.langkahOff.setujuiKonsep": "Konsep menunggu Anda setujui di Telegram. Gambarnya belum dibuat, jadi konsep yang Anda tolak tidak menagih ongkos gambar. Ia tidak hilang — ia menumpuk di layar Konten.",
  "tk.langkahOn.setujuiAset": "Gambar dari rantai otomatis langsung terjadwal, dan terbit sendiri pada jam slotnya. Konten yang dibuat orang tetap menunggu di Telegram sampai orangnya memilih Upload sekarang atau Jadwalkan.",
  "tk.langkahOff.setujuiAset": "Gambarnya SUDAH dibuat, lalu dikirim ke Telegram sebagai foto bertombol. Ia baru terjadwal sesudah Anda setujui. Ongkos gambarnya sudah keluar di titik ini.",
  "tk.langkahTakDibeli": "Paket Anda belum memuat {{fitur}}, jadi saklar ini tidak berlaku. Hubungi Smova kalau ingin menambahkannya.",
  "tk.fiturNama.scraping": "pencarian bahan",
  "tk.fiturNama.drafting": "penyusunan konten",
  "tk.mati": "Mati",
  "tk.tinjauDulu": "Saya tinjau dulu",
  "tk.rantaiBedaJudul": "Dua jenis “tidak otomatis”, dan bedanya menentukan apa yang Anda temukan besok",
  "tk.rantaiBedaIsi": "Langkah 1 dan 2 mati berarti TIDAK TERJADI apa-apa — tidak ada bahan, tidak ada konsep, dan tidak ada biaya model yang keluar. Langkah 3 dan 4 mati berarti pekerjaannya TETAP TERJADI lalu berhenti menunggu Anda, dan keduanya menunggu di Telegram: konsep sebagai teks bertombol, gambar sebagai foto bertombol. Bedanya ongkos: konsep yang ditolak belum menagih gambar, gambar yang ditolak sudah. Menyamakan “mati” dan “menunggu” membuat orang mengira konten berhenti padahal ia sedang menunggu.",
  "ta.pengUnggah": "Unggah dokumen",
  "ta.pengMemproses": "Memproses…",
  "ta.pengJenis": "Teks saja: .txt .md .csv .json — PDF/Word simpan ulang jadi .txt",
  "ta.pengTerunggah": "{{nama}} masuk · {{n}} potongan siap dipakai bot",
  "adm.orangHitung": "{{n}} orang",
  "adm.tambahOrang": "Tambah orang",
  "adm.kolTertaut": "Tertaut",
  "adm.kolTerakhirAktif": "Terakhir aktif",
  "adm.sudahJoin": "Sudah /join",
  "adm.belumJoin": "Belum /join",
  "adm.kolAkunAktif": "Akun aktif?",
  "adm.kolUsername": "Nama pengguna",
  "adm.kolPassword": "Sandi awal",
  "adm.kolTelegram_username": "Telegram",
  "adm.suntingOrang": "Menyunting {{nama}}",
  "adm.sandiCatatan": "Sandi diketik Anda, bukan dibuatkan layar — sandi yang tampil di layar ikut masuk tangkapan layar dan riwayat chat. Sampaikan lewat jalur yang Anda pilih, dan minta orangnya menggantinya.",
  "adm.sandiMinimal": "Nama pengguna minimal 3 huruf, sandi minimal 8.",
  "adm.tgHandleCatatan": "Handle ini yang KITA catat. Tautan sungguhan lahir saat orangnya sendiri menjalankan /join di grup Telegram — mengisi kolom ini tidak menautkannya.",
  "adm.orangSiapaJudul": "Menambah orang dilakukan di sini; menautkannya di Tenant Admin",
  "adm.orangSiapaIsi": "Kolom Tertaut di atas cuma DIBACA dari sini — kode /join diterbitkan admin tenant, dan orangnya sendiri yang mengetiknya di grup Telegram. Kita menambah dan menyunting orangnya; mereka yang menautkan akunnya.",
  "umum.sunting": "Edit",
  "umum.tersimpanOtomatis": "Tab ini menyimpan setiap perubahan seketika — tidak ada yang menunggu disimpan.",
  "tk.kolSlide": "Slide",
  "tk.slideVideo": "1 · video",
  "tk.slideVideoKet": "Reels tidak punya bentuk carousel, jadi slot video selalu satu berkas.",
  "tk.gambarPerHari": "{{n}} gambar dibuat per hari — inilah angka yang menentukan belanja, bukan jumlah slotnya.",
  "tk.collaseBiayaJudul": "Collase menaikkan belanja sebanyak slidenya",
  "tk.collaseBiayaIsi": "Tiap slide adalah satu gambar yang dibuat dan ditagih terpisah — jadwal Anda sekarang menghasilkan {{n}} gambar sehari. Gambar juga yang PALING DULU dihentikan saat pagu belanja tersentuh, jadi collase yang terlalu banyak membuat konten berhenti lebih awal di bulan itu. Kalau pagu habis di tengah pembuatan, slotnya batal utuh — tidak ada collase separuh yang terbit.",
  "bk.gambarHilang": "gambar tidak ditemukan",
  "konten.cobaLagi": "Coba lagi",
  "konten.buang": "Buang",
  "konten.galatUrl": "Meta tidak bisa mengunduh gambarnya — berkasnya sudah tidak ada di server. Buang konten ini, lalu buat ulang dari bahan yang sama.",
  "konten.galatToken": "Izin Meta kedaluwarsa. Hubungi Smova untuk memperbarui tokennya, lalu tekan Coba lagi.",
  "konten.galatSambungan": "Akun platform ini belum tersambung, atau sambungannya tidak aktif. Minta Tenant Admin memeriksanya di Sambungan, lalu tekan Coba lagi.",
  "k6.toast.konsepTanpaGambar": "Konsep disetujui, tetapi gambarnya gagal dibuat. Buka kontennya untuk membuat gambar.",
  "k6.toast.konsepTerjadwal": "Konsep disetujui dan langsung terjadwal.",
  "konten.galatKuota": "Meta menolak sementara karena terlalu banyak permintaan. Coba lagi beberapa jam berikutnya.",
  "konten.galatIzin": "Akun Meta ini belum punya izin menerbitkan. Hubungi Smova.",
  "konten.galatIzinBaca": "Aplikasi Meta-nya belum punya izin MEMBACA postingan Halaman Facebook, jadi angkanya tidak bisa diambil. Penerbitan tidak terpengaruh — kontennya tetap tayang. Hubungi Smova.",
  "konten.galatMedia": "Meta menolak gambar atau videonya — ukuran atau formatnya tidak diterima.",
  "bh.kolBerita": "Berita",
  "konten.cobaLagiN": "Coba lagi ({{n}} tujuan)",
  "konten.buangN": "Buang ({{n}} tujuan)",
  "konten.suka": "Suka",
  "konten.komentar": "Komentar",
  "konten.semuaKonten": "← Semua konten",
  "konten.tanpaJudul": "(tanpa judul)",
  "konten.insightJudul": "Angka per tujuan",
  "konten.insightCatatan": "angka platform yang dipilih — tidak pernah dijumlahkan",
  "konten.bukaPostingan": "Buka postingan",
  "konten.tanpaTautan": "tautan tidak tersimpan",
  "konten.slideKe": "Slide {{n}}/{{dari}}",
  "konten.slideMundur": "Slide sebelumnya",
  "konten.slideMaju": "Slide berikutnya",
  "konten.yangTayangCollase": "Collase {{n}} slide — urutannya persis seperti yang tayang.",
  "konten.perbaruiAngka": "Perbarui angka",
  "konten.mengambil": "Mengambil…",
  "konten.diambil": "Angka diambil {{kapan}}.",
  "konten.belumDiambil": "Angka ini belum pernah diambil dari platformnya.",
  "konten.kenapaKosongJudul": "Kenapa sebagian angkanya “—”",
  "konten.kenapaKosongIsi": "“—” berarti platformnya TIDAK MELAPORKAN angka itu, bukan nol — nol berarti benar-benar tidak ada yang melihatnya. Jangkauan menghitung ORANG, tayangan menghitung KALI DILIHAT: satu orang yang membuka tiga kali menambah tiga tayangan dan satu jangkauan. Simpan hanya ada di Instagram, dibagikan hanya di Facebook. Sebagian angka baru tersedia beberapa jam sesudah terbit. Konten yang terbit sebelum 12 September tidak menyimpan id postingannya, jadi angkanya kosong sampai “Perbarui angka” ditekan sekali — id-nya dicari balik dengan mencocokkan waktu terbit. Kalau postingannya sudah dihapus, ia tidak akan ketemu, dan itu dikatakan apa adanya.",
  "konten.detailKeterangan": "Tayang {{kapan}} · ke {{tujuan}}",
  "konten.detailBelumJam": "Belum dijadwalkan · ke {{tujuan}}",
  "konten.captionJudul": "Caption",
  "konten.yangTayangJudul": "Yang tayang",
  "konten.yangTayangFoto": "foto · sudah berwatermark",
  "konten.yangTayangVideo": "video · sudah berwatermark",
  "konten.lihatPostingan": "lihat postingan",
  "konten.sumberIde": "Sumber ide",
  "konten.kolJenis": "Jenis",
  "konten.m.jangkauan": "Jangkauan",
  "konten.m.tayangan": "Tayangan",
  "konten.m.suka": "Suka",
  "konten.m.simpan": "Simpan",
  "konten.m.dibagikan": "Dibagikan",
  "konten.m.komentar": "Komentar",
  "prospek.semuaProspek": "Semua prospek",
  "prospek.dariInstagram": "Dari Instagram",
  "prospek.dariManual": "Dimasukkan manual",
  "prospek.manual": "Manual",
  "prospek.ditanganiOleh": "ditangani {{siapa}}",
  "prospek.belumDitangani": "belum ada yang mengambil alih",
  "prospek.meetingBerikut": "Meeting berikut",
  "prospek.dataTerisi": "{{terisi}} dari {{total}} terisi",
  "prospek.dataKet": "Dikumpulkan bot lewat percakapan, tapi boleh Anda perbaiki — dan sering perlu: PIC berganti orang, alamat kantor pindah, email salah ketik. Nilai lama tidak hilang: tiap perubahan tersimpan di riwayat beserta nilai sebelumnya.",
  "prospek.tidakDikumpulkan": "tidak lagi dikumpulkan",
  "prospek.catatanProses": "Catatan proses",
  "prospek.catatanProsesCatatan": "diisi tim, bukan bot",
  "prospek.cTanggal": "Tanggal",
  "prospek.cKejadian": "Kejadian",
  "prospek.cOleh": "Oleh",
  "prospek.catatanKosong": "Belum ada catatan proses",
  "prospek.catatanKosongKet": "Yang terjadi di luar sistem — ditelepon, kirim proposal, ditolak — dicatat di sini.",
  "prospek.riwayatDM": "Riwayat percakapan Instagram",
  "prospek.riwayatDMCatatan": "apa yang sudah dibicarakan, bukan cuma siapa",
  "prospek.dmKosong": "Belum ada percakapan",
  "prospek.dmKosongKet": "Prospek yang dimasukkan manual memang tidak punya riwayat DM.",
  "prospek.balasDariSini": "Balas dari sini",
  "prospek.balasDariSiniKet": "Balasan Anda dikirim sebagai akun Instagram perusahaan, bukan atas nama bot.",
  "prospek.botMati": "Bot dimatikan",
  "prospek.botJalan": "Bot menjawab",
  "prospek.dipegangKet": "Anda memegang percakapan ini. Selama dipegang, bot tidak membalas orang ini sama sekali — pesan masuknya tetap dicatat dan tetap muncul di Perlu dijawab, tapi jawabannya menunggu Anda.",
  "prospek.botJalanKet": "Bot membalas otomatis. \"Pegang percakapan\" mematikannya untuk orang ini saja, sampai dilepas.",
  "prospek.pernahMenangani": "Pernah turun tangan: {{siapa}}.",
  "prospek.tidakMundur": "Prospeknya tidak mundur: posisinya di funnel tetap.",
  "prospek.ambilVsPegang": "\"Ambil\" dan \"Pegang percakapan\" dua hal berbeda",
  "prospek.ambilVsPegangKet": "Ambil menahan satu pesan — Anda yang menjawab yang ini, dan bot tetap hidup untuk pesan berikutnya. Pegang percakapan mematikan bot untuk orang ini terus-menerus sampai dilepas. Untuk pertanyaan harga sekali, \"Ambil\" cukup; untuk negosiasi yang berjalan berhari-hari, \"Pegang\" yang benar.",
  "prospek.tanpaPeserta": "belum ada peserta",
  "prospek.simpanPeserta": "Simpan peserta",
  "prospek.pesertaKet": "Boleh berubah kapan saja — orang ditambah, dikurangi, atau diganti seluruhnya.",
  "prospek.timKosong": "Belum ada anggota tim yang bisa dipilih.",
  "prospek.hasilBelum": "belum diisi — isi setelah meeting selesai",
  "prospek.simpanHasil": "Simpan hasil",
  "prospek.rekamanKe": "Rekaman {{n}}",
  "prospek.rekamanJumlah": "{{n}} rekaman",
  "prospek.belumAdaRekaman": "Belum ada rekaman untuk meeting ini.",
  "prospek.unggahRekaman": "Unggah rekaman audio",
  "prospek.mengunggah": "Mengunggah…",
  "prospek.rekamanKet": "Audio diubah jadi transkrip lalu diringkas jadi poin dan action item, tersimpan di meeting ini. Rekaman kedua ditambahkan — tidak menimpa yang pertama. Maksimal {{mb}} MB per berkas.",
  "prospek.jadwalkanLagi": "Jadwalkan meeting lagi",
  "prospek.rekamanTerlaluBesar": "Audionya lebih dari {{mb}} MB. Kecilkan dulu (mis. ekspor jadi mono 64 kbps), atau kirim sebagai voice note di grup Telegram — jalur itu tidak kena batas ini.",
  "prospek.rekamanDitolakProxy": "Ditolak proxy sebelum sampai ke Smova karena badannya terlalu besar. Ini batas server, bukan batas Smova — beri tahu operator supaya dinaikkan.",
  "prospek.rekamanSaldoKurang": "Saldo OpenRouter kurang untuk transkripsi audio (butuh minimal $0,50). Top-up dulu, lalu unggah lagi.",
  "prospek.rekamanFiturMati": "Fitur rekaman meeting sedang dimatikan untuk tenant ini.",
  "umum.hapus": "Hapus",
  "prospek.hapusRekamanYakin": "Hapus rekaman ini? Audionya tidak disimpan — yang hilang tidak bisa dikembalikan.",
  "prospek.hapusRekamanIya": "Ya, hapus",
  "prospek.lihatTranskrip": "Lihat transkrip lengkap",
  "prospek.jamTidakTercatat": "jam tidak tercatat",
  "prospek.ringkasanGagal": "Ringkasannya tidak tersimpan — transkripnya ada di bawah.",
  "konten.suntingMedia": "Ganti gambarnya",
  "konten.unggahSlide": "Unggah gambar sendiri",
  "konten.suntingMediaKet": "Model, referensi, prompt tiap slide, dan urutannya — sama seperti di Buat Konten. Hanya selama kontennya belum disetujui.",
  "konten.simpanGambar": "Simpan gambar",
  "konten.simpanGambarKet": "Antreannya baru berubah saat disimpan, dan berubah untuk semua tujuan sekaligus.",
  "konten.ubahTeks": "Ubah teks",
  "konten.ubahTeksKet": "Berlaku untuk semua tujuan sekaligus.",
  "konten.captionHitung": "{{n}} dari {{batas}} karakter",
  "konten.pesanKunci": "Pesan kunci 💡",
  "konten.hashtag": "Hashtag",
  "konten.hashtagKet": "Pisahkan dengan spasi atau koma, tanpa tanda pagar. {{n}} terbaca, batas Instagram 30.",
  "sb.akunGanda": "{{n}} akun aktif — sistem menolak memilih. Nonaktifkan semua kecuali satu.",
  "sb.gantiAkun": "Ganti akun",
  "sb.gantiAkunJudul": "Ganti akun {{platform}}",
  "sb.gantiAkunPeringatan": "Akun yang sekarang dinonaktifkan, akun baru didaftarkan, dan tokennya dirotasi — sekaligus, dalam satu langkah. Yang lama tidak dihapus: ia tetap jadi jejak bahwa akun itu pernah tertaut ke sini.",
  "sb.gantiAkunId": "ID akun baru",
  "sb.gantiAkunToken": "Token akun baru",
  "sb.gantiAkunTokenKet": "Boleh dikosongkan HANYA kalau token yang sekarang memang berlaku untuk akun baru itu. Token akun lama hampir tidak pernah bisa melihat akun baru — gejalanya \"Object with ID … does not exist\" saat uji koneksi.",
  "sb.gantiAkunSimpan": "Ganti akun & token",
  "sb.gantiAkunSelesai": "Selesai. {{lama}} dinonaktifkan, {{baru}} sekarang aktif. Tekan Uji koneksi untuk memastikan.",
  "konten.draftJudul": "Masih draft — belum akan terbit",
  "konten.draftKet": "Draft punya tanggal, tapi penerbit hanya mengambil yang berstatus terjadwal. Selama masih draft ia duduk di sini tanpa pernah tayang.",
  "konten.draftKapan": "Tayang pada",
  "konten.draftJadwalkan": "Jadwalkan sekarang",
  "konten.belumDijadwalkan": "belum dijadwalkan",
  "konten.jadwalkanDulu": "Jadwalkan…",
  "konten.belumJudul": "Belum dijadwalkan — pilih jam terbitnya",
  "konten.belumKet": "Konten ini dibuat orang dan menunggu Anda memilih kapan terbit. Sistem tidak memilihkan jam. Setelah dijadwalkan, ia terbit sendiri pada jamnya ke semua tujuannya.",
  "konten.draftTerjadwal": "Terjadwal. Penerbit mengambilnya saat waktunya tiba.",
  "konten.draftSegera": "Terjadwal, dan waktunya sudah lewat — ia terbit pada sapuan berikutnya, paling lama 10 menit lagi.",
  "bk.unggahSendiri": "Unggah sendiri",
  "konten.hapusKonten": "Hapus konten",
  "konten.hapusJudul": "Hapus permanen — tidak bisa dibatalkan",
  "konten.hapusKet": "Seluruh {{n}} tujuan konten ini dibuang dari Smova, beserta angka jangkauan dan interaksi yang sudah terkumpul. Laporan yang terlanjur memakai angka itu tidak akan cocok lagi. Postingannya sendiri tidak disentuh — kalau masih ada di Instagram atau Facebook, ia tetap di sana.",
  "konten.hapusIya": "Ya, hapus permanen",
  "tk.refJudul": "Gambar untuk AI",
  "tk.refCatatan": "{{n}} dari {{maks}} dipakai — ikut ke setiap gambar otomatis",
  "tk.refKet": "Gambar yang dicentang ikut ke AI penulis prompt dan ke model gambar setiap kali gambar dibuat otomatis, beserta teks “untuk apa”-nya. Nama dan teks tersimpan saat Anda pindah dari kotaknya. Tim marketing tetap bisa memilih gambar mana pun secara manual di Buat Konten.",
  "tk.tabReferensi": "Referensi",
  "bk.tempJudul": "Gambar saya (sementara)",
  "bk.tempLabel": "sementara",
  "bk.tempTambah": "+ gambar saya",
  "bk.tempBuang": "Buang gambar ini",
  "bk.tempKet": "Gambar Anda sendiri tidak tersimpan; hilang saat halaman ditutup.",
  "bk.tempTerlaluBesar": "Gambarnya {{ukuran}} MB — batasnya {{maks}} MB. Kecilkan dulu; ia ikut dikirim ke model tiap kali gambar dibuat.",
  "bk.rasio": "Rasio",
  "bk.rasioBawaan": "Bawaan model · {{rasio}}",
  "bk.rasioPenyedia": "ditentukan penyedia",
  "bk.rasioIkutModel": "Tanpa rasio · bentuk mengikuti model dan referensi",
  "bk.rasioCatatan": "Daftarnya milik model yang dipilih — tiap model punya rasio sendiri.",
  "bk.rasioDiabaikan": "Dengan gambar referensi, model ini mengabaikan pilihan rasio dan mengeluarkan bentuk bawaannya (terukur: persegi). Feed Instagram 4:5, jadi hasilnya bisa terpotong. Pilih model lain kalau bentuknya penting.",
  "kt.kolKemampuan": "Kemampuan",
  "kt.kemReferensi": "terima referensi",
  "kt.kemRasioReferensiAbaikan": "rasio diabaikan saat berreferensi",
  "kt.kemDetik": "dtk",
  "kt.kemBelumSinkron": "belum disinkron",
  "kt.kemRasioBawaan": "Rasio bawaan",
  "kt.kemRasioPenyedia": "penyedia",
  "tk.videoMasihManual": "Slot video berhenti di draf, apa pun posisi saklar ini. Yang dibuat otomatis baru gambar; videonya diunggah atau dibuat orangnya di layar Konten.",
  "tk.refNamaLabel": "Nama bahan",
  "tk.refOrang": "Orang",
  "tk.refJenisOrangKet": "Ikut hanya kalau Pemeriksa kebutuhan orang menjawab YA untuk prompt gambarnya.",
  "prospek.tambahJudul": "Prospek baru",
  "prospek.simpanProspek": "Simpan prospek",
  "prospek.tambahKet": "Untuk prospek dari luar Instagram — pameran, telepon, rujukan. Kelima isian wajib. Sesudah disimpan, halaman prospeknya terbuka dan meeting bisa dijadwalkan dari sana.",
  "tk.refUnggah": "+ Unggah gambar",
  "tk.refBelumDipakai": "Belum ada gambar yang dicentang. Gambar otomatis dibuat tanpa logo atau aset brand apa pun.",
  "tk.refPenuh": "Sudah {{maks}} gambar — paling banyak yang bisa ikut sekali jalan. Lepas centang salah satu untuk memakai gambar lain.",
  "tk.refLain": "Gambar lain yang tidak dipakai ({{n}})",
  "tk.refPakai": "Pakai {{nama}}",
  "tk.refLepas": "Lepas {{nama}}",
  "tk.refUntukApa": "Untuk apa gambar ini",
  "tk.refUntukApaContoh": "mis. Logo resmi Seleris. Taruh di kiri atas, jangan digambar ulang.",
  "tk.phJudul": "Prompt harian",
  "tk.phCatatan": "Ditulis sekali, dipakai untuk setiap konten otomatis. AI membacanya bersama topik berita, caption, dan gambar di atas, lalu menulis prompt gambarnya.",
  "tk.phKosong": "Belum ada prompt harian. Gambar otomatis memakai prompt cadangan dari draf konten, dan tombol Tulis prompt di Buat Konten menolak sampai ada.",
  "tk.phContoh": "Tulis instruksi untuk AI di sini. Sisipkan topik dan caption lewat tombol di bawah.",
  "tk.phSisipkan": "Sisipkan",
  "tk.phTempel": "Topik, caption, brief, dan daftar gambar yang tidak Anda sisipkan tetap dikirim — ditempel di akhir prompt. Selain itu, tidak ada kalimat yang ditambahkan sistem.",
  "tk.phTopik": "Topik",
  "tk.phTopikKet": "judul dan ringkasan berita dari scraping",
  "tk.phCaption": "Caption",
  "tk.phCaptionKet": "caption yang sudah ditulis AI untuk konten ini",
  "tk.phPesan": "Pesan utama",
  "tk.phPesanKet": "pesan utama konten",
  "tk.phBrief": "Brief",
  "tk.phBriefKet": "arahan dari tombol Perbaiki di Telegram atau brief di Buat Konten",
  "tk.phBahan": "Daftar gambar",
  "tk.phBahanKet": "gambar yang ikut, bernomor, beserta teks untuk apa-nya",
  "tk.phSlideKe": "Slide ke-",
  "tk.phSlideKeKet": "nomor slide yang sedang ditulis (carousel: satu panggilan per slide)",
  "tk.phJumlah": "Jumlah slide",
  "tk.phJumlahKet": "jumlah slide carousel",
  "pintu.judul": "Masuk ke Smova",
  "pintu.sandi": "Sandi",
  "pintu.tampilkanSandi": "Tampilkan sandi",
  "pintu.lupa": "Lupa sandi? Hubungi admin tenant Anda.",
  "pintu.ket": "Pakai akun yang diberikan admin tim Anda.",
  "pintu.merek": "Tentang Smova",
  "pintu.janji": "Satu tempat untuk percakapan, prospek, meeting, dan konten.",
  "pintu.janjiKet": "Bot yang menjawab dan menyiapkan; tim Anda yang memutuskan.",
  "pintu.r1": "Percakapan",
  "pintu.r1Ket": "Pesan masuk dijawab bot dari pengetahuan perusahaan Anda.",
  "pintu.r2": "Prospek",
  "pintu.r2Ket": "Yang serius dikenali, lalu diteruskan ke tim lewat Telegram.",
  "pintu.r3": "Meeting",
  "pintu.r3Ket": "Jadwal disepakati di percakapan, pengingatnya dikirim otomatis.",
  "pintu.r4": "Konten",
  "pintu.r4Ket": "Disusun AI, disetujui tim, lalu terbit sesuai jadwal.",
  "pintu.oleh": "Smova oleh Seleris",
  "akun.label": "Akun {{nama}}",
  "akun.nama.judul": "Ubah nama",
  "akun.nama.ket": "Nama ini yang dibaca tim saat Anda bertindak di sebuah tenant, misalnya di pesan grup Telegram. Nama untuk masuk tidak berubah.",
  "akun.nama.label": "Nama",
  "akun.nama.isianKet": "Kosongkan untuk kembali disebut dengan nama akun Anda.",
  "akun.nama.simpan": "Simpan nama",
  "akun.nama.toast": "Nama Anda sekarang {{nama}}.",
  "akun.nama.toastKosong": "Nama dikosongkan. Anda kembali disebut dengan nama akun.",
  "akun.nama.gagalMuat": "Nama yang sekarang tidak bisa dimuat: {{sebab}}",
  "sandi.judul": "Ganti sandi",
  "sandi.ket": "Sesudah diganti, Anda keluar dari semua perangkat dan masuk lagi dengan sandi baru.",
  "sandi.ketKotor": "Sesudah diganti, Anda keluar dari semua perangkat dan masuk lagi dengan sandi baru. Perubahan yang belum disimpan di halaman ini akan hilang.",
  "sandi.lama": "Sandi lama",
  "sandi.baru": "Sandi baru",
  "sandi.baruKet": "Minimal {{n}} karakter.",
  "sandi.ulang": "Ulangi sandi baru",
  "sandi.simpan": "Ganti sandi",
  "sandi.pendek": "Sandi baru minimal {{n}} karakter.",
  "sandi.tidakSama": "Sandi baru dan ulangannya tidak sama.",
  "sandi.samaLama": "Sandi baru harus berbeda dari sandi lama.",
  "sandi.berhasil": "Sandi diganti. Masuk lagi dengan sandi baru.",
  "kerangka.lompatKeIsi": "Lompat ke isi",
  "kerangka.galatJudul": "Halaman ini gagal ditampilkan",
  "kerangka.muatUlang": "Muat ulang",
  "kerangka.tenant": "Tenant",
  "kerangka.tenantGagal": "Tenant tidak termuat. Coba lagi",
  "jaring.kueri": "Sebagian data di layar ini tidak termuat ({{sebab}}). Yang tampil bisa tidak lengkap atau sudah lama.",
  "jaring.aksi": "Ada yang gagal dan belum tertangani: {{sebab}}",
  "kerangka.hitungK2": "percakapan menunggu staf",
  "kerangka.hitungK6": "konten menunggu Anda",
  "kerangka.hitungP5": "orang belum /join di Telegram",
  "kerangka.hitungS5": "alur gagal dalam 24 jam",
  "mode.pendek.draft": "Draf",
  "mode.pendek.test": "Uji",
  "mode.pendek.live": "Live",
  "mode.ket.draft": "Draf: bot diam untuk semua orang.",
  "mode.ket.test": "Uji: bot hanya menjawab akun uji.",
  "mode.ket.live": "Live: bot menjawab semua pesan.",
  "k1.tujuh.judul": "{{n}} hari terakhir",
  "k1.tujuh.ket": "Angka untuk mengawasi, bukan daftar tugas.",
  "k1.tujuh.dm": "DM masuk",
  "k1.tujuh.dmDari": "{{n}} dibalas bot",
  "k1.tujuh.prospek": "Prospek baru",
  "k1.tujuh.prospekDari": "{{n}} lewat tahap pengumpulan",
  "k1.tujuh.meeting": "Meeting",
  "k1.tujuh.meetingDari": "{{n}} belum ada peserta",
  "k1.tujuh.meetingAman": "semua sudah ada peserta",
  "k1.tujuh.konten": "Konten terbit",
  "k1.tujuh.kontenDari": "{{n}} menunggu persetujuan",
  "k1.tujuh.gagal": "Angka tujuh hari terakhir tidak termuat",
  "k1.tujuh.kosong": "Belum ada angkanya.",
  "k1.sub.menunggu": "{{tanggal}} · {{n}} hal menunggu Anda",
  "k1.sub.kosong": "{{tanggal}} · Tidak ada yang menunggu Anda",
  "k1.angka.dm": "Perlu dijawab",
  "k1.angka.dmTerlama": "Terlama {{lamanya}}",
  "k1.angka.dmBeres": "Semua sudah ditangani",
  "k1.angka.prospek": "Prospek dikelola",
  "k1.angka.prospekTindakLanjut": "{{n}} perlu tindak lanjut",
  "k1.angka.prospekCalon": "{{n}} calon masih dilayani bot",
  "k1.angka.meeting": "Meeting hari ini",
  "k1.angka.meetingSatu": "{{jam}} · {{nama}}",
  "k1.angka.meetingLagi": "{{meeting}}, dan {{n}} lagi",
  "k1.angka.meetingKosong": "Tidak ada hari ini",
  "k1.angka.konten": "Konten menunggu Anda",
  "k1.angka.kontenKosong": "Tidak ada yang menunggu",
  "k1.angka.gagal": "Tidak termuat",
  "k1.rincian.belumDijadwalkan": "{{n}} belum dijadwalkan",
  "k1.rincian.konsep": "{{n}} konsep",
  "k1.rincian.persetujuan": "{{n}} menunggu persetujuan",
  "k1.rincian.gagal": "{{n}} gagal terbit",
  "k1.rincian.tanpaGambar": "{{n}} tanpa gambar",
  "k1.tugas.judul": "Menunggu Anda",
  "k1.tugas.keterangan": "Yang paling mendesak di atas.",
  "k1.tugas.dmJudul": "{{nama}}: “{{cuplikan}}”",
  "k1.tugas.dmKeterangan": "{{asal}} · bot menyerahkan ke tim {{lamanya}} lalu",
  "k1.tugas.asalDm": "{{platform}} DM",
  "k1.tugas.asalKomentar": "Komentar {{platform}}",
  "k1.tugas.jawab": "Jawab",
  "k1.tugas.lewatJudul": "{{nama}} menunggu {{lamanya}}",
  "k1.tugas.lewatKeterangan": "Lewat 24 jam: balas langsung di {{platform}}",
  "k1.tugas.lainJudul": "{{n}} percakapan lain menunggu",
  "k1.tugas.bukaSemua": "Buka semua",
  "k1.tugas.kontenJudul": "{{n}} konten menunggu Anda",
  "k1.tugas.tinjau": "Tinjau",
  "k1.tugas.meetingJudul": "Meeting dengan {{nama}} pukul {{jam}}",
  "k1.tugas.meetingTanpaNama": "Meeting pukul {{jam}}",
  "k1.tugas.prospekJudul": "{{n}} calon prospek datanya belum lengkap",
  "k1.tugas.prospekKeterangan": "Bot masih mengumpulkan, belum bisa ditawari meeting",
  "k1.tugas.lanjutJudul": "{{n}} prospek perlu tindak lanjut",
  "k1.tugas.lanjutKeterangan": "Meetingnya sudah lewat dan belum ditutup, atau belum ada meeting berikutnya",
  "k1.tugas.kosongJudul": "Tidak ada yang menunggu Anda",
  "k1.tugas.kosongKeterangan": "Percakapan, konten, dan meeting yang butuh Anda akan muncul di sini.",
  "k1.gagal.percakapan": "Percakapan tidak termuat",
  "k1.gagal.konten": "Konten tidak termuat",
  "k1.gagal.meeting": "Meeting tidak termuat",
  "k1.gagal.prospek": "Prospek tidak termuat",
  "k1.meeting.berikutnya": "Meeting berikutnya",
  "k1.meeting.tanpaNama": "Tanpa nama usaha",
  "k1.meeting.hariIni": "Hari ini",
  "k1.meeting.kapan": "{{hari}} · {{zona}}",
  "k1.meeting.bentuk": "Bentuk",
  "k1.meeting.online": "Online",
  "k1.meeting.tatapMuka": "Tatap muka",
  "k1.meeting.tatapMukaDi": "Tatap muka · {{lokasi}}",
  "k1.meeting.peserta": "Peserta",
  "k1.meeting.anda": "Anda",
  "k1.konten.judul": "Konten hari ini",
  "k1.konten.tanpaJudul": "Tanpa judul",
  "k1.konten.st.published": "Terbit",
  "k1.konten.st.scheduled": "Terjadwal",
  "k1.konten.st.rejected": "Ditolak",
  "k1.konten.st.failed": "Gagal terbit",
  "k1.konten.st.menunggu": "Menunggu Anda",
  "k1.konten.kosongJudul": "Tidak ada konten berjam hari ini",
  "k1.konten.kosongKeterangan": "Konten yang dijadwalkan untuk hari ini akan muncul di sini.",
  "k1.tugas.putusJudul": "{{n}} calon prospek menunggu keputusan",
  "k1.tugas.putusKeterangan": "Datanya lengkap; bot menunggu Terima atau Tolak",
  "k1a.judul": "Kesiapan bot {{nama}}",
  "k1a.judulTanpaNama": "Kesiapan bot",
  "k1a.keterangan": "Yang belum beres punya tautan ke tempat membereskannya.",
  "k1a.cincin": "{{beres}} dari {{jumlah}} beres",
  "k1a.tanda.beres": "Beres",
  "k1a.tanda.belum": "Belum beres",
  "k1a.bereskan": "Bereskan",
  "k1a.gagal": "Kesiapan bot tidak termuat",
  "k1a.persona.beres": "Persona bot diisi",
  "k1a.persona.belum": "Persona bot belum diisi",
  "k1a.pengetahuan.beres": "{{n}} dokumen Pengetahuan aktif",
  "k1a.pengetahuan.belum": "Belum ada dokumen aktif di Pengetahuan; bot tidak punya bahan untuk menjawab",
  "k1a.jadwal.beres": "Jadwal balas mingguan",
  "k1a.jadwal.selalu": "Bot membalas 24 jam, sesuai Jadwal balas",
  "k1a.jadwal.belum": "Jadwal balas belum diatur: bot membalas 24 jam, termasuk tengah malam",
  "k1a.tim.beres": "Semua tim sudah /join",
  "k1a.tim.belum": "{{n}} orang belum /join di Telegram",
  "k1a.grup.beres": "Grup Telegram tersambung",
  "k1a.grup.belum": "Grup Telegram belum tersambung; kabar untuk tim tidak sampai",
  "k1a.rantai.beres": "Rantai konten berjalan",
  "k1a.rantai.belum": "Sebagian rantai konten dimatikan",
  "k1a.slot": "Slot terbit {{n}} kali sehari",
  "percakapan.tanpaNama": "Tanpa nama",
  "percakapan.jenis.dm": "DM",
  "percakapan.jenis.comment": "Komentar",
  "percakapan.sebab.ai_kosong": "bot tidak punya jawabannya.",
  "percakapan.sebab.perlu_tim": "bot sudah menjawab, tetapi ini perlu orang.",
  "percakapan.sebab.di_luar_jam": "pesan masuk di luar jam chatbot.",
  "percakapan.sebab.chatbot_mati": "chatbot sedang dimatikan.",
  "percakapan.sebab.mode": "tenant ini belum Live, jadi bot tidak membalas.",
  "percakapan.sebab.tanpa_teks": "pesannya tanpa teks (foto, stiker, voice, atau story mention).",
  "percakapan.sebab.ai_gagal": "AI gagal menjawab.",
  "percakapan.sebab.gagal_kirim": "balasan bot gagal terkirim.",
  "percakapan.sebab.dipegang": "pesan ini masuk saat percakapan dipegang tim.",
  "percakapan.sebabLain": "bot tidak membalas pesan ini.",
  "k2.menunggu": "{{n}} percakapan menunggu staf",
  "k2.menungguSatu": "1 percakapan menunggu staf",
  "k2.tidakMenunggu": "Tidak ada yang menunggu staf",
  "k2.cari": "Cari percakapan",
  "k2.cariContoh": "Cari nama atau @akun",
  "k2.daftar": "Daftar percakapan",
  "k2.chip.dipegangSaya": "Anda memegang",
  "k2.chip.dipegang": "Dipegang {{nama}}",
  "k2.chip.dipegangTim": "Dipegang tim",
  "k2.chip.lewat24": "Lewat 24 jam",
  "k2.chip.menunggu": "Bot menyerah",
  "k2.chip.perluOrang": "Perlu orang",
  "k2.chip.bot": "Dijawab bot",
  "k2.tidakCocok": "Tidak ada yang cocok",
  "k2.tidakCocokIsi": "Tidak ada percakapan untuk “{{kata}}”.",
  "k2.hapusCari": "Hapus pencarian",
  "k2.kosongJudul": "Kotak masuk bersih",
  "k2.kosongIsi": "Percakapan yang diserahkan bot akan muncul di sini.",
  "k2.kosongRingkas": "Belum ada percakapan.",
  "k2.sebagian": "Menampilkan {{n}} dari {{total}} percakapan. Persempit dengan pencarian.",
  "k3.semua": "Semua",
  "k3.gagal": "Prospek tidak termuat",
  "k3.kosongJudul": "Belum ada prospek",
  "k3.kosongIsi": "Prospek muncul di sini begitu jadwal meetingnya mulai diatur. Yang masih dilayani bot ada di Calon prospek.",
  "k3.baru.buka": "Prospek baru",
  "k3.baru.judul": "Prospek baru",
  "k3.baru.ket": "Untuk prospek dari luar percakapan: pameran, telepon, rujukan. Semua isian wajib, karena tidak ada bot yang akan menanyakannya.",
  "k3.baru.perusahaan": "Nama perusahaan",
  "k3.baru.alamat": "Alamat perusahaan",
  "k3.baru.pic": "Nama PIC",
  "k3.baru.email": "Email PIC",
  "k3.baru.telepon": "Telepon PIC",
  "k3.baru.simpan": "Tambah prospek",
  "k3.baru.toast": "{{nama}} ditambahkan",
  "k3.dikelola": "{{n}} prospek dikelola",
  "k3.tindakLanjutN": "{{n}} perlu tindak lanjut",
  "k3.cari": "Cari prospek",
  "k3.cariContoh": "Cari nama atau PIC",
  "k3.jalur": "Tahap prospek",
  "k3.keCalon": "Masih dilayani bot",
  "k3.semuaKet": "Yang sedang dikelola",
  "k3.tahap.jadwal": "Mengatur jadwal",
  "k3.tahap.terjadwal": "Meeting terjadwal",
  "k3.tahap.tindakLanjut": "Perlu tindak lanjut",
  "k3.tahap.selesai": "Selesai",
  "k3.tahapKet.jadwal": "Jamnya sedang dicari",
  "k3.tahapKet.terjadwal": "Sudah ada tanggalnya",
  "k3.tahapKet.tindakLanjut": "Menunggu Anda",
  "k3.selesaiKet": "{{jadi}} jadi · {{tidak}} tidak lanjut",
  "k3.hasil.jadi": "Jadi pelanggan",
  "k3.hasil.tidak": "Tidak lanjut",
  "k3.daftar": "Daftar prospek",
  "k3.tahapKosong": "Tidak ada prospek di tahap ini",
  "k3.cariKosong": "Tidak ada yang cocok dengan “{{kata}}”",
  "k3.kolom.prospek": "Prospek",
  "k3.kolom.tahap": "Tahap",
  "k3.kolom.meeting": "Meeting",
  "k3.kolom.langkah": "Langkah berikutnya",
  "k3.kolom.dipegang": "Dipegang",
  "k3.kolom.aktif": "Aktif terakhir",
  "k3.meeting.jumlah": "{{n}} meeting",
  "k3.meeting.belumBertanggal": "Belum bertanggal",
  "k3.meeting.belum": "Belum ada",
  "k3.langkah.tutupMeeting": "Tutup meeting {{kapan}}",
  "k3.langkah.jadwalkanLanjutan": "Jadwalkan meeting lanjutan",
  "k3.langkah.tunjukPeserta": "Tunjuk peserta meetingnya",
  "k3.langkah.hadir": "Hadir di meeting",
  "k3.langkah.isiTanggal": "Isi tanggal meetingnya",
  "k3.langkah.botMenawarkan": "Bot sedang menawarkan jadwal",
  "k3.langkah.tambahMeeting": "Jadwalkan meeting pertamanya",
  "k3.langkahKet.tutupMeeting": "lalu jadwalkan lanjutannya",
  "k3.langkahKet.jadwalkanLanjutan": "atau tutup prospeknya",
  "k3.langkahKet.tunjukPeserta": "belum ada yang ditunjuk",
  "k3.langkahKet.hadir": "pesertanya sudah ditunjuk",
  "k3.langkahKet.isiTanggal": "ia minta jadwal di luar pilihan bot",
  "k3.langkahKet.botMenawarkan": "menunggu jawabannya",
  "k3.langkahKet.tambahMeeting": "diisi tim, tanpa percakapan",
  "k3.belumDipegang": "Belum ada",
  "k3.kaki": "{{n}} prospek · yang menunggu Anda di atas",
  "k3.langkah.botMelengkapi": "Bot melengkapi datanya dulu",
  "k3.langkahKet.botMelengkapi": "diterima tim sebelum datanya lengkap",
  "k3.langkah.botAkanMenawarkan": "Bot menawarkan meeting begitu ia membalas",
  "k3.langkahKet.botAkanMenawarkan": "sudah diterima tim",
  "k4.remah": "Remah",
  "k4.gagal": "Prospek tidak termuat",
  "k4.tidakAda": "Prospek ini tidak ditemukan",
  "k4.bukaPercakapan": "Buka percakapan",
  "k4.dataJudul": "Data prospek",
  "k4.dataKet": "Diisi bot dari percakapan. Tim boleh melengkapinya.",
  "k4.dataPensiun": "Pertanyaan yang tidak lagi dikumpulkan",
  "k4.dataTidakLagi": "tidak lagi dikumpulkan",
  "k4.catatanJudul": "Semua catatan",
  "k4.catatanKet": "Yang ditulis tentang {{nama}}, yang terbaru di atas.",
  "k4.catatanKosong": "Belum ada catatan.",
  "k4.catatanBaru": "Catatan baru",
  "k4.catatanContoh": "Apa yang terjadi? Misalnya: telepon, proposal dikirim, kunjungan",
  "k4.catatanTambah": "Tambah catatan",
  "k4.toast.catatan": "Catatan ditambahkan",
  "k4.percakapanJudul": "Percakapan terakhir",
  "k4.percakapanGagal": "Percakapan tidak termuat",
  "k4.percakapanKosong": "Belum ada pesan.",
  "k4.bukaDiPerluDijawab": "Buka di Perlu dijawab",
  "k4.botJudul": "Bot untuk prospek ini",
  "k4.botKet": "Matikan saat tim memegang percakapan ini sendiri.",
  "k4.botLabel": "Bot membalas prospek ini",
  "k4.botNyala": "Bot membalas pesannya. Mematikannya menjadikan Anda pemegang percakapannya.",
  "k4.botMati": "Bot diam untuk orang ini; tim yang membalas. Menyalakannya melepas percakapannya ke bot.",
  "k4.meetingBelum": "Belum ada meeting dengan {{nama}}.",
  "k4.dataKurangJudul": "Lengkapi dulu data prospeknya",
  "k4.dataKurang": "Masih kosong: {{daftar}}. Meeting baru bisa dijadwalkan sesudah itu.",
  "k4.dataKurangKe": "Lengkapi di tab Ringkasan",
  "k4.jadwalBaru": "Jadwal meeting",
  "k4.jadwalUbah": "Ubah jadwal",
  "k4.tanggal": "Tanggal",
  "k4.jam": "Jam",
  "k4.bentuk": "Bentuk",
  "k4.tautan": "Tautan meeting",
  "k4.tempat": "Tempat",
  "k4.agenda": "Agenda",
  "k4.agendaIsi": "Agenda: {{isi}}",
  "k4.jadwalkan": "Jadwalkan",
  "k4.jadwalSimpan": "Simpan jadwal",
  "k4.jadwalKet": "Jamnya jam tenant. Tim dikabari di grup Telegram; prospek tidak dikabari otomatis.",
  "k4.koreksi": "Ini koreksi catatan: meetingnya sudah berlangsung di waktu yang saya tulis.",
  "k4.koreksiKet": "Jam lamanya sudah lewat. Koreksi tidak mengabari siapa pun.",
  "k4.tetapJadwalkan": "Tetap jadwalkan, walau harinya penuh atau jamnya bentrok.",
  "k4.tetapJadwalkanKet": "Tercatat di Aktivitas sebagai jadwal yang sengaja ditembus.",
  "k4.toast.jadwalBaru": "Meeting dijadwalkan",
  "k4.toast.jadwalUbah": "Jadwal disimpan",
  "k4.catatanMeeting": "Catatan meeting",
  "k4.catatanMeetingSimpan": "Simpan catatan",
  "k4.toast.catatanMeeting": "Catatan meeting disimpan",
  "k4.rekamanMeeting": "Rekaman meeting {{kapan}}",
  "k4.rekamanTanpaRingkasan": "Ringkasannya tidak ada; transkripnya tersimpan.",
  "k4.transkripLihat": "Lihat transkrip",
  "k4.rekamanHapus": "Hapus rekaman",
  "k4.rekamanHapusTanya": "Hapus {{judul}}?",
  "k4.rekamanHapusKet": "Ringkasan dan transkripnya ikut terhapus dan tidak bisa dikembalikan.",
  "k4.toast.rekamanHapus": "Rekaman dihapus",
  "k4.rekamanUnggah": "Unggah rekaman",
  "k4.rekamanMengunggah": "Mengunggah dan meringkas…",
  "k4.rekamanUnggahKet": "Berkas audio, maksimal {{mb}} MB. Ditambahkan ke rekaman yang sudah ada.",
  "k4.toast.rekamanUnggah": "Rekaman ditambahkan",
  "k4.tab.label": "Bagian detail prospek",
  "k4.tab.ringkasan": "Ringkasan",
  "k4.tab.meeting": "Meeting & rekaman",
  "k4.tab.percakapan": "Percakapan",
  "k4.tab.catatan": "Catatan",
  "k4.posisi.judul": "Posisi sekarang",
  "k4.posisi.ket": "Diambil dari meeting terakhir, supaya tidak perlu membaca semua rekamannya.",
  "k4.posisi.terakhir": "Meeting terakhir",
  "k4.posisi.hasil": "Hasilnya",
  "k4.posisi.berikutnya": "Berikutnya",
  "k4.posisi.keadaan.perluDitutup": "sudah lewat, belum ditutup",
  "k4.posisi.keadaan.selesai": "selesai",
  "k4.posisi.keadaan.tidakHadir": "prospek tidak hadir",
  "k4.posisi.rekaman": "{{n}} rekaman",
  "k4.posisi.belumAda": "Belum ada meeting yang berlangsung.",
  "k4.posisi.hasilKosong": "Belum ada catatan atau rekaman. Tulis catatannya di tab Meeting & rekaman.",
  "k4.posisi.dariCatatan": "Dari catatan meeting yang ditulis tim.",
  "k4.posisi.dariRekaman": "Dari ringkasan rekamannya, ditulis otomatis.",
  "k4.posisi.kapan": "{{hari}} {{jam}}",
  "k4.posisi.tanpaPeserta": "belum ada peserta",
  "k4.posisi.menunggu": "Ada permintaan meeting yang belum bertanggal.",
  "k4.posisi.belumBerikut": "Belum ada meeting berikutnya.",
  "k4.posisi.lihat": "Lihat meeting & rekaman",
  "k4.berikut.judul": "Meeting berikutnya",
  "k4.berikut.belum": "Belum dijadwalkan.",
  "k4.berikut.buka": "Buka meeting ini",
  "k4.berikut.isiTanggal": "Isi tanggalnya",
  "k4.tambahMeeting": "Tambah meeting",
  "k4.meetingBaru": "Meeting baru dengan {{nama}}",
  "k4.meetingPertama": "Meeting pertama",
  "k4.meetingKe": "Meeting ke-{{n}}",
  "k4.meetingSaja": "Meeting",
  "k4.daftar.judul": "{{n}} meeting dengan {{nama}}",
  "k4.daftar.ket": "Tiap kartu memuat jadwal, catatan, dan rekaman meetingnya.",
  "k4.keadaan.selesai": "Selesai",
  "k4.keadaan.tidakHadir": "Tidak hadir",
  "k4.keadaan.batal": "Dibatalkan",
  "k4.tertutup": "{{meeting}} · {{kapan}}",
  "k4.tutup.tanya": "Meeting ini sudah lewat. Bagaimana hasilnya?",
  "k4.tutup.ket": "Menutupnya hanya mencatat di sini; tidak ada yang dikabari.",
  "k4.tutup.selesai": "Tandai selesai",
  "k4.tutup.tidakHadir": "Prospek tidak hadir",
  "k4.tutup.jadiSelesai": "Ubah jadi selesai",
  "k4.tutup.jadiTidakHadir": "Ubah jadi tidak hadir",
  "k4.toast.selesai": "Meeting ditandai selesai",
  "k4.toast.tidakHadir": "Meeting ditandai tidak hadir",
  "k4.catatanUbah": "Ubah catatan",
  "k4.catatanTulis": "Tulis catatan",
  "k4.rekaman.judul": "Rekaman ({{n}})",
  "k4.rekaman.kosong": "Belum ada rekaman. Balas pesan meeting di grup Telegram dengan voice note, atau unggah di sini.",
  "k4.selengkapnya": "Selengkapnya",
  "k4.ringkasLagi": "Ringkas lagi",
  "k4.transkrip.judul": "Transkrip",
  "k4.transkrip.isi": "Isi transkrip",
  "k4.transkrip.ket": "{{rekaman}} · meeting {{kapan}}",
  "k4.transkrip.salin": "Salin transkrip",
  "k4.transkrip.disalin": "Transkrip disalin",
  "k4.transkrip.gagalSalin": "Tidak bisa menyalin. Pilih teksnya lalu salin sendiri.",
  "k4.percakapanTanpa": "Prospek ini tidak punya percakapan",
  "k4.percakapanTanpaKet": "Datanya diisi tim, bukan dari pesan yang masuk ke bot.",
  "k4.langkah.label": "Sampai mana prospek ini",
  "k4.langkah.sudah": ", sudah dilewati",
  "k4.langkah.kini": ", tahap sekarang",
  "k4.akhiri.judul": "Tutup prospek",
  "k4.akhiri.judulCalon": "Sisihkan calon ini",
  "k4.akhiri.judulSudah": "Sudah ditutup",
  "k4.akhiri.judulDini": "Putuskan sekarang",
  "k4.akhiri.ketDini": "Datanya belum lengkap. Terima sekarang kalau tim sudah yakin, atau sisihkan kalau memang bukan calon pelanggan.",
  "k4.akhiri.ketProspek": "Kalau sudah ada keputusannya. Tidak ada yang dikabari, dan bisa dibuka lagi.",
  "k4.akhiri.ketCalon": "Kalau memang bukan calon pelanggan. Bot tetap menjawab pertanyaan umumnya.",
  "k4.akhiri.sudah.jadi": "Ditutup sebagai pelanggan.",
  "k4.akhiri.sudah.tidak": "Ditutup: tidak lanjut.",
  "k4.akhiri.sudah.disisihkan": "Calon ini disisihkan.",
  "k4.akhiri.bukaLagi": "Buka lagi",
  "k4.akhiri.toast.jadi": "{{nama}} ditutup sebagai pelanggan",
  "k4.akhiri.toast.tidak": "{{nama}} tidak dilanjutkan",
  "k4.akhiri.toast.buka": "{{nama}} dibuka lagi",
  "k4.putus.judul": "Keputusan",
  "k4.putus.ket": "Datanya sudah lengkap. Bot menunggu keputusan tim sebelum menawarkan meeting.",
  "k5.terjadwal": "{{n}} meeting terjadwal",
  "umum.dan": "dan",
  "k6.buat": "Buat konten",
  "k7.gagal": "Konten tidak termuat",
  "k7.tidakAda": "Konten ini tidak ditemukan",
  "k7.hapusTanya": "Hapus konten ini permanen?",
  "k7.hapusKet": "Konten dan angkanya hilang dari Smova. Postingan yang sudah terbit di Instagram atau Facebook tidak ikut terhapus.",
  "k7.hapusYa": "Hapus permanen",
  "k7.toastHapus": "“{{judul}}” dihapus",
  "k7.jamLain": "Jam lain…",
  "k7.ubahJadwal": "Ubah jadwal",
  "k7.batalJadwal": "Batalkan jadwal",
  "k7.toastBatalJadwal": "Jadwal dibatalkan. Konten kembali jadi draf.",
  "k7.arah.produk.dari": "Ditulis dengan produk, dari Pengetahuan: {{daftar}}.",
  "k7.arah.produk.tanpaBahan": "Diminta dengan produk, tetapi tidak ada dokumen Pengetahuan yang cocok dengan topiknya. Ditulis umum.",
  "k7.arah.iklan.dari": "Iklan produk, ditulis dari Pengetahuan: {{daftar}}.",
  "k7.arah.iklan.tanpaBahan": "Diminta iklan produk, tetapi dokumen Pengetahuannya tidak ada atau sudah dimatikan. Ditulis umum.",
  "k7.teks.judul": "Teks",
  "k7.teks.ket": "Caption, hashtag, dan pesan kunci yang terbit.",
  "k7.teks.terbitKet": "Yang sudah tayang tidak bisa diubah dari Smova.",
  "k7.teks.terjadwalKet": "Jam terbitnya sudah tiba, jadi teksnya tidak bisa diubah lagi.",
  "k7.teks.ketTerjadwal": "Sudah terjadwal. Masih bisa diubah sampai jam terbitnya.",
  "k7.teks.caption": "Caption",
  "k7.teks.tagar": "Hashtag",
  "k7.teks.pesan": "Pesan kunci",
  "k7.teks.tagarKet": "Pisahkan dengan spasi. Tanda # boleh ditulis atau tidak.",
  "k7.teks.hitungan": "{{n}} / {{batas}} karakter",
  "k7.jadwal.judul": "Jadwal",
  "k7.jadwal.belum": "Belum dijadwalkan",
  "k7.jadwal.belumKet": "Pilih jam terbit dan platformnya.",
  "k7.jadwal.usulan": "Usulan {{jam}}",
  "k7.jadwal.usulanKet": "Jam dari slot otomatis. Terbit sendiri sesudah disetujui.",
  "k7.jadwal.konsepUsulanKet": "Gambar dibuat sesudah konsep disetujui, lalu menunggu persetujuan gambar.",
  "k7.jadwal.konsepKet": "Gambar dibuat sesudah konsep disetujui. Jamnya dipilih sesudah konten siap.",
  "k7.jadwal.drafKet": "Buat gambar dulu, lalu jadwalkan.",
  "k7.jadwal.ditolakKet": "Konten ini tidak akan terbit.",
  "k7.platform.label": "Tambah platform",
  "k7.platform.tambah": "Tambah {{nama}}",
  "k7.platform.tanya": "Tambah {{nama}} ke konten ini?",
  "k7.platform.ket": "{{nama}} memakai teks dan gambar yang sama, dan mengikuti konten ini: menunggu, terjadwal, atau terbit bersama platform lainnya.",
  "k7.platform.ketTerjadwal": "{{nama}} ikut terbit {{jam}}, dengan teks dan gambar yang sama.",
  "k7.platform.ya": "Tambah {{nama}}",
  "k7.platform.toast": "{{nama}} ditambahkan ke konten ini",
  "k7.platform.terbitJuga": "Terbitkan juga ke {{nama}}",
  "k7.platform.tanyaTerbit": "Terbitkan konten ini ke {{nama}} sekarang?",
  "k7.platform.ketTerbit": "Konten ini sudah tayang. {{nama}} memakai teks dan gambar yang sama dan langsung terbit sekarang; yang sudah terbit tidak bisa ditarik dari Smova.",
  "k7.platform.yaTerbit": "Terbitkan ke {{nama}}",
  "k7.platform.toastTerbit": "Terbit ke {{nama}}",
  "k7.platform.toastGagal": "{{nama}} gagal terbit. Sebabnya tertulis di kartu Jadwal.",
  "k7.angka.judul": "Angka per platform",
  "k7.angka.ket": "Tidak dijumlahkan antar-platform.",
  "k7.angka.diambil": "Diambil {{waktu}}",
  "k7.angka.belum": "Angkanya belum pernah diambil",
  "k7.angka.segarkan": "Segarkan angka {{nama}}",
  "k7.angka.toast": "Angka {{nama}} diperbarui",
  "k7.angka.lihat": "Lihat postingan {{nama}}",
  "k7.gambar.judul": "Gambar",
  "k7.gambar.judulKonsep": "Konsep gambar",
  "k7.gambar.ketKonsep": "Gambarnya dibuat saat konsep disetujui.",
  "k7.gambar.ketSatu": "Satu slide · maksimal 10 slide untuk carousel",
  "k7.gambar.ketSlide": "{{n}} slide · maksimal 10 slide untuk carousel",
  "k7.gambar.slide": "Slide",
  "k7.gambar.slideKe": "Slide {{n}}",
  "k7.gambar.prompt": "Prompt yang dipakai",
  "k7.gambar.tanpaPrompt": "Prompt gambarnya tidak tersimpan.",
  "k7.gambar.regenerate": "Regenerate gambar",
  "k7.gambar.buat": "Buat gambar",
  "k7.gambar.editPrompt": "Edit prompt",
  "k7.gambar.unggah": "Unggah gambar",
  "k7.gambar.arahan": "Arahan untuk gambarnya",
  "k7.gambar.arahanContoh": "Contoh: logonya kecilin, warnanya lebih cerah",
  "k7.gambar.arahanKetKonsep": "AI menulis ulang prompt-nya. Gambarnya dibuat saat konsep disetujui.",
  "k7.gambar.arahanKet": "AI menulis ulang prompt-nya, lalu membuat gambar baru (berbayar).",
  "k7.gambar.perbaruiPrompt": "Perbarui prompt",
  "k7.gambar.buatBaru": "Buat gambar baru",
  "k7.gambar.berbayar": "Regenerate dan Edit prompt membuat gambar baru, dan itu berbayar.",
  "k7.gambar.toastPrompt": "Prompt diperbarui. Gambarnya dibuat saat konsep disetujui.",
  "k7.gambar.toastBaru": "Gambar baru dibuat",
  "k7.gambar.toastUnggah": "Gambar diganti",
  "k6.gagal": "Konten tidak termuat",
  "k6.tanpaJudul": "Konten tanpa judul",
  "k6.dibuang": "yang menunggu {{n}} hari dibuang",
  "k6.tidakDibuang": "yang menunggu tidak dibuang",
  "k6.tab.label": "Bagian Konten",
  "k6.tab.menunggu": "Menunggu Anda",
  "k6.tab.terjadwal": "Terjadwal",
  "k6.tab.tayang": "Sudah tayang",
  "k6.tab.bahan": "Bahan",
  "k6.urut.label": "Urutan",
  "k6.urut.menunggu.mendesak": "Paling mendesak",
  "k6.urut.menunggu.terbaru": "Dibuat terbaru",
  "k6.urut.menunggu.terlama": "Dibuat terlama",
  "k6.urut.terjadwal.terdekat": "Terbit terdekat",
  "k6.urut.terjadwal.terjauh": "Terbit terjauh",
  "k6.urut.tayang.terbaru": "Tayang terbaru",
  "k6.urut.tayang.terlama": "Tayang terlama",
  "k6.kosong.menungguJudul": "Tidak ada yang menunggu",
  "k6.kosong.menungguIsi": "Konten muncul di sini saat konsep atau gambar selesai disusun, dan saat ada yang gagal terbit.",
  "k6.kosong.terjadwalJudul": "Belum ada yang terjadwal",
  "k6.kosong.terjadwalIsi": "Konten yang sudah dijadwalkan muncul di sini sampai terbit.",
  "k6.kosong.tayangJudul": "Belum ada yang tayang",
  "k6.kosong.tayangIsi": "Konten yang terbit dalam 30 hari terakhir muncul di sini, dengan angkanya.",
  "k6.tayangKet": "Angka tiap platform ditampilkan terpisah, tidak dijumlahkan.",
  "k6.status.konsep": "Konsep menunggu",
  "k6.status.siap": "Konten siap",
  "k6.status.menunggu": "Konten menunggu",
  "k6.status.gagal": "Gagal terbit",
  "k6.status.gagalDi": "Gagal terbit · {{daftar}}",
  "k6.status.gambarGagal": "Gambar gagal dibuat",
  "k6.status.draf": "Draf",
  "k6.status.terjadwal": "Terjadwal",
  "k6.status.terbit": "Terbit",
  "k6.status.ditolak": "Ditolak",
  "k6.poster.konsep": "Konsep · belum ada gambar",
  "k6.poster.prompt": "Prompt gambar: {{isi}}",
  "k6.poster.tanpaPrompt": "Prompt gambarnya belum ditulis.",
  "k6.poster.kosong": "Belum ada gambar",
  "k6.gambar": "Gambar konten {{judul}}",
  "k6.belumDijadwalkan": "belum dijadwalkan",
  "k6.terbitPada": "Terbit {{jam}}",
  "k6.tidakDipakai": "{{nama}} tidak dipakai",
  "k6.asal.otomatis": "Dari pencarian otomatis",
  "k6.asal.telegram": "Dibuat lewat Telegram",
  "k6.asal.smova": "Dibuat lewat Smova",
  "k6.tolak": "Tolak",
  "k6.setujuiKonsep": "Setujui konsep",
  "k6.jadwalkan": "Jadwalkan…",
  "k6.setujuiJam": "Setujui · {{jam}}",
  "k6.buang": "Buang",
  "k6.cobaLagi": "Coba lagi",
  "k6.buangTanya": "Buang konten ini dari antrean?",
  "k6.buangKet": "Yang gagal tidak dicoba lagi.",
  "k6.buangKetSudah": "Yang sudah terbit di {{daftar}} tidak ikut terhapus. Yang gagal tidak dicoba lagi.",
  "k6.toast.ditolak": "“{{judul}}” ditolak",
  "k6.toast.konsep": "Konsep disetujui. Kontennya menunggu di Menunggu Anda.",
  "k6.toast.disetujui": "Disetujui · terbit {{jam}}",
  "k6.toast.dibuang": "“{{judul}}” dibuang dari antrean",
  "k6.toast.cobaLagi": "Dicoba lagi. Penerbit mengambilnya dalam 10 menit.",
  "k6.toast.dijadwalkan": "Dijadwalkan {{jam}} · {{daftar}}",
  "k6.toast.terbit": "Terbit ke {{daftar}}",
  "k6.toast.sebagianGagal": "{{terbit}} terbit, {{gagal}} gagal. Yang gagal ada di Menunggu Anda.",
  "k6.angka.jangkauan": "Jangkauan",
  "k6.angka.suka": "Suka",
  "k6.angka.disimpan": "Disimpan",
  "k6.angka.dibagikan": "Dibagikan",
  "k6.jadwal.judul": "Jadwalkan “{{judul}}”",
  "k6.jadwal.jam": "Jam terbit",
  "k6.jadwal.slotKosong": "Slot kosong",
  "k6.jadwal.lain": "Jam lain",
  "k6.jadwal.lainKet": "Pilih sendiri",
  "k6.jadwal.tanggalJam": "Tanggal & jam",
  "k6.jadwal.zona": "Zona waktu tenant: {{zona}}.",
  "k6.jadwal.platform": "Platform",
  "k6.jadwal.minimalSatu": "Centang minimal satu platform.",
  "k6.jadwal.dilepas": "{{daftar}} tidak dipakai untuk konten ini.",
  "k6.jadwal.sekarang": "Upload sekarang",
  "k6.jadwal.sekarangTanya": "Konten ini langsung terbit sekarang",
  "k6.jadwal.sekarangKet": "Ke {{daftar}}. Tidak bisa ditarik dari Smova.",
  "k6.jadwal.sekarangYa": "Ya, upload sekarang",
  "k6.jadwal.jadwalkan": "Jadwalkan",
  "k6.bahan.judul": "Bahan dari pencarian",
  "k6.bahan.ket": "Dicari otomatis dari sumber yang diatur Tenant Admin.",
  "k6.bahan.matiJudul": "Cari bahan sedang dimatikan",
  "k6.bahan.matiKet": "Tidak ada bahan baru yang masuk sampai Tenant Admin menyalakannya lagi.",
  "k6.bahan.cari": "Cari sekarang",
  "k6.bahan.toastCari": "Pencarian bahan dimulai. Hasilnya muncul di sini beberapa menit lagi.",
  "k6.bahan.gagal": "Bahan tidak termuat",
  "k6.bahan.kosongJudul": "Belum ada bahan",
  "k6.bahan.kosongIsi": "Bahan muncul di sini sesudah pencarian berikutnya berjalan.",
  "k6.bahan.jadiKonsep": "Jadi konsep",
  "k6.bahan.jadikan": "Jadikan konten",
  "k6.bahan.dibuatKonten": "Sudah dibuat konten",
  "k6.bahan.dibuatKontenN": "Sudah dibuat {{n}} konten",
  "k6.bahan.jadikanDari": "Jadikan konten dari {{judul}}",
  "k5.gagal": "Meeting tidak termuat",
  "k5.kosongJudul": "Belum ada meeting terjadwal",
  "k5.kosongIsi": "Meeting muncul di sini begitu bot atau tim menjadwalkannya dengan prospek.",
  "k5.baris": "Meeting dengan {{nama}}",
  "k5.tanpaNama": "Tanpa nama usaha",
  "k5.belumBertanggalN": "{{n}} belum bertanggal",
  "k5.belumBertanggal": "Belum bertanggal",
  "k5.tanpaTanggal": "Tanggal belum diisi",
  "k5.tanpaTanggalKet": "Prospek minta jadwal di luar pilihan bot. Hubungi prospek, lalu isi tanggalnya.",
  "k5.isiTanggal": "Isi tanggal",
  "k5.peserta": "Peserta: {{daftar}}",
  "k5.pesertaBelum": "belum ada",
  "k5.tanpaPeserta": "Belum ada peserta. Pilih siapa yang ikut.",
  "k5.bentrok": "{{daftar}} izin di tanggal ini. Ganti pesertanya.",
  "k5.aturPeserta": "Atur peserta",
  "k5.pilihPeserta": "Pilih peserta",
  "k5.pilihKet": "Orang yang izin di tanggal ini tidak bisa dipilih. Izin diatur masing-masing di Meeting.",
  "k5.tidakIkut": "tidak ikut meeting",
  "k5.pesertaLain": "Peserta lain",
  "k5.tanpaAkun": "tanpa akun Smova",
  "k5.akunNonaktif": "akun nonaktif",
  "k5.lainKet": "Mereka tidak ada di daftar tim, jadi tidak bisa dicentang di atas. Mereka tetap peserta; lepas centangnya untuk mengeluarkan.",
  "k5.izinTanggal": "izin {{tanggal}}",
  "k5.simpanPeserta": "Simpan peserta",
  "k5.gagalTim": "Daftar tim tidak termuat.",
  "k5.batal": "Batalkan meeting",
  "k5.batalTanya": "Batalkan meeting dengan {{nama}}?",
  "k5.batalKet": "Tim dikabari di grup Telegram. Prospek tidak dikabari otomatis; kabari lewat chat.",
  "k5.batalKetDiam": "Prospek tidak dikabari otomatis; kabari lewat chat.",
  "k5.toast.batalDiam": "Meeting dengan {{nama}} dibatalkan.",
  "k5.toast.batal": "Meeting dengan {{nama}} dibatalkan. Tim dikabari di grup Telegram.",
  "k5.toast.peserta": "Peserta disimpan",
  "k5.izinJudul": "Tanggal saya izin",
  "k5.izinKet": "Di tanggal ini Anda tidak bisa dipilih jadi peserta. Bot tetap menawarkan tanggal itu selama masih ada anggota tim lain yang bisa.",
  "k5.izinKosong": "Belum ada.",
  "k5.izinDaftar": "Tanggal izin Anda",
  "k5.izinHapus": "Hapus izin {{tanggal}}",
  "k5.izinTanggalLabel": "Tanggal izin",
  "k5.izinTambah": "Tambah izin",
  "k5.gagalIzin": "Tanggal izin tidak termuat",
  "k5.toast.izinTambah": "Izin {{tanggal}} dicatat",
  "k5.toast.izinHapus": "Izin {{tanggal}} dihapus",
  "prospek.tanpaNama": "Belum bernama",
  "prospek.picBelum": "PIC belum diketahui",
  "prospek.diisiTim": "Diisi tim",
  "prospek.kelengkapan": "{{terisi}}/{{dari}} data terkumpul",
  "prospek.hariIni": "Hari ini",
  "k2.gagalDaftar": "Kotak masuk tidak termuat",
  "k2.gagalUtas": "Percakapan tidak termuat",
  "k2.utas": "Percakapan dengan {{nama}}",
  "k2.utasKosong": "Percakapan",
  "k2.sumberDm": "{{akun}} · DM {{platform}}",
  "k2.sumberKomentar": "Komentar {{platform}}",
  "k2.botDiam": "Bot diam",
  "k2.kembalikan": "Kembalikan ke bot",
  "k2.abaikan": "Tidak perlu dibalas",
  "k2.ambil": "Ambil alih",
  "k2.pesan": "Pesan",
  "k2.bot": "Bot",
  "k2.anda": "Anda",
  "k2.tim": "Tim",
  "k2.sebab": "Bot menyerahkan ke tim: {{sebab}}",
  "k2.dariAplikasi": "Dibalas dari aplikasi {{platform}}",
  "k2.balasan": "Balasan",
  "k2.tulis": "Tulis balasan…",
  "k2.tulisKomentar": "Tulis balasan komentar…",
  "k2.sedangDipegang": "Sedang dipegang {{nama}}",
  "k2.ambilDulu": "Ambil alih dulu untuk membalas",
  "k2.kirim": "Kirim",
  "k2.lewat24Judul": "Lewat 24 jam sejak pesan terakhir {{akun}}",
  "k2.lewat24Isi": "{{platform}} tidak mengizinkan balasan dari Smova lagi. Balas langsung di {{platform}}.",
  "k2.bukaPlatform": "Buka {{platform}}",
  "k2.tabBaru": "(tab baru)",
  "k2.drafTertahan": "Balasan yang belum terkirim",
  "k2.toast.ambil": "Anda memegang percakapan ini. Bot diam sampai dikembalikan.",
  "k2.toast.kembalikan": "Percakapan dikembalikan ke bot",
  "k2.toast.abaikan": "Ditandai tidak perlu dibalas",
  "k2.toast.terkirim": "Balasan terkirim lewat {{platform}}",
  "k2.toast.gagalKirim": "Balasan untuk {{nama}} tidak terkirim: {{sebab}}",
  "k2.toast.aksiGagal": "{{nama}}: {{sebab}}",
  "k2.toast.ambilNama": "Anda memegang percakapan {{nama}}. Bot diam sampai dikembalikan.",
  "k2.toast.kembalikanNama": "Percakapan {{nama}} dikembalikan ke bot",
  "menu.label": "Menu {{peran}}",
  "menu.kerja": "Kerja",
  "menu.pengaturan": "Pengaturan",
  "menu.operasi": "Operasi",
  "menu.dataInduk": "Data induk",
  "layar.B0": "Halaman depan",
  "layar.B1": "Masuk",
  "layar.K1": "Hari ini",
  "layar.K2": "Perlu dijawab",
  "layar.K3": "Prospek",
  "layar.K4": "Detail prospek",
  "layar.K5": "Meeting",
  "layar.K6": "Konten",
  "layar.K7": "Detail konten",
  "layar.K8": "Buat konten",
  "layar.P1": "Chatbot",
  "layar.P2": "Aturan meeting",
  "layar.P3": "Konten otomatis",
  "layar.P4": "Pengetahuan",
  "layar.P5": "Tim",
  "layar.P6": "Sambungan",
  "layar.P7": "Pemakaian",
  "layar.S1": "Ringkasan",
  "layar.S2": "Tenant",
  "layar.S3": "Tenant baru",
  "layar.S4": "Detail tenant",
  "layar.S5": "Jejak alur",
  "layar.S6": "Pemakaian",
  "layar.S7": "Katalog",
  "layar.S8": "Sistem",
  "layar.bagian": "Bagian {{nama}}",
  "layar.belumJudul": "Layar ini belum dibangun",
  "layar.belumKeterangan": "{{nama}} dikerjakan di tahap {{tahap}} rancang ulang. Alamat, peran, dan menunya sudah berlaku.",
  "layar.keTampilanLama": "Buka tampilan lama",
  "layar.K9": "Calon prospek",
  "tab.K4.ringkasan": "Ringkasan",
  "tab.K4.meeting": "Meeting & rekaman",
  "tab.K4.percakapan": "Percakapan",
  "tab.K4.catatan": "Catatan",
  "tab.K6.menunggu": "Menunggu Anda",
  "tab.K6.terjadwal": "Terjadwal",
  "tab.K6.sudah-tayang": "Sudah tayang",
  "tab.K6.bahan": "Bahan",
  "tab.P1.persona": "Persona & kebijakan",
  "tab.P1.data-prospek": "Data prospek",
  "tab.P1.jadwal-balas": "Jadwal balas",
  "tab.P1.model": "Model",
  "tab.P3.rantai": "Rantai & jadwal",
  "tab.P3.sumber": "Sumber & gaya",
  "tab.P3.referensi": "Referensi",
  "tab.P3.model": "Model",
  "tab.S4.ikhtisar": "Ikhtisar",
  "tab.S4.sambungan": "Sambungan",
  "tab.S4.orang": "Orang",
  "tab.S4.paket": "Paket & pagu",
  "tab.S4.aktivitas": "Aktivitas",
  "tab.S5.jalan": "Catatan jalan",
  "tab.S5.masuk": "Pesan masuk",
  "tab.S7.fitur": "Fitur",
  "tab.S7.model": "Model AI",
  "jaga.judul": "Perubahan belum disimpan",
  "jaga.akibat": "Kalau pindah sekarang, perubahan ini dibuang.",
  "jaga.perubahan": "{{n}} perubahan",
  "jaga.tetap": "Kembali ke formulir",
  "jaga.buang": "Buang dan pindah",
  "jaga.hanyaAdmin": "Halaman {{nama}} hanya untuk Tenant Admin. Anda dibawa ke Hari ini.",
  "jaga.tidakTersedia": "Halaman itu tidak tersedia untuk {{peran}}. Anda dibawa ke {{beranda}}.",
  "sesi.habisJudul": "Sesi Anda habis",
  "sesi.habisKeterangan": "Masuk lagi untuk melanjutkan. Perubahan yang belum disimpan tetap ada di halaman ini.",
  "sesi.masukLagi": "Masuk lagi",
  "sesi.sudahMasukLagi": "Anda masuk lagi.",
  "sesi.masukLagiAdaUbahan": "Anda masuk lagi. Perubahan yang belum disimpan masih ada.",
  "ui.pemberitahuan": "Pemberitahuan",
  "ui.urungkan": "Urungkan",
  "ui.dibatalkan": "Dibatalkan.",
  "ui.gagalDibatalkan": "Tidak bisa dibatalkan: {{sebab}}",
  "ui.tersimpan": "Tersimpan",
  "ui.langsungTersimpan": "Langsung tersimpan",
  "ui.terkunci": "Terkunci",
  "ui.saklarNyala": "{{nama}}: nyala",
  "ui.saklarMati": "{{nama}}: mati",
  "ui.saklarBatalNyala": "Dibatalkan. {{nama}}: nyala lagi.",
  "ui.saklarBatalMati": "Dibatalkan. {{nama}}: mati lagi.",
  "ui.semuaTersimpan": "Semua tersimpan",
  "ui.belumDisimpan": "{{n}} perubahan belum disimpan",
  "ui.tersimpanPukul": "Tersimpan pukul {{jam}}",
  "ui.batalkan": "Batalkan",
  "ui.disimpan": "{{judul}} disimpan",
  "ui.tidakTersimpan": "Tidak tersimpan",
  "ui.tabBerubah": "ada perubahan belum disimpan",
  "k8.ket": "Konten buatan Anda tidak perlu ditinjau lagi. Jamnya Anda pilih sendiri.",
  "k8.acuan.label": "Konten ini dibuat seperti",
  "k8.acuan.tanpa": "Tanpa referensi (atur sendiri)",
  "k8.acuan.ketTanpa": "Arah tulisan, jumlah slide, dan gambar brandnya Anda pilih di bawah, dan prompt gambarnya Anda tulis sendiri. Bingkai dan halaman penutup tidak dipakai.",
  "k8.acuan.judul": "Referensi",
  "k8.acuan.ketKartu": "Pilih dulu bentuk kontennya. Tulisan dan gambarnya mengikuti pilihan ini.",
  "k8.acuan.hasil.video": "Hasil: 1 video",
  "k8.acuan.hasil.satu": "Hasil: 1 gambar, dibuat AI",
  "k8.acuan.hasil.banyak": "Hasil: carousel {{n}} slide, semuanya dibuat AI",
  "k8.acuan.hasil.penutup": "Hasil: carousel {{n}} slide ({{ai}} dibuat AI + halaman penutup)",
  "k8.acuan.tulisan": "Tulisan",
  "k8.acuan.gambar": "Gambar",
  "k8.acuan.tulisanKet.umum": "tanpa pengetahuan produk",
  "k8.acuan.tulisanKet.produk": "AI memilih satu produk yang cocok",
  "k8.acuan.tulisanKet.iklan": "produknya Anda pilih di Isi konten",
  "k8.acuan.tulisanKet.iklanKosong": "AI memilih produk yang paling cocok dengan judulnya",
  "k8.acuan.gambarKet.bingkai": "1080 × 1350 (4:5), berbingkai",
  "k8.acuan.gambarKet.polos": "Tanpa bingkai; ukurannya mengikuti model gambar",
  "k8.acuan.dipakai": "Gambar yang dipakai referensi ini",
  "k8.acuan.hilang": "Ada gambar referensi ini yang sudah tidak ada di pustaka, jadi tidak ikut. Tenant Admin bisa memperbaikinya di Konten otomatis.",
  "k8.acuan.diatur": "Isi referensi diatur Tenant Admin di Pengaturan › Konten otomatis.",
  "k8.acuan.sendiri": "Anda mengatur sendiri semuanya",
  "k8.dariBahan": "Dari bahan",
  "k8.bahanSudah": "Bahan ini sudah pernah dibuat konten. Anda tetap bisa membuat yang baru.",
  "k8.isi.judul": "Isi konten",
  "k8.isi.ket": "Teks yang ikut terbit.",
  "k8.isi.ketKe": "Yang terbit ke {{daftar}}.",
  "k8.isi.judulInternal": "Judul internal",
  "k8.isi.judulKet": "Hanya terlihat di Smova.",
  "k8.arah.label": "Arah tulisan AI",
  "k8.arah.umum": "Tanpa pengetahuan produk.",
  "k8.arah.produk": "AI membaca Pengetahuan dan mengaitkan tulisannya ke satu produk.",
  "k8.arah.iklan": "AI menulis iklan untuk produk di Pengetahuan yang paling cocok dengan judulnya.",
  "k8.arah.dari": "Tulisan AI terakhir memakai Pengetahuan: {{daftar}}.",
  "k8.arah.tanpaBahan": "Tidak ada dokumen Pengetahuan yang cocok dengan judul ini, jadi tulisan AI terakhir dibuat tanpa produk.",
  "k8.arah.ikut": "Arah tulisan:",
  "k8.arah.ikutKet": "mengikuti referensi",
  "k8.produk.label": "Produk yang diiklankan",
  "k8.produk.ket": "Daftarnya dari referensi. Caption ditulis dari dokumen produk ini di Pengetahuan.",
  "k8.produk.kosong": "Referensi ini belum punya daftar produk, jadi AI memilih produk yang paling cocok dengan judulnya.",
  "k8.isi.tulis": "Tulis dari judul",
  "k8.isi.tiga": "Tiga pilihan",
  "k8.isi.aiKet": "AI menulis caption, pesan kunci, dan hashtag dari judulnya.",
  "k8.isi.aiButuhJudul": "Isi judul internal dulu supaya AI bisa menulisnya.",
  "k8.isi.tanpaHasil": "AI tidak mengembalikan tulisan. Coba lagi.",
  "k8.isi.toastTulis": "Teks ditulis AI",
  "k8.isi.toastPilih": "Pilihan dipakai",
  "k8.isi.pilih": "Pilih satu",
  "k8.isi.sudut.masalah": "Mulai dari masalah",
  "k8.isi.sudut.angka": "Mulai dari angka",
  "k8.isi.sudut.cerita": "Mulai dari cerita orang",
  "k8.gambar.arahanContoh": "Contoh: pemilik kedai kopi membalas chat di ponsel, cahaya pagi",
  "k8.gambar.buatUlang": "Buat ulang",
  "k8.gambar.buatVideo": "Buat video",
  "k8.gambar.videoUlang": "Buat ulang video",
  "k8.gambar.berbayar": "Tiap gambar yang dibuat berbayar.",
  "k8.gambar.videoKet": "Membuat video dengan AI berbayar dan butuh 1 sampai 4 menit. Mengunggah video sendiri tidak berbayar.",
  "k8.gambar.toastBuat": "Gambar dibuat dari arahan Anda",
  "k8.gambar.toastVideo": "Video dibuat dari arahan Anda",
  "k8.gambar.butuhArahan": "Tulis arahannya dulu, atau isi caption-nya.",
  "k8.gambar.promptKosong": "AI tidak mengembalikan prompt untuk slide ini. Tulis prompt-nya di Atur lebih lanjut, atau coba lagi.",
  "k8.gambar.promptPanjang": "Prompt-nya lebih dari {{batas}} karakter. Pendekkan dulu.",
  "k8.gambar.tanpaHasil": "Server tidak mengembalikan hasilnya. Coba lagi.",
  "k8.gambar.alt": "Gambar slide {{n}}",
  "k8.gambar.ketAcuan": "Mengikuti referensi “{{nama}}”.",
  "k8.gambar.ketTanpa": "Anda yang menulis prompt-nya, atau unggah gambar sendiri.",
  "k8.gambar.ketTanpaVideo": "Anda yang menulis prompt-nya, atau unggah video sendiri.",
  "k8.gambar.buatN": "Buat {{n}} gambar",
  "k8.gambar.arahanBoleh": "(boleh kosong)",
  "k8.gambar.arahanKetAcuan": "AI menulis prompt tiap slide dari caption, referensi, dan arahan ini. Mau menulis prompt-nya sendiri? Buka “Atur lebih lanjut” di bawah.",
  "k8.gambar.unggahSendiri": "Unggah gambar sendiri",
  "k8.gambar.berbayarPenutup": "Tiap gambar yang dibuat berbayar. Halaman penutup tidak dibuat AI, jadi tidak ditagih.",
  "k8.gambar.belum": "Slide {{n}} belum dibuat",
  "k8.gambar.belumVideo": "Video belum dibuat",
  "k8.gambar.belumKetAcuan": "Dibuat AI mengikuti referensi, atau unggah sendiri.",
  "k8.gambar.belumKetTanpa": "Dibuat dari prompt Anda, atau unggah sendiri.",
  "k8.gambar.promptWajib": "Tulis dulu prompt gambarnya.",
  "k8.gambar.promptWajibAtauAi": "Tulis dulu prompt-nya, atau minta AI menulisnya.",
  "k8.gambar.toastBuatN": "{{n}} gambar dibuat mengikuti referensi",
  "k8.gambar.toastBuatPrompt": "Gambar dibuat dari prompt ini",
  "k8.prompt.label": "Prompt gambar",
  "k8.prompt.contoh": "Tulis gambar yang Anda inginkan. Contoh: kartu ucapan Selamat Idul Fitri, nuansa hijau muda",
  "k8.prompt.ket": "Kalimat ini dikirim apa adanya ke model gambar, bersama gambar brand yang dicentang. Tidak ada yang ditulis ulang AI.",
  "k8.prompt.ketVideo": "Kalimat ini dikirim apa adanya ke model video.",
  "k8.penutup.judul": "Halaman penutup",
  "k8.penutup.isi": "Gambar tetap dari referensi. Tidak dibuat AI, tidak berbayar, dan selalu menjadi slide terakhir.",
  "k8.penutup.isiKonten": "Gambar tetap dari referensi kontennya. Tidak diubah AI, dan tetap menjadi slide terakhir.",
  "k8.penutup.ket": "Gambarnya diganti Tenant Admin di Pengaturan › Konten otomatis › Pustaka gambar.",
  "k8.penutup.ketBuat": "Tidak ingin memakainya? Pilih referensi tanpa halaman penutup.",
  "k8.penutup.petak": "Slide {{n}}, halaman penutup, terkunci",
  "k8.penutup.keterangan": "Slide {{n}} · halaman penutup · tetap",
  "k8.gambar.dibuat": "Dibuat dengan {{model}} · {{biaya}}",
  "k8.gambar.dibuatTanpaTarif": "Dibuat dengan {{model}} · tarif belum diketahui",
  "k8.unggah.ket": "Unggahan: PNG, JPG, atau WEBP, paling besar {{maks}} MB.",
  "k8.unggah.terlaluBesar": "Berkasnya {{ukuran}} MB. Batasnya {{maks}} MB.",
  "k8.unggah.toast": "{{nama}} dipakai sebagai gambar",
  "k8.slide.tambah": "Tambah slide",
  "k8.slide.kiri": "Geser slide ke kiri",
  "k8.slide.kanan": "Geser slide ke kanan",
  "k8.slide.hapus": "Hapus slide {{n}}",
  "k8.slide.ketSatu": "Lebih dari satu slide menjadi carousel.",
  "k8.slide.ketBanyak": "Carousel {{n}} slide. Slide 1 yang terlihat di feed; tiap slide dibuat dan ditagih sendiri.",
  "k8.slide.maks": "Paling banyak {{n}} slide. Itu batas Instagram.",
  "k8.slide.ketAcuanSatu": "Satu gambar. Jumlahnya mengikuti referensi.",
  "k8.slide.ketAcuanBanyak": "Carousel {{n}} slide. Slide 1 yang terlihat di feed. Jumlahnya mengikuti referensi.",
  "k8.slide.ketLebih": "Referensi ini menggambar {{n}} slide. Slide lebihnya bisa dihapus.",
  "k8.ref.judul": "Referensi brand yang ikut",
  "k8.ref.kosong": "Belum ada referensi brand untuk tenant ini.",
  "k8.ref.gambarSaya": "Gambar saya",
  "k8.ref.tambah": "Tambah gambar saya",
  "k8.ref.judulTambahan": "Gambar tambahan untuk konten ini",
  "k8.ref.ketTambahan": "Misalnya foto produk atau tangkapan layar aplikasi. Dilihat AI sesudah gambar referensinya, dan tidak disimpan ke pustaka. Paling banyak {{n}}.",
  "k8.ref.tambahSendiri": "Tambah gambar sendiri",
  "k8.ref.buang": "Buang gambar saya ini",
  "k8.ref.ket": "Paling banyak {{n}}. Gambar Anda sendiri tidak disimpan dan hilang saat halaman ditutup.",
  "k8.ref.urutan": "Urutan referensi",
  "k8.ref.naik": "Naikkan {{nama}}",
  "k8.ref.turun": "Turunkan {{nama}}",
  "k8.ref.hilang": "Referensi yang sudah tidak ada",
  "k8.ref.terlaluBesar": "Gambarnya {{ukuran}} MB. Batasnya {{maks}} MB.",
  "k8.ref.tidakTerbaca": "Berkasnya tidak bisa dibaca.",
  "k8.ref.tanpaModel": "Tidak ada model gambar tenant ini yang menerima referensi. Lepaskan referensinya, atau minta Tenant Admin menambah model yang bisa.",
  "k8.ref.modelSalah": "Model yang dipilih tidak menerima referensi. Pilih {{model}}, atau lepaskan referensinya.",
  "k8.ref.rasioDiabaikan": "Dengan referensi, model ini mengabaikan pilihan rasio dan memakai bentuk bawaannya.",
  "k8.ref.tidakDilihat": "Referensi tidak dilihat AI penulis prompt, karena model teksnya tidak menerima gambar. Prompt-nya ditulis dari caption dan arahan saja.",
  "k8.lanjut.judul": "Atur lebih lanjut",
  "k8.lanjut.jenis": "Jenis",
  "k8.lanjut.foto": "Foto",
  "k8.lanjut.video": "Video",
  "k8.lanjut.jenisKet": "Mengganti jenis mengosongkan gambar yang sudah dibuat.",
  "k8.lanjut.videoKet": "Satu video per konten. Video tidak memakai gambar referensi: dibuat AI dari prompt-nya, atau diunggah sendiri.",
  "k8.lanjut.model": "Model",
  "k8.lanjut.modelBawaan": "Bawaan tenant",
  "k8.lanjut.modelBawaanKet": "Urut pilihan Tenant Admin. Yang berikutnya dipakai kalau yang pertama gagal.",
  "k8.lanjut.modelKosong": "Tenant Admin belum memilih model untuk jenis ini. Sistem memakai model bawaannya.",
  "k8.lanjut.tanpaTarif": "tarif belum diketahui",
  "k8.lanjut.rasio": "Rasio",
  "k8.lanjut.rasioBawaan": "Bawaan model · {{rasio}}",
  "k8.lanjut.rasioPenyedia": "ditentukan penyedia",
  "k8.lanjut.rasioIkut": "Tanpa rasio · mengikuti model dan referensi",
  "k8.lanjut.prompt": "Prompt",
  "k8.lanjut.promptSlide": "Prompt slide {{n}}",
  "k8.lanjut.promptContoh": "Kosongkan supaya AI yang menulisnya. Atau tulis sendiri gambar yang Anda inginkan untuk slide ini.",
  "k8.lanjut.promptHitung": "{{n}} / {{batas}} karakter",
  "k8.lanjut.promptKet": "Inilah yang dikirim ke model gambar. Sunting kalimatnya, lalu tekan tombol di bawah.",
  "k8.lanjut.tulis": "Minta AI menulis prompt-nya dulu",
  "k8.lanjut.tulisSemua": "Minta AI menulis prompt semua slide",
  "k8.lanjut.toastPrompt": "Prompt ditulis",
  "k8.lanjut.dikirim": "Lihat yang dikirim ke AI ({{n}} gambar dilampirkan)",
  "k8.lanjut.isi.prompt": "prompt",
  "k8.lanjut.isi.tambahan": "gambar tambahan",
  "k8.lanjut.isi.brand": "gambar brand",
  "k8.lanjut.isi.model": "model",
  "k8.lanjut.promptKetBingkai": "Bingkai tetap ditempel sesudahnya, jadi logo dan kontak tidak perlu disebut.",
  "k8.lanjut.buatDariPrompt": "Buat gambar dari prompt ini",
  "k8.lanjut.ulangDariPrompt": "Buat ulang dari prompt ini",
  "k8.lanjut.videoDariPrompt": "Buat video dari prompt ini",
  "k8.lanjut.videoUlangDariPrompt": "Buat ulang video dari prompt ini",
  "k8.lanjut.tulisUlang": "Minta AI menulis ulang prompt-nya",
  "k8.lanjut.rasioBingkai": "Ukuran 1080 × 1350 mengikuti bingkai referensinya.",
  "k8.ubah.judul": "Ubah gambar ini",
  "k8.ubah.contoh": "Tulis yang ingin diubah. Contoh: ganti latarnya jadi biru tua",
  "k8.ubah.ket": "Berbayar. Yang dikirim hanya gambar ini dan kalimat di atas.",
  "k8.ubah.takBisa": "Gambar ini tidak tersimpan di Smova, jadi tidak bisa diubah dengan arahan. Buat ulang, atau unggah lagi.",
  "k8.ubah.tombol": "Ubah",
  "k8.ubah.toast": "Gambar diubah",
  "k8.ubah.saranLabel": "Contoh perubahan",
  "k8.ubah.saran.judul": "Perbesar judulnya",
  "k8.ubah.saran.latar": "Ganti latarnya jadi biru tua",
  "k8.ubah.saran.teks": "Buang teks kecil di bawah judul",
  "k8.ubah.saran.utama": "Perbesar gambar utamanya",
  "k8.ubah.ketBingkai": "Berbayar. Bingkai ditempel ulang sesudahnya, jadi logo dan kontak di sudut tidak ikut berubah.",
  "k8.ganti.judul": "Atau ganti seluruhnya",
  "k8.ganti.ket": "Buat ulang membuat gambar baru untuk slide ini saja (berbayar). Gambar unggahan dipakai apa adanya, bingkai tidak ditempel.",
  "k8.hasil.judul": "Hasil sebelumnya",
  "k8.hasil.ke": "Hasil {{n}}",
  "k8.hasil.ket": "Pilih salah satu untuk memakainya lagi.",
  "k8.kapan.judul": "Kapan & ke mana",
  "k8.kapan.ket": "Platform yang tersambung tercentang sebagai bawaan.",
  "k8.kapan.kapan": "Kapan",
  "k8.kapan.draf": "Simpan sebagai draf",
  "k8.kapan.drafKet": "Tidak terbit sampai dijadwalkan.",
  "k8.kapan.jadwalKet": "Terbit sendiri pada jamnya.",
  "k8.kapan.sekarangKet": "Langsung terbit.",
  "k8.kapan.simpanDraf": "Simpan draf",
  "k8.kapan.slotKet": "Terisi slot kosong berikutnya.",
  "k8.kapan.belumSiap": "{{nama}} belum bisa dipakai: {{sebab}}.",
  "k8.kurang.judul": "Judul internal belum diisi.",
  "k8.kurang.caption": "Caption belum diisi.",
  "k8.kurang.gambar": "Buat atau unggah gambar dulu.",
  "k8.kurang.slide": "Ada slide yang belum bergambar. Buat gambarnya, atau hapus slidenya.",
  "k8.kurang.slideAcuan": "Ada slide yang belum bergambar. Buat gambarnya dulu.",
  "k8.kurang.jam": "Pilih tanggal dan jamnya.",
  "k8.toast.draf": "Draf disimpan di Menunggu Anda",
  "k7.gambar.sunting": "Sunting gambar",
  "k7.video.judul": "Video",
  "k7.video.ket": "Satu video. Sampulnya bisa diunggah sendiri.",
  "k7.video.unggah": "Unggah video",
  "k7.video.sunting": "Sunting video",
  "k7.video.toastUnggah": "Video diganti",
  "k7.video.syarat": "Video unggahan: MP4 tegak 9:16, 3 sampai 90 detik, paling besar {{maks}} MB.",
  "k7.sampul.judul": "Sampul video",
  "k7.sampul.ket": "Gambar yang tampil sebelum videonya diputar. Kalau kosong, Instagram dan Facebook memilih sendiri potongan videonya.",
  "k7.sampul.kosong": "Belum ada sampul.",
  "k7.sampul.alt": "Sampul video",
  "k7.sampul.unggah": "Unggah sampul",
  "k7.sampul.ganti": "Ganti sampul",
  "k7.sampul.lepas": "Lepas sampul",
  "k7.sampul.syarat": "PNG, JPG, atau WEBP, paling besar {{maks}} MB. Sebaiknya tegak 9:16, seperti videonya.",
  "k7.sampul.toast": "Sampul terpasang",
  "k7.sampul.toastLepas": "Sampul dilepas",
  "k8.video.unggah": "Unggah video sendiri",
  "k8.video.toast": "{{nama}} dipakai sebagai videonya",
  "k7.sunting.ket": "Yang dikerjakan di sini baru berlaku sesudah Simpan gambar.",
  "k7.sunting.simpan": "Simpan gambar",
  "k7.sunting.toast": "Gambar disimpan",
  "k7.sunting.belumBerubah": "Belum ada yang berubah",
  "k7.sunting.belumDisimpan": "Gambar belum disimpan",
  "k7.sunting.slideKosong": "Ada slide yang belum bergambar",
  "k7.sunting.tanpaBahan": "Gambar yang sudah ada belum bisa diubah dengan arahan",
  "k6.video": "Video konten {{judul}}",
  "k8.kurang.tanpaPlatform": "Belum ada platform yang bisa dipakai, jadi konten belum bisa dibuat.",
  "k9.ket": "Orang yang masih dilayani bot.",
  "k9.ringkas": "{{n}} calon dilayani bot",
  "k9.lengkapN": "{{n}} datanya sudah lengkap",
  "k9.cari": "Cari calon prospek",
  "k9.cariContoh": "Cari nama atau PIC",
  "k9.gagal": "Calon prospek tidak termuat",
  "k9.jalur": "Tahap calon prospek",
  "k9.semua": "Semua",
  "k9.semuaKet": "Yang dilayani bot",
  "k9.tahap.jajaki": "Menjajaki",
  "k9.tahap.kumpul": "Mengumpulkan data",
  "k9.tahap.lengkap": "Data lengkap",
  "k9.tahap.tidakLanjut": "Tidak dilanjutkan",
  "k9.tahapKet.jajaki": "Bot menjawab pertanyaan",
  "k9.tahapKet.kumpul": "Bot meminta data dasar",
  "k9.tahapKet.lengkap": "Bot menawarkan meeting",
  "k9.tahapKet.tidakLanjut": "Bisa dipulihkan",
  "k9.keProspek": "Sedang dikelola tim",
  "k9.daftar": "Daftar calon prospek",
  "k9.kosongJudul": "Belum ada calon prospek",
  "k9.kosongIsi": "Calon muncul di sini begitu bot mengenali calon pelanggan dari percakapannya.",
  "k9.tahapKosong": "Tidak ada calon di tahap ini",
  "k9.cariKosong": "Tidak ada yang cocok dengan “{{kata}}”",
  "k9.kolom.calon": "Calon",
  "k9.kolom.tahap": "Tahap",
  "k9.kolom.keadaan": "Keadaan",
  "k9.kolom.data": "Data",
  "k9.kolom.aktif": "Aktif terakhir",
  "k9.keadaan.botMati": "Bot dimatikan untuk orang ini. Tim yang membalas.",
  "k9.keadaan.menjajaki": "Bot menjawab pertanyaannya.",
  "k9.keadaan.kurang": "Bot sedang melengkapi datanya.",
  "k9.keadaan.kurangDaftar": "Bot meminta: {{daftar}}.",
  "k9.keadaan.mauMeeting": "Mau meeting. Bot menawarkan jadwalnya.",
  "k9.keadaan.belumMau": "Belum mau meeting.",
  "k9.keadaan.belumDitanya": "Belum ditanya soal meeting.",
  "k9.keadaan.tidakLanjut": "Disisihkan. Bot tetap menjawab pertanyaan umumnya.",
  "k9.pulihkan": "Pulihkan",
  "k9.toast.pulih": "{{nama}} dipulihkan",
  "k9.kaki": "{{n}} calon · baris mana pun membuka datanya",
  "k9.menunggu": "Menunggu keputusan Anda",
  "k9.menungguN": "{{n}} menunggu keputusan Anda",
  "k9.terima.tombol": "Terima",
  "k9.terima.tanya": "Terima {{nama}}?",
  "k9.terimaDini.tombol": "Terima sekarang",
  "k9.terimaDini.tanya": "Terima {{nama}} sekarang?",
  "k9.terimaDini.ket": "Datanya belum lengkap. Calon ini pindah ke Prospek, dan bot tetap melengkapi datanya, lalu menawarkan meeting tanpa menunggu keputusan lagi. Tidak ada pesan yang dikirim sekarang, dan penerimaan ini tidak bisa dicabut dari layar.",
  "k9.toast.terimaDini": "{{nama}} diterima. Bot melanjutkan melengkapi datanya.",
  "k9.terima.ket": "Calon ini pindah ke Prospek, dan bot menawarkan meeting begitu ia membalas lagi.",
  "k9.tolak.tombol": "Tolak",
  "k9.tolak.judul": "Tolak {{nama}}?",
  "k9.tolak.ket": "Bot tidak menawarkan meeting, tetapi tetap menjawab pertanyaan umumnya. Calon ini pindah ke Tidak dilanjutkan dan bisa dipulihkan.",
  "k9.tolak.alasan": "Alasan",
  "k9.tolak.catatan": "Catatan untuk tim (boleh kosong)",
  "k9.tolak.catatanContoh": "Misalnya: hubungi lagi tahun depan",
  "k9.alasan.luar_sasaran": "Di luar sasaran kita",
  "k9.alasan.belum_siap": "Belum siap membeli",
  "k9.alasan.sudah_ditangani": "Sudah ditangani di tempat lain",
  "k9.alasan.lainnya": "Lainnya",
  "k9.toast.terima": "{{nama}} diterima",
  "k9.toast.tolak": "{{nama}} ditolak",
  "k9.keadaan.menunggu": "Datanya lengkap. Bot belum menawarkan meeting.",
  "k9.keadaan.ditolak": "Ditolak: {{alasan}}.",
  "k9.diputuskan": "{{oleh}} · {{kapan}}",
  "hari.1": "Sen",
  "hari.2": "Sel",
  "hari.3": "Rab",
  "hari.4": "Kam",
  "hari.5": "Jum",
  "hari.6": "Sab",
  "hari.7": "Min",
  "pm.tanpaTarif": "tarif belum diketahui",
  "pm.biayaToken": "{{masuk}} masuk · {{keluar}} keluar per 1 juta token",
  "pm.kiraBalasan": "kira-kira {{biaya}} per {{per}} balasan, dari {{n}} balasan tim ini {{hari}} hari terakhir",
  "pm.kiraKonsep": "kira-kira {{biaya}} per konsep, dari {{n}} konsep tim ini {{hari}} hari terakhir",
  "pm.biayaGambar": "{{biaya}} per gambar",
  "pm.biayaDetik": "{{biaya}} per detik video",
  "pm.utama": "Model utama",
  "pm.bawaan": "Bawaan Smova",
  "pm.bawaanKet": "Model dan urutannya ditentukan Smova.",
  "pm.cadangan": "Cadangan kalau model utama gagal, berurutan",
  "pm.tanpaCadangan": "Belum ada cadangan. Kalau model utama gagal, permintaannya gagal.",
  "pm.naik": "Naikkan {{nama}}",
  "pm.turun": "Turunkan {{nama}}",
  "pm.lepas": "Hapus {{nama}} dari cadangan",
  "pm.modelCadangan": "Model cadangan",
  "pm.tambahCadangan": "Tambah cadangan",
  "pm.gagal": "Daftar model tidak termuat",
  "pm.kosong": "Belum ada model untuk keperluan ini di katalog Smova.",
  "pm.minggu.judul": "Minggu ini",
  "pm.minggu.ket": "Dari jadwal yang tersimpan.",
  "pm.minggu.selalu": "24 jam",
  "p1.ket": "Cara bot membalas DM dan komentar.",
  "p1.tab.label": "Bagian Chatbot",
  "p1.tab.persona": "Persona & kebijakan",
  "p1.tab.data": "Data prospek",
  "p1.tab.jadwal": "Jadwal balas",
  "p1.tab.model": "Model",
  "p1.wajib": "Wajib diisi.",
  "p1.maks": "Paling banyak {{n}} huruf.",
  "p1.emailSalah": "Alamat email itu tidak lengkap.",
  "p1.persona.gagal": "Persona tidak termuat",
  "p1.identitas.judul": "Identitas bot",
  "p1.identitas.ket": "Nama dan gaya yang dipakai bot saat membalas.",
  "p1.identitas.nama": "Nama bot",
  "p1.identitas.perusahaan": "Nama perusahaan",
  "p1.identitas.bidang": "Bidang usaha",
  "p1.identitas.bidangKet": "Satu kalimat tentang yang dikerjakan perusahaan Anda. Dipakai bot saat memperkenalkan diri.",
  "p1.identitas.email": "Email rujukan",
  "p1.identitas.emailKet": "Disebut bot saat prospek minta dihubungi lewat email.",
  "p1.identitas.gaya": "Gaya bahasa",
  "p1.gaya.formal": "Formal",
  "p1.gaya.ramah": "Ramah",
  "p1.gaya.santai": "Santai",
  "p1.kebijakan.judul": "Kebijakan bisnis",
  "p1.kebijakan.ket": "Batas yang dipegang bot saat percakapan mengarah ke penjualan.",
  "p1.kebijakan.melayani": "Melayani",
  "p1.kebijakan.demo": "Demo atau uji coba",
  "p1.kebijakan.catatan": "Catatan khusus",
  "p1.kebijakan.catatanKet": "Aturan tambahan yang selalu dibaca bot.",
  "p1.melayani.b2b": "Bisnis (B2B)",
  "p1.melayani.b2c": "Perorangan (B2C)",
  "p1.melayani.keduanya": "Keduanya",
  "p1.demo.meeting": "Lewat meeting",
  "p1.demo.mandiri": "Coba sendiri",
  "p1.pratinjau.judul": "Yang dibaca bot",
  "p1.pratinjau.ket": "Dari nilai yang sudah tersimpan. Berubah setelah Simpan.",
  "p1.pagar.judul": "Selalu berlaku",
  "p1.pagar.ket": "Aturan ini tertanam di bot dan tidak bisa dimatikan siapa pun.",
  "p1.pagar.1": "Bot tidak mengaku manusia, walaupun pelanggan mendesak atau kecewa.",
  "p1.pagar.2": "Bot tidak menyebut produk yang tidak ada di dokumen pengetahuan Anda. Ia lebih baik bilang tidak tahu.",
  "p1.pagar.3": "Bot tidak menjanjikan apa pun yang tidak ada di pengaturan ini.",
  "p1.data.judul": "Data yang dikumpulkan bot",
  "p1.data.ket": "Bot menanyakan data yang menyala, satu per satu dari atas, sebelum menawarkan meeting.",
  "p1.data.gagal": "Data prospek tidak termuat",
  "p1.data.ditanyakan": "Ditanyakan sebelum meeting",
  "p1.data.tambahan": "Tidak ditanyakan; dicatat kalau prospek menyebutnya",
  "p1.data.terisi": "{{n}} prospek sudah mengisinya",
  "p1.data.berhenti": "Tidak lagi dikumpulkan",
  "p1.data.naik": "Naikkan {{nama}}",
  "p1.data.turun": "Turunkan {{nama}}",
  "p1.data.banyakJudul": "{{n}} data ditanyakan bot",
  "p1.data.banyakIsi": "Makin banyak yang ditanyakan, makin percakapannya terasa seperti formulir, dan calon pembeli berhenti di tengah. Matikan yang bisa ditanyakan tim saat meeting.",
  "p1.data.ubahNama": "Ubah nama",
  "p1.data.namaBaru": "Nama baru untuk {{nama}}",
  "p1.data.toastNama": "Nama pertanyaan diubah",
  "p1.tipe.teks": "teks",
  "p1.tipe.angka": "angka",
  "p1.tipe.email": "email",
  "p1.tipe.telepon": "telepon",
  "p1.tambahan.judul": "Pertanyaan tambahan",
  "p1.tambahan.ket": "Data di luar bawaan Smova. Yang dimatikan berhenti dikumpulkan; jawaban yang sudah ada tidak dihapus.",
  "p1.tambahan.kosong": "Belum ada pertanyaan tambahan.",
  "p1.tambahan.pertanyaan": "Data yang ditanyakan",
  "p1.tambahan.pertanyaanKet": "Nama datanya, seperti yang akan dibaca tim.",
  "p1.tambahan.kunci": "Disimpan sebagai {{kunci}}. Kuncinya tidak bisa diubah nanti.",
  "p1.tambahan.contoh": "Contoh: Jumlah karyawan",
  "p1.tambahan.tipe": "Jenis jawaban",
  "p1.tambahan.tambah": "Tambah pertanyaan",
  "p1.tambahan.tambahKet": "Langsung ditanyakan bot pada percakapan berikutnya.",
  "p1.tambahan.toast": "Pertanyaan ditambahkan",
  "p1.jadwal.judul": "Jadwal balas",
  "p1.jadwal.ket": "Kapan bot membalas sendiri.",
  "p1.jadwal.gagal": "Jadwal tidak termuat",
  "p1.jadwal.mode": "Bot membalas",
  "p1.jadwal.selalu": "Selalu, 24 jam",
  "p1.jadwal.mingguan": "Mingguan",
  "p1.jadwal.hari": "Hari",
  "p1.jadwal.mulai": "Mulai",
  "p1.jadwal.selesai": "Selesai",
  "p1.jadwal.luar": "Di luar jam itu",
  "p1.jadwal.luarKet": "Percakapannya tetap masuk ke Perlu dijawab, apa pun pilihannya.",
  "p1.jadwal.diam": "Diam",
  "p1.jadwal.balas": "Kirim satu pesan",
  "p1.jadwal.pesan": "Pesan di luar jam",
  "p1.jadwal.pesanKet": "Dikirim sekali per percakapan.",
  "p1.jadwal.pesanBawaan": "Dikirim sekali per percakapan. Yang tampil teks bawaan Smova; menyimpannya membuat salinan milik Anda.",
  "p1.jadwal.hariKosong": "Pilih paling sedikit satu hari.",
  "p1.jadwal.jamTerbalik": "Jam selesai harus sesudah jam mulai.",
  "p1.jadwal.pesanKosong": "Tulis pesannya, atau pilih Diam.",
  "p1.jadwal.luarPesan": "pesan luar jam",
  "p1.jadwal.luarDiam": "diam",
  "p1.model.judul": "Model balasan chat",
  "p1.model.ket": "Model yang menyusun balasan DM dan komentar. Pilihan ini menagih biaya, jadi ia menunggu Simpan.",
  "p2.ket": "Kapan, kepada siapa, dan bagaimana bot menawarkan meeting.",
  "p2.pratinjau.judul": "Yang ditawarkan bot sekarang",
  "p2.pratinjau.gagal": "Pratinjau tidak termuat",
  "p2.pratinjau.tanggal": "Prospek yang memenuhi syarat hari ini ditawari {{tanggal}}, jam {{awal}} sampai {{akhir}}.",
  "p2.pratinjau.atau": ", atau ",
  "p2.pratinjau.kosongTanggal": "Dua minggu ke depan tidak ada tanggal yang bisa ditawarkan bot.",
  "p2.pratinjau.durasi": "Tiap meeting {{durasi}} menit, jadi selesai paling lambat {{selesai}}.",
  "p2.pratinjau.satu": "Sehari paling banyak 1 meeting: satu meeting mengunci seluruh hari itu.",
  "p2.pratinjau.banyak": "Sehari paling banyak {{n}} meeting; jam yang sudah terisi tidak ditawarkan lagi.",
  "p2.pratinjau.jamKosong": "Jam mulai di hari kosong:",
  "p2.pratinjau.bawaan": "Jam meeting belum pernah disimpan: bot memakai 08.00 sampai 15.00.",
  "p2.pratinjau.ket": "Dihitung dari isian di bawah, dan berubah begitu Anda menyimpan. Libur dan izin seluruh tim ikut dihitung.",
  "p2.jam.judul": "Kapan",
  "p2.jam.ket": "Hari, jam, dan berapa meeting sehari. Berlaku untuk seluruh tim.",
  "p2.jam.gagal": "Jam meeting tidak termuat",
  "p2.jam.hariKet": "Sabtu dan Minggu tidak pernah ditawarkan.",
  "p2.jam.mulai": "Jam mulai",
  "p2.jam.selesai": "Jam selesai",
  "p2.jam.selesaiKet": "Meeting harus sudah selesai pada jam ini.",
  "p2.jam.durasi": "Durasi meeting",
  "p2.jam.tidakMuat": "Dengan durasi {{durasi}} menit, jam selesai paling cepat {{jam}}.",
  "p2.jam.belumDiatur": "Belum pernah disimpan: sekarang bot menawarkan jam mulai 08.00 sampai 15.00.",
  "p2.jam.setengah": "Hari dan jam tersimpan, tetapi sisanya belum: {{pesan}}",
  "p2.maks.label": "Meeting per hari, paling banyak",
  "p2.maks.ket": "Bawaan 1. Hari yang sudah penuh tidak ditawarkan, dan jam yang sudah terisi dilewati.",
  "p2.maks.kurang": "Kurangi",
  "p2.maks.tambah": "Tambah",
  "p2.kapasitas.judul": "Batas {{maks}} sehari tidak muat",
  "p2.kapasitas.isi": "Jam {{awal}} sampai {{selesai}} hanya muat {{n}} meeting {{durasi}} menit dengan jeda {{jeda}} menit. Bot tetap menawarkan paling banyak {{n}}.",
  "p2.cepat.label": "Tanggal paling awal",
  "p2.cepat.satuan": "hari setelah hari ini",
  "p2.cepat.ket": "1 = besok, 2 = lusa. Akhir pekan dan libur dilewati.",
  "p2.belumSetelan": "Durasi, meeting per hari, dan tanggal paling awal bisa diatur setelah operator Smova menyiapkan setelan meeting tenant ini.",
  "p2.syarat.data": "Data prospek yang harus sudah terkumpul",
  "p2.syarat.dataKosong": "Belum ada data prospek yang dikumpulkan bot.",
  "p2.syarat.jedaHariSalah": "Isi 0 sampai 30 hari.",
  "p2.syarat.jedaMenit": "Jeda antar-meeting",
  "p2.syarat.jedaMenitKet": "Waktu kosong di antara dua meeting pada hari yang sama.",
  "p2.syarat.bentuk": "Bentuk pertemuan",
  "p2.syarat.lokasi": "Lokasi tatap muka",
  "p2.syarat.lokasiKet": "Usulan pertama bot kalau prospek memilih tatap muka. Prospek tetap boleh menyebut tempat lain.",
  "p2.syarat.lokasiWajib": "Isi lokasinya, atau pilih Online saja.",
  "p2.syarat.menit": "{{n}} mnt",
  "p2.bentuk.online": "Online saja",
  "p2.bentuk.offline": "Tatap muka saja",
  "p2.bentuk.keduanya": "Keduanya",
  "p2.bagaimana.judul": "Bagaimana",
  "p2.bagaimana.ket": "Bentuk pertemuan yang ditawarkan bot.",
  "p2.bagaimana.gagal": "Bentuk pertemuan tidak termuat",
  "p2.siapa.judul": "Kepada siapa",
  "p2.siapa.ket": "Bot baru menawarkan jadwal kalau data ini sudah terkumpul.",
  "p2.siapa.dataKet": "Ditambahkan ke data yang wajib di Chatbot.",
  "p2.siapa.gagal": "Syarat prospek tidak termuat",
  "p2.libur.judul": "Tanggal libur",
  "p2.libur.ket": "Seluruh tim libur. Izin per orang diatur masing-masing di Meeting.",
  "p2.libur.gagal": "Tanggal libur tidak termuat",
  "p2.libur.kosong": "Belum ada tanggal libur yang akan datang.",
  "p2.libur.tanggal": "Tanggal",
  "p2.libur.keterangan": "Keterangan",
  "p2.libur.contoh": "Contoh: Idul Fitri",
  "p2.libur.tambah": "Tambah",
  "p2.libur.akanDatang": "Akan datang · {{n}}",
  "p2.libur.lewat": "Tanggal yang sudah lewat tidak ditampilkan.",
  "p2.libur.lewatTambah": "Tanggal itu sudah lewat. Pilih hari ini atau sesudahnya.",
  "p2.libur.hapus": "Hapus libur {{tanggal}}",
  "p2.libur.toastTambah": "{{tanggal}} ditandai libur",
  "p2.libur.toastHapus": "Libur {{tanggal}} dihapus",
  "p2.gerbang.judul": "Persetujuan tim",
  "p2.gerbang.ket": "Tim yang memilih calon mana yang ditawari meeting.",
  "p2.gerbang.label": "Minta persetujuan tim sebelum bot menawarkan meeting",
  "p2.gerbang.nyala": "Menyala: bot berhenti saat data calon lengkap. Tim menerima atau menolaknya di Calon prospek, atau dari kartunya di grup Telegram.",
  "p2.gerbang.mati": "Mati: begitu data di atas terkumpul, bot langsung menawarkan meeting.",
  "p2.gerbang.gagal": "Setelan persetujuan tidak termuat",
  "p3.ket": "Rantai dari bahan sampai terbit, untuk Instagram dan Facebook",
  "p3.gagal": "Setelan konten tidak termuat",
  "p3.tab.label": "Bagian Konten otomatis",
  "p3.tab.rantai": "Rantai & jadwal",
  "p3.tab.sumber": "Sumber & gaya",
  "p3.tab.referensi": "Referensi",
  "p3.tab.model": "Model",
  "p3.cariTakAda": "Cari bahan tidak ada di paket Anda, jadi jadwal dan sumbernya tidak diatur di sini. Minta ke operator Smova.",
  "p3.rantai.judul": "Rantai konten",
  "p3.rantai.ket": "Untuk konten dari pencarian otomatis. Konten dari /campaign, /analyze, dan tombol tren selalu menunggu Anda di Konten.",
  "p3.rantai.langkah": "Langkah {{n}}",
  "p3.rantai.terkunci": "Tidak ada di paket Anda. Minta ke operator Smova.",
  "p3.langkah.cari.judul": "Cari bahan",
  "p3.langkah.cari.nyala": "Bot mencari berita dan tren sesuai jadwal di bawah.",
  "p3.langkah.cari.mati": "Tidak ada pencarian. Bahan baru tidak masuk.",
  "p3.langkah.cari.ya": "Jalan",
  "p3.langkah.cari.tidak": "Mati",
  "p3.langkah.susun.judul": "Susun konsep",
  "p3.langkah.susun.nyala": "Bahan yang masuk langsung disusun jadi caption dan prompt gambar.",
  "p3.langkah.susun.mati": "Bahan menunggu sampai tim membuat konten sendiri.",
  "p3.langkah.susun.ya": "Jalan",
  "p3.langkah.susun.tidak": "Mati",
  "p3.langkah.konsep.judul": "Setujui konsep otomatis",
  "p3.langkah.konsep.nyala": "Konsep langsung lanjut ke pembuatan gambar tanpa ditinjau.",
  "p3.langkah.konsep.mati": "Konsep menunggu di Konten › Menunggu Anda.",
  "p3.langkah.konsep.ya": "Otomatis",
  "p3.langkah.konsep.tidak": "Tim meninjau",
  "p3.langkah.gambar.judul": "Setujui gambar otomatis",
  "p3.langkah.gambar.nyala": "Gambar yang jadi langsung terjadwal di slotnya dan terbit sendiri.",
  "p3.langkah.gambar.mati": "Gambar menunggu di Konten › Menunggu Anda.",
  "p3.langkah.gambar.ya": "Otomatis",
  "p3.langkah.gambar.tidak": "Tim meninjau",
  "p3.jadwal.judul": "Jadwal cari bahan",
  "p3.jadwal.ket": "Seberapa sering bot mencari bahan baru.",
  "p3.jadwal.kali": "Berapa kali",
  "p3.jadwal.sehari": "{{n}}× sehari",
  "p3.jadwal.mulai": "Mulai jam",
  "p3.jadwal.hari": "Hari",
  "p3.jadwal.hariKosong": "Pilih paling sedikit satu hari.",
  "p3.jadwal.jamJalan": "Bot mencari pukul {{jam}}.",
  "p3.jadwal.asingJudul": "Jadwal ini ditulis di luar layar ini",
  "p3.jadwal.asingIsi": "Bentuknya tidak dikenali, dan ia tetap berjalan apa adanya. Ganti dengan jadwal biasa kalau ingin mengaturnya dari sini.",
  "p3.jadwal.pakaiBiasa": "Pakai jadwal biasa",
  "p3.jadwal.toastBiasa": "Jadwal diganti: sekali sehari pukul 09.00, Senin sampai Jumat",
  "p3.buang.judul": "Konten yang menunggu",
  "p3.buang.ket": "Konsep dan gambar yang tidak diputuskan.",
  "p3.buang.hari": "Buang setelah (hari)",
  "p3.buang.hariKet": "Dari pencarian otomatis maupun /campaign, beserta datanya. Isi 0 kalau tidak ingin dibuang.",
  "p3.buang.salah": "Isi angka bulat 0 sampai 365.",
  "p3.slot.referensi": "Referensi slot {{n}}",
  "p3.slot.kepala.referensi": "Referensi",
  "p3.slot.bawaanTanda": "{{nama}} (bawaan)",
  "p3.slot.tanpaPilihan": "Belum ada referensi",
  "p3.slot.referensiKosong": "Pilih referensi untuk slot ini.",
  "p3.slot.aturReferensi": "Atur referensi",
  "p3.slot.tanpaReferensiJudul": "Belum ada referensi",
  "p3.slot.tanpaReferensi": "Slot terbit butuh referensi: arah, jenis, gambar brand, dan prompt gambarnya.",
  "p3.slot.kepala.jam": "Jam",
  "p3.slot.kepala.platform": "Platform",
  "p3.arah.umum.judul": "Umum",
  "p3.arah.produk.judul": "Dengan produk",
  "p3.arah.iklan.judul": "Iklan produk",
  "p3.iklan.label": "Produk yang diiklankan",
  "p3.iklan.ket": "Konten dari referensi ini mengambil satu dokumen tiap kali, bergiliran. Centang dokumen produknya saja, bukan profil atau ketentuan.",
  "p3.iklan.mati": "{{nama}} · mati di Pengetahuan",
  "p3.iklan.kosongJudul": "Belum ada produk yang dipilih",
  "p3.iklan.kosong": "Referensi ini belum bisa membuat iklan sampai ada dokumen yang dicentang.",
  "p3.iklan.wajib": "Centang paling sedikit satu produk untuk arah Iklan produk.",
  "p3.arah.pengetahuan": "Bahannya dari Pengetahuan: {{n}} dokumen menyala.",
  "p3.arah.pengetahuanKosongJudul": "Belum ada dokumen Pengetahuan yang menyala",
  "p3.arah.pengetahuanKosong": "Konten berarah Dengan produk dan Iklan produk akan ditulis umum sampai ada dokumennya.",
  "p3.arah.bukaPengetahuan": "Buka Pengetahuan",
  "p3.slot.judul": "Slot terbit",
  "p3.slot.ket": "Jam konten otomatis terbit setiap hari. Tiap slot memakai satu referensi; arah, jenis, gambar brand, dan promptnya diatur di tab Referensi.",
  "p3.slot.jam": "Jam slot {{n}}",
  "p3.slot.tujuan": "Platform slot {{jam}}",
  "p3.slot.hapus": "Hapus slot {{jam}}",
  "p3.slot.tambah": "Tambah slot",
  "p3.slot.penuh": "Paling banyak {{n}} slot sehari.",
  "p3.slot.ringkas": "{{konten}} konten dan {{gambar}} gambar dibuat per hari.",
  "p3.slot.video": "Slot video berhenti di draf. Videonya dibuat atau diunggah tim di Konten.",
  "p3.slot.belumSiap": "{{nama}} belum siap menerbitkan: {{sebab}}",
  "p3.slot.jamSalah": "Isi jam slot ini.",
  "p3.slot.slideSalah": "Carousel berisi 2 sampai {{n}} slide.",
  "p3.slot.tujuanKosong": "Pilih paling sedikit satu platform untuk slot ini.",
  "p3.jenis.foto": "Foto",
  "p3.jenis.carousel": "Carousel",
  "p3.jenis.video": "Video",
  "p3.sumber.judul": "Sumber & topik",
  "p3.sumber.ket": "Dari mana bot mencari bahan, dan topik apa.",
  "p3.sumber.sumber": "Sumber",
  "p3.sumber.sumberKet": "Anda memilih kata kunci, bukan situs berita. Situs yang muncul ditentukan hasil pencariannya.",
  "p3.sumber.sumberKosong": "Pilih paling sedikit satu sumber.",
  "p3.sumber.topik": "Topik",
  "p3.sumber.topikKet": "Pisahkan dengan koma.",
  "p3.sumber.topikKosong": "Isi paling sedikit satu topik.",
  "p3.sumber.bahasa": "Bahasa bahan",
  "p3.sumber.bahasaKet": "Menentukan bahasa dan negara hasil pencarian. Topik berbahasa lain akan menarik berita yang tidak nyambung.",
  "p3.gaya.judul": "Gaya visual brand",
  "p3.gaya.ket": "Selera visual brand. Aturan teknis gambar tetap dipegang sistem.",
  "p3.gaya.teks": "Gaya visual",
  "p3.gaya.teksKet": "Palet, jenis gambar, suasana. Boleh kosong: gaya lalu diambil dari gambar brand yang dipakai otomatis.",
  "p3.gaya.contoh": "Contoh: ilustrasi flat, palet biru tua dan hijau, latar polos",
  "p3.ref.judul": "Pustaka gambar",
  "p3.ref.daftar": "Pustaka gambar",
  "p3.ref.dipakaiOleh": "Dipakai: {{daftar}}",
  "p3.ref.belumDipakai": "Belum dipakai referensi mana pun",
  "p3.ref.sebagaiBingkai": "{{nama}} (bingkai)",
  "p3.ref.sebagaiPenutup": "{{nama}} (halaman penutup)",
  "p3.rk.judul": "Referensi konten",
  "p3.rk.ket": "Satu referensi adalah satu paket: arah tulisan, jenis, gambar brand, dan prompt gambarnya. Slot terbit dan Buat konten tinggal memilihnya.",
  "p3.rk.gagal": "Referensi tidak termuat",
  "p3.rk.daftar": "Daftar referensi",
  "p3.rk.baru": "Referensi baru",
  "p3.rk.bawaan": "Bawaan",
  "p3.rk.bawaanKet": "dipakai /campaign, berita yang dipilih dari Telegram, dan konsep dari tab Bahan",
  "p3.rk.simpanDulu": "Simpan atau batalkan perubahan ini dulu untuk membuka referensi lain.",
  "p3.rk.slot": "Slot {{jam}}",
  "p3.rk.tanpaSlot": "Belum dipakai slot",
  "p3.rk.carouselN": "Carousel {{n}} slide",
  "p3.rk.gambarN": "{{n}} gambar brand",
  "p3.rk.nama": "Nama referensi",
  "p3.rk.namaKet": "Nama ini yang tampil di pilihan referensi tiap slot terbit dan di Buat konten.",
  "p3.rk.namaKosong": "Beri nama referensi ini.",
  "p3.rk.arah": "Arah tulisan",
  "p3.rk.arahKet.umum": "Informasi, wawasan, atau cerita seputar beritanya. Produk tidak disebut.",
  "p3.rk.arahKet.produk": "Beritanya dikaitkan ke satu produk dari Pengetahuan. Tanpa dokumen yang cocok, ditulis umum.",
  "p3.rk.arahKet.iklan": "Iklan satu produk, tanpa berita. Produknya bergiliran dari yang dicentang di bawah.",
  "p3.rk.jenis": "Jenis",
  "p3.rk.jenisKet.carousel": "Tiap slide satu gambar, jadi biayanya ikut berlipat.",
  "p3.rk.jenisKet.video": "Konten video berhenti di draf; videonya dibuat atau diunggah tim di Konten. Gambar brand dan prompt gambar tidak dipakai.",
  "p3.rk.slide": "Jumlah slide",
  "p3.rk.gambar": "Gambar referensi ini",
  "p3.rk.gambarKet": "Beri tiap gambar satu peran. Gambar brand dilihat AI sebagai acuan, paling banyak {{maks}}. Bingkai adalah PNG tembus pandang 4:5 berisi logo dan kontak: AI melihatnya sebagai kanvas, lalu bingkainya ditempel ulang dari berkas aslinya sesudah gambarnya jadi, jadi selalu sama. Halaman penutup jadi slide terakhir carousel dan tidak digambar AI.",
  "p3.rk.gambarKosong": "Belum ada gambar di pustaka. Unggah di sini.",
  "p3.rk.gambarDaftar": "Gambar pustaka dan perannya",
  "p3.rk.gambarHitung": "{{n}} dari {{maks}} gambar brand dipilih.",
  "p3.rk.peranUntuk": "Peran {{nama}}",
  "p3.rk.peran.tanpa": "Tidak dipakai",
  "p3.rk.peran.brand": "Gambar brand",
  "p3.rk.peran.bingkai": "Bingkai",
  "p3.rk.peran.bingkaiBukanPng": "Bingkai (harus PNG)",
  "p3.rk.peran.penutup": "Halaman penutup",
  "p3.rk.peranKet.tanpa": "Tidak dipakai referensi ini",
  "p3.rk.peranKet.brand": "Gambar {{n}} di prompt",
  "p3.rk.peranKet.bingkai": "Gambar 1 di prompt (kanvas), lalu ditempel ulang dari berkas ini",
  "p3.rk.peranKet.penutup": "Slide terakhir carousel; tidak dilihat AI",
  "p3.rk.hilang.bingkai": "Bingkai yang tersimpan sudah tidak ada di pustaka.",
  "p3.rk.hilang.penutup": "Halaman penutup yang tersimpan sudah tidak ada di pustaka.",
  "p3.rk.hilang.lepas.bingkai": "Lepas bingkai",
  "p3.rk.hilang.lepas.penutup": "Lepas halaman penutup",
  "p3.rk.penutupHitung": "Carousel {{n}} slide: {{gambar}} digambar AI, lalu halaman ini.",
  "p3.rk.berbingkai": "berbingkai",
  "p3.rk.toastUnggahPilih": "“{{nama}}” diunggah. Pilih perannya di daftar.",
  "p3.rk.prompt": "Prompt gambar",
  "p3.rk.belumJudul": "Belum ada referensi",
  "p3.rk.belumIsi": "Konten otomatis belum punya referensi. Isi yang pertama di bawah, lalu Simpan.",
  "p3.rk.tanpaBawaanJudul": "Belum ada referensi bawaan",
  "p3.rk.tanpaBawaanIsi": "Buka salah satu referensi, centang Bawaan, lalu Simpan. Sampai itu, /campaign dan berita yang dipilih dari Telegram tidak punya referensi.",
  "p3.rk.baruKet": "Referensi baru bisa dipilih slot terbit dan Buat konten begitu disimpan.",
  "p3.rk.satuSaja": "Baru ada satu referensi, jadi semua slot memakainya. Tambah lewat tombol Referensi baru.",
  "p3.rk.gantiBawaan": "Referensi bawaan tidak bisa dihapus. Untuk mengganti bawaan, buka referensi lain lalu centang Bawaan.",
  "p3.rk.dipakaiSlot": "Dipakai slot {{jam}}.",
  "p3.rk.hapusDipakai": "Pindahkan slot itu ke referensi lain dulu kalau referensi ini mau dihapus.",
  "p3.rk.belumDipakai": "Belum dipakai slot mana pun. Pilih di tab Rantai & jadwal, kartu Slot terbit.",
  "p3.rk.hapus": "Hapus referensi",
  "p3.rk.hapusTanya": "Hapus referensi “{{nama}}”?",
  "p3.rk.hapusRincian": "Referensinya dihapus dan tidak bisa dikembalikan. Konten yang sudah dibuat tidak berubah.",
  "p3.rk.toastHapus": "“{{nama}}” dihapus",
  "p3.rk.uji.judul": "Uji referensi ini",
  "p3.rk.uji.ket": "Memakai isian di atas, termasuk yang belum disimpan. Hasilnya tidak masuk ke Konten dan tidak dikirim ke Telegram.",
  "p3.rk.uji.topik": "Topik contoh",
  "p3.rk.uji.topikContoh": "mis. Klaim asuransi kesehatan naik tahun ini",
  "p3.rk.uji.produk": "Produk yang diuji",
  "p3.rk.uji.tanpaProduk": "Centang produknya dulu",
  "p3.rk.uji.tulisan": "Uji tulisan",
  "p3.rk.uji.caption": "Caption",
  "p3.rk.uji.dari": "Dari Pengetahuan: {{daftar}}",
  "p3.rk.uji.tanpaBahan": "Tidak ada dokumen Pengetahuan yang cocok; ditulis umum.",
  "p3.rk.uji.prompt": "Prompt gambar",
  "p3.rk.uji.ragam": "Susunan nomor {{n}}, dipilih sistem dari topik dan captionnya.",
  "p3.rk.uji.slide": "Slide {{n}}",
  "p3.rk.uji.gambar": "Buat {{n}} gambar contoh",
  "p3.rk.uji.berbayar": "Berbayar",
  "p3.rk.uji.gambarTanya": "Buat {{n}} gambar contoh?",
  "p3.rk.uji.gambarRincian": "Tiap gambar ditagih seperti gambar konten biasa. Hasilnya tidak disimpan.",
  "p3.rk.uji.gambarYa": "Buat gambar",
  "p3.rk.uji.hasilGambar": "Gambar contoh",
  "p3.rk.uji.altGambar": "Gambar contoh slide {{n}}",
  "p3.rk.uji.penutup": "Halaman penutup",
  "p3.rk.uji.berpenutup": "Slide terakhirnya halaman penutup tetap, tanpa biaya gambar.",
  "p3.rk.uji.altPenutup": "Halaman penutup: {{nama}}",
  "p3.ref.ket": "Semua gambar milik tenant ini: logo, maskot, contoh gaya, bingkai, dan halaman penutup. Peran tiap gambar diatur di tiap referensi di atas; di sini namanya, keterangannya, dan pensiunnya.",
  "p3.ref.unggah": "Unggah gambar",
  "p3.ref.mengunggah": "Mengunggah…",
  "p3.ref.gagalUnggah": "Gambar tidak terunggah",
  "p3.ref.gagal": "Pustaka gambar tidak termuat",
  "p3.ref.belumJudul": "Pustaka gambar masih kosong",
  "p3.ref.belumIsi": "Tanpa gambar di pustaka, gambar konten dibuat tanpa logo atau aset brand apa pun.",
  "p3.ref.tanpaUntuk": "Belum ada keterangan untuk apa gambar ini.",
  "p3.ref.ubah": "Ubah",
  "p3.ref.nama": "Nama gambar",
  "p3.ref.untuk": "Untuk apa gambar ini",
  "p3.ref.untukContoh": "Contoh: Logo resmi. Taruh di kiri atas, jangan digambar ulang.",
  "p3.ref.untukKet": "Dibaca AI bersama gambarnya. Kosongkan kalau gambar ini jangan dipilih AI sendiri.",
  "p3.ref.toastUbah": "Keterangan gambar disimpan",
  "p3.ref.pensiun": "Pensiunkan",
  "p3.ref.pensiunTanya": "Pensiunkan “{{nama}}”?",
  "p3.ref.pensiunRincian": "Gambar ini tidak dipakai lagi untuk konten baru. Konten lama tidak berubah.",
  "p3.ref.toastPensiun": "“{{nama}}” dipensiunkan",
  "p3.ref.toastUnggah": "“{{nama}}” diunggah.",
  "p3.ref.dikecilkan": "Gambarnya dikecilkan sebelum diunggah.",
  "p3.prompt.teksKet": "Topik, caption, brief, dan daftar gambar yang tidak disisipkan tetap dikirim, ditempel di akhir prompt.",
  "p3.prompt.contoh": "Tulis instruksi untuk AI di sini.",
  "p3.prompt.kosong": "Isi instruksinya dulu.",
  "p3.prompt.sisipkan": "Sisipkan",
  "p3.tempat.topik": "Topik",
  "p3.tempat.caption": "Caption",
  "p3.tempat.pesan": "Pesan utama",
  "p3.tempat.brief": "Brief",
  "p3.tempat.bahan": "Daftar gambar",
  "p3.tempat.slideKe": "Slide ke-",
  "p3.tempat.jumlah": "Jumlah slide",
  "p3.tempat.ragam": "Ragam",
  "p3.tempatKet.topik": "judul dan ringkasan berita dari pencarian",
  "p3.tempatKet.caption": "caption yang sudah ditulis AI untuk konten ini",
  "p3.tempatKet.pesan": "pesan utama konten",
  "p3.tempatKet.brief": "arahan dari tombol Perbaiki di Telegram atau brief di Buat konten",
  "p3.tempatKet.bahan": "gambar yang ikut, bernomor, beserta teks untuk apa-nya",
  "p3.tempatKet.slideKe": "nomor slide yang sedang ditulis",
  "p3.tempatKet.jumlah": "jumlah slide carousel",
  "p3.tempatKet.ragam": "angka 1 sampai 6 yang dipilih sistem untuk tiap konten, sama di semua slidenya; ganti 6 dengan jumlah susunan yang ditulis di prompt",
  "p3.model.teks": "Model teks",
  "p3.model.teksKet": "Menulis caption, pesan kunci, dan prompt gambar.",
  "p3.model.gambar": "Model gambar",
  "p3.model.gambarKet": "Membuat gambar konten. Pilihan ini paling terasa di biaya.",
  "p3.model.video": "Model video",
  "p3.model.videoKet": "Dipakai saat tim membuat video di Konten.",
  "p4.ket": "Dokumen yang dipakai bot menjawab",
  "p4.ringkas": "{{n}} dokumen dipakai bot · {{potongan}} potongan",
  "p4.unggah.tombol": "Unggah dokumen",
  "p4.unggah.memproses": "Memproses…",
  "p4.unggah.gagal": "Dokumen tidak terunggah",
  "p4.unggah.jenisSalah": "“{{nama}}” belum bisa dibaca. Yang diterima: .txt, .md, .csv, dan .json. Simpan PDF atau Word sebagai .txt lebih dulu.",
  "p4.unggah.terlaluBesar": "Berkasnya {{kb}} KB. Batasnya {{maks}} KB; pecah jadi beberapa dokumen.",
  "p4.unggah.toast": "{{nama}} masuk: {{n}} potongan siap dipakai bot",
  "p4.dok.judul": "Dokumen",
  "p4.dok.ket": "Hanya dokumen yang menyala yang dibaca bot. Isinya tidak ditampilkan di sini.",
  "p4.dok.gagal": "Dokumen tidak termuat",
  "p4.dok.kosong": "Belum ada dokumen",
  "p4.dok.kosongKet": "Bot belum punya bahan untuk menjawab. Unggah dokumen pertama Anda.",
  "p4.dok.cari": "Cari dokumen",
  "p4.dok.tidakCocok": "Tidak ada dokumen yang cocok.",
  "p4.dok.namaVersi": "{{nama}} ({{versi}})",
  "p4.dok.hapus": "Hapus",
  "p4.dok.hapusTanya": "Hapus {{nama}} permanen?",
  "p4.dok.hapusKet": "Isinya dan potongannya hilang dari pengetahuan bot, dan tidak bisa diurungkan. Kalau dokumen ini diiklankan referensi konten, namanya ikut dilepas dari sana. Untuk berhenti memakainya sementara, matikan saklarnya saja.",
  "p4.dok.hapusYa": "Hapus permanen",
  "p4.dok.toastHapus": "{{nama}} dihapus",
  "p4.dok.toastHapusRef": "{{nama}} dihapus, dan dilepas dari referensi {{daftar}}",
  "p4.dok.rincian": "{{n}} potongan · diproses {{tanggal}}",
  "p4.dok.belumDiproses": "Belum diproses, jadi belum bisa dipakai bot. Unggah ulang berkasnya.",
  "p4.dok.jenis": "Teks, Markdown, CSV, atau JSON sampai 1 MB. Nama berkas menjadi judul dokumen, dan mengunggah nama yang sama mengganti isinya.",
  "p4.uji.contoh": "Ketik pertanyaan seperti pelanggan Anda",
  "p4.uji.menguji": "Menguji…",
  "p4.uji.gagal": "Uji tidak berjalan",
  "p4.ambil.judul": "Uji jawaban",
  "p4.ambil.ket": "Potongan mana yang ditemukan bot, dan kenapa. Murah, boleh berkali-kali.",
  "p4.ambil.label": "Pertanyaan untuk uji jawaban",
  "p4.ambil.tombol": "Uji",
  "p4.ambil.nolJudul": "0 potongan ditemukan",
  "p4.ambil.nolIsi": "“{{pertanyaan}}” tidak menemukan apa pun di dokumen yang menyala. Tambahkan bagian yang membahasnya ke salah satu dokumen.",
  "p4.ambil.ketemu": "{{n}} potongan ditemukan · {{karakter}} huruf",
  "p4.ambil.untuk": "Untuk “{{pertanyaan}}”",
  "p4.ambil.cuplikan": "Cuplikan potongan yang ditemukan",
  "p4.chat.judul": "Uji percakapan",
  "p4.chat.ket": "Satu jawaban dari dokumen Anda, lalu diperiksa apakah jawabannya memakai potongan yang ditemukan. Memanggil model sungguhan, jadi tiap uji ditagih.",
  "p4.chat.label": "Pesan prospek untuk uji percakapan",
  "p4.chat.tombol": "Kirim ke bot",
  "p4.chat.prospek": "Prospek",
  "p4.chat.bot": "Bot",
  "p4.chat.uji": "uji",
  "p4.chat.pakai": "Jawabannya memakai potongan yang ditemukan ({{n}} potongan).",
  "p4.chat.karang": "Jawabannya tidak memakai potongan yang ditemukan ({{n}} potongan).",
  "p4.chat.karangIsi": "Kemungkinan besar dikarang. Periksa dokumen Anda.",
  "p4.chat.biaya": "Biaya uji ini {{biaya}}.",
  "p4.dok.aksi": "Aksi untuk {{nama}}",
  "p4.dok.lihat": "Lihat yang dibaca bot",
  "p4.dok.hapusMenu": "Hapus dokumen…",
  "p4.kelompok.produk": "Produk · {{n}}",
  "p4.kelompok.peran": "Ringkasan dan profil perusahaan · {{n}}",
  "p4.kelompok.umum": "Umum · {{n}}",
  "p4.peran.produk": "Produk",
  "p4.peran.ringkasan": "Ringkasan",
  "p4.peran.profil": "Profil perusahaan",
  "p4.peran.umum": "Umum",
  "p4.tanda.kembar": "Alias kembar",
  "p4.tanda.tanpaKepala": "Tanpa kepala",
  "p4.tanda.tipeAsing": "TYPE tidak dikenal",
  "p4.cara.judul": "Cara bot membaca dokumen",
  "p4.cara.ket": "Tulis tiga baris ini di awal tiap dokumen. Bot memakainya untuk memilih dokumen yang dibaca saat pelanggan bertanya.",
  "p4.cara.contoh": "TYPE: produk\nPRODUCT: Paket Bisnis\nALIASES: paket bisnis, paket kantor, langganan tim",
  "p4.cara.type": "produk, overview (ringkasan semua produk), atau profil perusahaan. Yang lain dibaca sebagai dokumen umum.",
  "p4.cara.product": "nama produknya; tulis all untuk dokumen umum.",
  "p4.cara.aliases": "istilah yang diketik pelanggan, dipisah koma. Tiap istilah di satu dokumen saja: istilah yang kembar tidak mengarahkan pertanyaan.",
  "p4.baca.judul": "Yang dibaca bot",
  "p4.baca.ditulis": "(ditulis “{{teks}}”)",
  "p4.baca.dariNama": "(dari nama berkas)",
  "p4.baca.arti.produk": "Dokumen satu produk. Pertanyaan yang menyebut produk atau aliasnya diarahkan ke sini.",
  "p4.baca.arti.ringkasan": "Dibaca utuh untuk pertanyaan umum soal produk, seperti “produk apa saja?”.",
  "p4.baca.arti.profil": "Dibaca utuh untuk pertanyaan soal perusahaan, pendiri, dan kontak.",
  "p4.baca.arti.umum": "Dibaca lewat aliasnya dan kemiripan isi. TYPE yang dikenali: produk, overview, dan profil perusahaan.",
  "p4.baca.mirip": "Maksudnya “{{tipe}}”? Perbaiki baris TYPE, lalu unggah ulang berkasnya dengan nama yang sama.",
  "p4.baca.tidakDitulis": "Tidak ditulis",
  "p4.baca.semua": "(dokumen umum, bukan satu produk)",
  "p4.baca.alias": "Alias · {{n}}",
  "p4.baca.aliasKet": "Pertanyaan yang menyebut salah satunya diarahkan ke dokumen ini. Nama berkasnya (“{{nama}}”) ikut dikenali.",
  "p4.baca.aliasKosong": "Belum ada alias. Bot hanya mengenali nama berkasnya (“{{nama}}”).",
  "p4.baca.aliasDaftar": "Alias dokumen ini",
  "p4.baca.merek": "nama merek, juga di {{daftar}}: dipakai saat pertanyaannya hanya nama itu",
  "p4.baca.kembar": "juga di {{daftar}}: tidak mengarahkan pertanyaan, kecuali pertanyaannya hanya nama ini",
  "p4.baca.dariProduk": "dari PRODUCT",
  "p4.baca.mati": "Dokumen ini mati, jadi bot tidak membacanya.",
  "p4.baca.tanpaKepala": "Bot hanya mengenali dokumen ini dari nama berkasnya. Tulis TYPE, PRODUCT, dan ALIASES di awal dokumen, lalu unggah ulang berkasnya dengan nama yang sama.",
  "p4.baca.kembarSaran": "Hapus alias kembar dari salah satu dokumen, lalu unggah ulang berkasnya dengan nama yang sama.",
  "p4.baca.tidakAda": "Kepala dokumen ini belum terbaca. Muat ulang halamannya.",
  "p4.ambil.potongan": "Potongan yang ditemukan",
  "p4.ambil.lain": "… dan {{n}} potongan lain",
  "p4.kenapa.label": "Kenapa:",
  "p4.kenapa.alias": "pertanyaannya menyebut {{alias}}, alias {{dokumen}}, jadi itu yang dibaca.",
  "p4.kenapa.ikut": "Ringkasan ({{dokumen}}) ikut diperiksa.",
  "p4.kenapa.merek": "pertanyaannya hanya nama {{alias}}, yang dipakai {{dokumen}}. Semuanya dibaca.",
  "p4.kenapa.perusahaan": "pertanyaan soal perusahaan, jadi seluruh profil perusahaan ({{dokumen}}) dibaca.",
  "p4.kenapa.bidang": "tidak menyebut nama produk, tetapi menyebut “{{kata}}”, kata yang dipakai beberapa produk. Ringkasan ({{dokumen}}) dibaca utuh.",
  "p4.kenapa.umum": "pertanyaan umum soal produk (“{{kata}}”), jadi ringkasan ({{dokumen}}) dibaca utuh.",
  "p4.kenapa.mirip": "tidak menyebut nama produk atau alias mana pun, jadi dicari dari kemiripan isi.",
  "p4.kenapa.miripNol": "tidak menyebut nama produk atau alias mana pun, jadi dicari dari kemiripan isi, dan tidak ada potongan yang cukup mirip.",
  "p4.saran.label": "Yang bisa dilakukan:",
  "p4.saran.umum": "kalau pertanyaan ini seharusnya ke satu produk, tambahkan istilahnya ke ALIASES dokumen produk itu.",
  "p4.saran.nol": "kalau ini dibahas di salah satu dokumen, tambahkan istilahnya ke ALIASES dokumen itu. Kalau tidak, bot belum punya bahan untuk menjawabnya.",
  "p5.ket": "Orang di tim Anda dan penautan Telegram-nya",
  "p5.ringkas": "{{n}} orang · {{belum}} belum menautkan Telegram",
  "p5.gagal": "Daftar orang tidak termuat",
  "p5.kosong": "Belum ada orang",
  "p5.kosongKet": "Orang ditambahkan operator Smova.",
  "p5.aksi": "Aksi untuk {{nama}}",
  "p5.peserta": "Bisa jadi peserta meeting",
  "p5.pesertaNama": "Bisa jadi peserta meeting: {{nama}}",
  "p5.nama.belum": "Belum bernama",
  "p5.belumDanNama": "{{n}} orang belum menautkan Telegram, {{m}} belum bernama",
  "p5.kelompok.nonaktif": "Nonaktif · {{n}}",
  "p5.nama.isi": "Isi nama",
  "p5.nama.ubah": "Ubah nama",
  "p5.nama.label": "Nama",
  "p5.nama.ket": "Dibaca orang lain di pemilih peserta dan pesan grup. Kalau dikosongkan, ia disebut dengan nama Telegramnya atau {{akun}}.",
  "p5.nama.toast": "Nama disimpan: {{nama}}",
  "p5.nama.toastKosong": "Nama dikosongkan. Ia disebut dengan nama Telegramnya atau {{akun}}.",
  "p5.nama.belumJudul": "{{n}} orang belum diisi namanya",
  "p5.nama.belumIsi": "Yang belum bernama disebut dengan nama Telegram atau emailnya di pemilih peserta dan pesan grup. Namanya diisi dari tombol ⋯ di barisnya.",
  "p5.belumJudul": "{{n}} orang belum menautkan Telegram",
  "p5.belumIsi": "Mereka tetap membaca notifikasi grup, tetapi tombol seperti “Ambil & Tangani” menolak mereka sampai tertaut. Kode /join-nya dibuat dari tombol ⋯ di barisnya.",
  "p5.orang.judul": "Orang di tim",
  "p5.orang.ket": "Menambah orang dan mengubah peran dilakukan operator Smova. Izin diatur masing-masing di Meeting.",
  "p5.sebutan": "{{nama}}, peserta meeting",
  "p5.nonaktif": "Akun nonaktif, jadi tidak bisa jadi peserta meeting.",
  "p5.tertaut": "Telegram tertaut",
  "p5.tertautNama": "Telegram tertaut · @{{nama}}",
  "p5.belumJoin": "Belum /join",
  "p5.izin": "izin {{tanggal}}",
  "p5.izinLagi": "+{{n}} tanggal lagi",
  "p5.izinGagal": "Tanggal izin tidak termuat.",
  "p5.kode.buat": "Buat kode /join",
  "p5.kode.label": "Kode /join",
  "p5.kode.baru": "berlaku sampai {{sampai}}",
  "p5.kode.lama": "kode yang sudah ada, berlaku sampai {{sampai}}",
  "p5.kode.catatan": "Kodenya milik satu orang dan sekali pakai. Berikan ke orangnya, lalu ia mengetik /join KODE sekali di grup Telegram tim.",
  "p5.saring.label": "Saring orang",
  "p5.saring.semua": "Semua",
  "p5.saring.belum": "Belum tertaut",
  "p5.saring.sudah": "Sudah tertaut",
  "p5.cari": "Cari orang",
  "p5.tidakCocok": "Tidak ada orang yang cocok.",
  "p6.ket": "Akun yang dipakai Smova atas nama tim Anda",
  "p6.gagal": "Sambungan tidak termuat",
  "p6.operator.judul": "Diatur oleh operator Smova",
  "p6.operator.isi": "Perlu mengganti akun atau token? Hubungi operator Smova.",
  "p6.akun.terakhir": "Terakhir menerima pesan {{kapan}}",
  "p6.akun.belumPernah": "Belum pernah menerima pesan",
  "p6.keadaan.tersambung": "Tersambung",
  "p6.keadaan.nonaktif": "Nonaktif",
  "p6.keadaan.belum": "Belum dihubungkan",
  "p6.kap.dm": "Balas DM",
  "p6.kap.komentar": "Balas komentar",
  "p6.kap.terbit": "Terbitkan konten",
  "p6.bisa.bisa": "Bisa",
  "p6.bisa.tidak_bisa": "Tidak disediakan platformnya",
  "p6.bisa.belum_dibangun": "Belum dibangun",
  "p6.bedaKap": "“Tidak disediakan platformnya” berarti platform itu memang tidak membukanya. “Belum dibangun” berarti platformnya bisa dan Smova yang belum.",
  "p6.grup.judul": "Grup Telegram",
  "p6.grup.ket": "Tujuan notifikasi tim: DM, prospek, meeting, dan konten.",
  "p6.grup.kosong": "Belum ada grup yang terdaftar",
  "p6.grup.kosongKet": "Tanpa grup, tim Anda tidak menerima notifikasi. Minta operator Smova mendaftarkan grup Anda.",
  "p6.grup.tanpaNama": "Grup tanpa nama",
  "p6.grup.aktif": "Aktif",
  "p6.grup.nonaktif": "Nonaktif",
  "p6.grup.catatan": "Semua orang di grup bisa membaca notifikasinya. Tombolnya hanya bekerja untuk orang yang sudah /join; siapa yang belum terlihat di Tim.",
  "p7.ket": "Belanja AI bulan ini dan fitur di paket Anda",
  "p7.ringkas": "{{bulan}} · {{n}} hari tersisa bulan ini",
  "p7.berhenti.judul": "Pagu bulan ini tersentuh",
  "p7.berhenti.isi": "Yang berhenti sekarang: {{daftar}}. Hubungi operator Smova kalau butuh pagu lebih.",
  "p7.berhenti.image": "pembuatan gambar",
  "p7.berhenti.video": "pembuatan video",
  "p7.berhenti.drafting": "penyusunan konten",
  "p7.berhenti.chatbot": "balasan chat",
  "p7.belanja.judul": "Belanja AI bulan ini",
  "p7.belanja.ket": "Dibanding pagu yang diatur operator Smova.",
  "p7.belanja.kunci": "Pagu diatur Smova",
  "p7.belanja.gagal": "Belanja bulan ini tidak termuat",
  "p7.belanja.dari": "dari {{pagu}}",
  "p7.belanja.tanpaPagu": "tanpa pagu",
  "p7.belanja.tanpaPaguKet": "Tim ini belum diberi pagu, jadi tidak ada yang menghentikan pemakaiannya. Hubungi operator Smova kalau ingin dipasangi batas.",
  "p7.belanja.batang": "Pagu yang terpakai",
  "p7.belanja.persen": "{{n}}% terpakai · peringatan di {{ambang}}%",
  "p7.belanja.sisa": "Sisa {{sisa}}",
  "p7.tanpaTarif.judul": "{{n}} panggilan belum punya tarif",
  "p7.tanpaTarif.isi": "Angka belanjanya batas bawah, bukan total.",
  "p7.urutan.judul": "Kalau pagu tersentuh",
  "p7.urutan.ket": "Yang berhenti, berurutan.",
  "p7.urutan.aset": "Gambar dan video berhenti dibuat",
  "p7.urutan.konten": "Penyusunan konten berhenti",
  "p7.urutan.chatbot": "Balasan chat ke pelanggan, paling akhir",
  "p7.urutan.sudah": "sudah berhenti",
  "p7.urutan.sebab": "Balasan chat paling akhir karena ia yang menghadap pelanggan Anda.",
  "p7.hari.judul": "Per hari",
  "p7.hari.ket": "Belanja tiap hari.",
  "p7.hari.puncak": "Tertinggi {{biaya}} pada {{tanggal}}.",
  "p7.hari.rentang": "Rentang hari",
  "p7.hari.nHari": "{{n}} hari",
  "p7.hari.gagal": "Pemakaian tidak termuat",
  "p7.hari.kosong": "Belum ada pemakaian tercatat dalam {{n}} hari terakhir.",
  "p7.hari.baris": "{{tanggal}}: {{biaya}}",
  "p7.rinci.judul": "Ke mana perginya",
  "p7.rinci.ket": "Per kegiatan, {{n}} hari terakhir.",
  "p7.rinci.panggilan": "Panggilan model",
  "p7.rinci.token": "Token",
  "p7.rinci.biaya": "Biaya",
  "p7.rinci.kegiatan": "Kegiatan",
  "p7.rinci.jumlah": "Jumlah",
  "p7.rinci.tanpaTarif": "{{n}} panggilan tarifnya belum diketahui",
  "p7.rinci.model": "Model yang membalas chat",
  "p7.rinci.modelTakTercatat": "tidak tercatat",
  "p7.rinci.balasan": "{{n}} balasan",
  "p7.fitur.judul": "Fitur di paket Anda",
  "p7.fitur.ket": "Yang belum ada di paket bisa diminta ke operator Smova.",
  "p7.fitur.kunci": "Diatur Smova",
  "p7.fitur.gagal": "Daftar fitur tidak termuat",
  "p7.fitur.tidakAda": "tidak ada di paket",
  "op.kanal.instagram": "Instagram",
  "op.kanal.facebook": "Facebook",
  "op.kanal.telegram": "Telegram",
  "op.kanalKeadaan.ok": "tersambung",
  "op.kanalKeadaan.perhatian": "token tidak berlaku",
  "op.kanalKeadaan.tanpa": "belum dihubungkan",
  "op.pagu.dari": "{{pakai}} / {{pagu}}",
  "op.pagu.tanpa": "{{pakai}} · tanpa pagu",
  "op.pagu.persen": "{{n}}% terpakai, peringatan di {{ambang}}%",
  "op.onboarding": "{{n}}/{{dari}}",
  "s1.ket": "Semua tenant · {{hari}}",
  "s1.gagal": "Daftar tenant tidak termuat",
  "s1.angka.tenant": "Tenant",
  "s1.angka.tenantKet": "{{live}} live · {{test}} uji · {{draft}} draf",
  "s1.angka.tenantBuka": "Buka daftar",
  "s1.angka.perhatian": "Butuh perhatian",
  "s1.angka.perhatianKet": "Yang merugikan pelanggan di atas",
  "s1.angka.gagal": "Pesan masuk gagal, 24 jam",
  "s1.angka.gagalKet": "Webhook yang tidak selesai diproses",
  "s1.angka.gagalBuka": "Lihat pesan masuk",
  "s1.angka.biaya": "Biaya AI {{bulan}}",
  "s1.angka.biayaKet": "dari total pagu {{pagu}}",
  "s1.angka.biayaTanpa": "belum ada tenant yang berpagu",
  "s1.angka.biayaBuka": "Buka pemakaian",
  "s1.perhatian.judul": "Butuh perhatian",
  "s1.perhatian.ket": "Yang merugikan pelanggan di atas.",
  "s1.perhatian.kosong": "Tidak ada yang butuh perhatian",
  "s1.perhatian.kosongKet": "Semua token berlaku, tidak ada pesan gagal, dan tidak ada pagu yang tersentuh.",
  "s1.perhatian.tokenMati": "Token Meta {{tenant}} tidak berlaku",
  "s1.perhatian.tokenMatiKet": "Bot tidak bisa membalas dan konten tidak bisa terbit sampai tokennya diganti.",
  "s1.perhatian.tokenMatiBuka": "Buka sambungan",
  "s1.perhatian.tokenSegera": "Token Meta {{tenant}} berakhir {{tanggal}}",
  "s1.perhatian.tokenSegeraKet": "Instagram dan Facebook berhenti kalau tidak diganti.",
  "s1.perhatian.tokenSegeraBuka": "Buka sambungan",
  "s1.perhatian.gagal": "{{n}} pesan masuk {{tenant}} gagal diproses",
  "s1.perhatian.gagalKet": "Dalam 24 jam terakhir. Pelanggannya tidak mendapat balasan.",
  "s1.perhatian.gagalBuka": "Lihat pesan masuk",
  "s1.perhatian.alurGagal": "{{n}} alur {{tenant}} berhenti gagal",
  "s1.perhatian.alurGagalKet": "Dalam 24 jam terakhir: timer, balasan bot, atau kiriman yang tidak sampai.",
  "s1.perhatian.alurGagalBuka": "Lihat jejak alur",
  "s1.perhatian.timerTerlambat": "{{nama}} terlambat: terakhir jalan {{kapan}}",
  "s1.perhatian.timerTerlambatKet": "Pekerjaan terjadwalnya tidak jalan: konten tidak terbit, pengingat tidak terkirim, atau sapuan tidak berjalan sampai timernya hidup lagi.",
  "s1.perhatian.timerTerlambatBuka": "Buka Sistem",
  "s1.perhatian.timerGagal": "{{nama}} gagal pada jalan terakhirnya",
  "s1.perhatian.timerGagalKet": "Sebabnya tertulis di layar Sistem.",
  "s1.perhatian.timerGagalBuka": "Buka Sistem",
  "s1.perhatian.paguLewat": "Pagu {{tenant}} terlampaui: {{n}}%",
  "s1.perhatian.paguLewatKet": "Gambar dan video sudah berhenti; konten dan balasan chat menyusul.",
  "s1.perhatian.paguLewatBuka": "Buka pagu",
  "s1.perhatian.paguDekat": "Pemakaian {{tenant}} sudah {{n}}% dari pagunya",
  "s1.perhatian.paguDekatKet": "Sudah melewati ambang peringatannya.",
  "s1.perhatian.paguDekatBuka": "Buka pagu",
  "s1.perhatian.onboarding": "{{tenant}} berhenti di langkah {{n}} dari 7",
  "s1.perhatian.onboardingKet": "Onboarding-nya belum selesai.",
  "s1.perhatian.onboardingBuka": "Lanjutkan",
  "s1.tenant.judul": "Tenant",
  "s1.kartu.pemakaian": "Pemakaian",
  "s1.kartu.onboarding": "Onboarding",
  "s1.kartu.batang": "Pagu {{nama}} yang terpakai",
  "s2.ket": "Semua tenant",
  "s2.ringkas": "{{n}} tenant",
  "s2.gagal": "Daftar tenant tidak termuat",
  "s2.saring": "Saring mode",
  "s2.semua": "Semua",
  "s2.baru": "Tenant baru",
  "s2.daftar": "Daftar tenant",
  "s2.kosong": "Belum ada tenant",
  "s2.kosongKet": "Buat tenant pertama, lalu ikuti langkah onboarding-nya.",
  "s2.tidakAda": "Tidak ada tenant di mode ini",
  "s2.tidakAdaKet": "Pilih saringan lain.",
  "s2.belumAktif": "belum pernah",
  "s2.kolom.tenant": "Tenant",
  "s2.kolom.mode": "Mode",
  "s2.kolom.sambungan": "Sambungan",
  "s2.kolom.onboarding": "Onboarding",
  "s2.kolom.pemakaian": "Pemakaian",
  "s2.kolom.aktif": "Aktif terakhir",
  "s3.ket": "Tenant baru mulai di mode Draf: bot diam sampai Anda memindahkannya.",
  "s3.remah": "Jejak halaman",
  "s3.data.judul": "Data tenant",
  "s3.data.ket": "Sisanya diisi lewat langkah onboarding sesudah tenant dibuat.",
  "s3.nama": "Nama tenant",
  "s3.namaContoh": "Contoh: Klinik Gigi Senyum",
  "s3.zona": "Zona waktu",
  "s3.mode": "Mode awal",
  "s3.buat": "Buat tenant",
  "s3.toast": "{{nama}} dibuat, di mode Draf",
  "s4.ket": "{{zona}} · id {{id}}…",
  "s4.gagal": "Tenant tidak termuat",
  "s4.tidakAda": "Tenant tidak ditemukan",
  "s4.tidakAdaKet": "Alamatnya mungkin salah, atau tenant ini bukan milik sistem ini.",
  "s4.tab.label": "Bagian detail tenant",
  "s4.tab.ikhtisar": "Ikhtisar",
  "s4.tab.sambungan": "Sambungan",
  "s4.tab.orang": "Orang",
  "s4.tab.paket": "Paket & pagu",
  "s4.tab.aktivitas": "Aktivitas",
  "s4.mode.ubah": "Ubah mode",
  "s4.mode.judul": "Ubah mode {{nama}}",
  "s4.mode.ket": "Mode menentukan siapa yang menerima balasan bot.",
  "s4.mode.legenda": "Mode tenant",
  "s4.mode.sekarang": "sekarang",
  "s4.mode.arti.draft": "Bot diam untuk semua orang.",
  "s4.mode.arti.test": "Bot hanya menjawab akun uji.",
  "s4.mode.arti.live": "Bot menjawab semua pesan.",
  "s4.mode.pilihLain": "Pilih mode lain",
  "s4.mode.pindah": "Pindah ke {{mode}}",
  "s4.mode.akibat.draft": "Semua balasan {{nama}} berhenti, termasuk ke prospek yang sedang bercakap.",
  "s4.mode.akibat.test": "Prospek sungguhan tidak dibalas lagi. Hanya akun uji yang menerima balasan.",
  "s4.mode.akibat.live": "Bot mulai membalas semua akun Instagram dan Facebook yang menghubungi {{nama}}.",
  "s4.mode.toast": "{{nama}} pindah ke mode {{mode}}",
  "s4.angka.pakai": "Pemakaian bulan ini",
  "s4.angka.onboarding": "Onboarding",
  "s4.angka.berikutnya": "Berikutnya: {{langkah}}",
  "s4.angka.selesai": "Sudah diserahkan ke klien",
  "s4.angka.terkunci": "Langkah berikutnya masih terkunci",
  "s4.angka.mode": "Mode",
  "s4.kurang.judul": "Yang masih kurang supaya bot jalan",
  "s4.ob.judul": "Onboarding",
  "s4.ob.ket": "{{n}} dari {{dari}} langkah selesai.",
  "s4.ob.berikutnya": "Berikutnya",
  "s4.ob.buka": "Buka",
  "s4.ob.langkah.tenant": "Tenant dibuat",
  "s4.ob.langkah.tim": "Grup Telegram dan tim tertaut",
  "s4.ob.langkah.pengetahuan": "Pengetahuan diunggah Tenant Admin",
  "s4.ob.langkah.paket": "Fitur dan model dipilih",
  "s4.ob.langkah.sambungan": "Instagram tersambung dengan token yang berlaku",
  "s4.ob.langkah.pesan_masuk": "Pesan pertama masuk",
  "s4.ob.langkah.serah_terima": "Tenant Admin pernah masuk",
  "s4.ob.keadaan.selesai": "selesai",
  "s4.ob.keadaan.sekarang": "berikutnya",
  "s4.ob.keadaan.menunggu": "belum",
  "s4.ob.keadaan.terkunci": "terkunci sampai langkah sebelumnya selesai",
  "s4.konfig.judul": "Konfigurasi klien",
  "s4.konfig.ket": "Diatur Tenant Admin. Di sini dibaca saja.",
  "s4.konfig.bacaSaja": "Baca saja",
  "s4.konfig.belum": "belum diatur",
  "s4.konfig.bot": "Bot",
  "s4.konfig.botIsi": "{{nama}} · {{gaya}}",
  "s4.konfig.melayani": "Melayani",
  "s4.konfig.jadwal": "Jadwal balas",
  "s4.konfig.jadwal24": "24 jam",
  "s4.konfig.jadwalIsi": "{{n}} hari · {{mulai}}–{{selesai}}",
  "s4.konfig.pengetahuan": "Pengetahuan",
  "s4.konfig.pengetahuanIsi": "{{n}} dari {{dari}} dokumen dipakai",
  "s4.konfig.model": "Model chat",
  "s4.konfig.modelBawaan": "bawaan Smova",
  "s4.konfig.slot": "Slot terbit",
  "s4.konfig.dokumen": "Dokumen pengetahuan",
  "s4.mati.judul": "Fitur yang mati",
  "s4.mati.ket": "Yang mati menjelaskan perilaku tenant ini.",
  "s4.jejak.judul": "Jejak perubahan",
  "s4.jejak.ket": "Siapa mengubah apa, terbaru dulu.",
  "s4.jejak.gagal": "Jejak perubahan tidak termuat",
  "s4.jejak.kosong": "Belum ada perubahan tercatat",
  "s4.jejak.oleh": "oleh {{siapa}}",
  "s4.jejak.sistem": "sistem",
  "s4.jejak.apa.settings": "Setelan",
  "s4.jejak.apa.persona": "Persona",
  "s4.jejak.apa.jadwal": "Jadwal",
  "s4.jejak.apa.libur": "Tanggal libur",
  "s4.jejak.apa.template": "Pesan bawaan",
  "s4.jejak.apa.meeting_setelan": "Syarat meeting",
  "s4.jejak.apa.model": "Model",
  "s4.jejak.apa.field_profil": "Data prospek",
  "s4.jejak.apa.pengetahuan": "Dokumen pengetahuan",
  "s4.jejak.apa.web_user": "Akun orang",
  "s4.jejak.apa.tenant": "Tenant",
  "s4.jejak.apa.pagu": "Pagu",
  "s4.jejak.apa.fitur": "Fitur",
  "s4.jejak.apa.orang": "Orang (prospek dan percakapan)",
  "s4.jejak.aksi.dihapus": "dihapus permanen",
  "s4.jejak.aksi.created": "dibuat",
  "s4.jejak.aksi.updated": "diubah",
  "s4.jejak.aksi.deleted": "dihapus",
  "s4.jejak.aksi.activated": "diaktifkan",
  "s4.jejak.aksi.deactivated": "dinonaktifkan",
  "s4.masuk.judul": "Pesan masuk terakhir",
  "s4.masuk.ket": "Webhook dari platform tenant ini.",
  "s4.masuk.semua": "Jejak alur tenant ini",
  "s4.masuk.gagal": "Pesan masuk tidak termuat",
  "s4.masuk.kosong": "Belum ada pesan masuk",
  "s4.masuk.kosongKet": "Belum ada webhook yang sampai untuk tenant ini.",
  "s4.orang.judul": "Orang di {{nama}}",
  "s4.orang.ket": "Saklar Aktif langsung tersimpan. Mengubah peran ditanya dulu.",
  "s4.orang.kosong": "Belum ada orang",
  "s4.orang.kosongKet": "Tambahkan Tenant Admin pertama untuk tenant ini.",
  "s4.orang.tambah": "Tambah orang",
  "s4.orang.nama": "Nama",
  "s4.orang.email": "Email",
  "s4.orang.emailKet": "Dipakai untuk masuk. Satu email satu akun di seluruh Smova.",
  "s4.orang.namaKet": "Dibaca tim di pemilih peserta, pesan grup, dan catatan.",
  "s4.orang.peran": "Peran",
  "s4.orang.sandi": "Sandi awal",
  "s4.orang.formKet": "Orangnya masuk dengan email dan sandi awal ini; berikan sandinya ke orangnya. Menautkan Telegram dilakukan lewat kode /join dari Tenant Admin.",
  "s4.orang.toastTambah": "{{nama}} ditambahkan",
  "s4.orang.sebutan": "{{nama}}, akun aktif",
  "s4.orang.aktif": "akun aktif",
  "s4.orang.nonaktif": "akun nonaktif, tidak bisa masuk",
  "s4.orang.ubahPeran": "Ubah peran",
  "s4.orang.peranTanya": "Jadikan {{nama}} {{peran}}?",
  "s4.orang.peranAkibat.tenant_admin": "Peran menentukan menu yang terlihat. Tenant Admin bisa membuka Pengaturan.",
  "s4.orang.peranAkibat.tenant_marketing": "Peran menentukan menu yang terlihat. Tenant Marketing tidak bisa membuka Pengaturan lagi.",
  "s4.orang.peranYa": "Jadikan {{peran}}",
  "s4.orang.toastPeran": "{{nama}} kini {{peran}}",
  "s4.orang.taut": "Taut Telegram",
  "s4.orang.tgId": "ID Telegram",
  "s4.orang.tgIdKet": "Angka, bukan nama pengguna. Kosongkan untuk melepas tautannya.",
  "s4.orang.tgNama": "Nama pengguna Telegram",
  "s4.orang.toastTaut": "Tautan Telegram disimpan",
  "s4.fitur.judul": "Fitur yang tersedia",
  "s4.fitur.ket": "Ketergantungan ditegakkan di barisnya. Tenant Admin memilih sendiri apakah yang otomatis dijalankan.",
  "s4.fitur.butuh": "butuh {{daftar}}",
  "s4.fitur.dibutuhkan": "dipakai {{daftar}}",
  "s4.pagu.judul": "Pagu belanja AI",
  "s4.pagu.ket": "Batas belanja AI per bulan.",
  "s4.pagu.pagu": "Pagu bulanan (USD)",
  "s4.pagu.paguKet": "Kosongkan untuk tanpa pagu.",
  "s4.pagu.paguSalah": "Isi angka 0 sampai {{n}}, atau kosongkan.",
  "s4.pagu.ambang": "Peringatan pada (%)",
  "s4.pagu.ambangKet": "Tim diberi tahu saat pemakaian menyentuh angka ini.",
  "s4.pagu.ambangSalah": "Isi angka bulat 10 sampai 100.",
  "s4.model.judul": "Model",
  "s4.model.ket": "Dipilih Tenant Admin. Di sini dibaca saja.",
  "s4.model.chat": "Chat",
  "s4.model.text": "Teks konten",
  "s4.model.image": "Gambar",
  "s4.model.video": "Video",
  "s4.tutup": "Tutup",
  "s4.akun.tanpaAdapter": "Platform ini belum bisa disambungkan dari Smova.",
  "s4.akun.tokenAda": "token tersimpan",
  "s4.akun.tokenTiada": "token belum dimuat",
  "s4.akun.aktif": "Akun {{platform}} aktif",
  "s4.akun.aktifKet": "Yang mati tidak menerima pesan dan tidak menerbitkan konten.",
  "s4.akun.sambung": "Sambungkan akun",
  "s4.akun.ganti": "Ganti akun atau token",
  "s4.akun.uji": "Uji koneksi",
  "s4.akun.ujiLulus": "Koneksi berjalan",
  "s4.akun.ujiGagal": "Koneksi gagal",
  "s4.akun.id": "ID akun atau Page",
  "s4.akun.idKet": "ID ini menentukan pesan Meta masuk ke tenant mana. Periksa dua kali.",
  "s4.akun.token": "Token baru",
  "s4.akun.tokenKet": "Kosongkan kalau hanya mengganti akunnya. Disimpan terenkripsi dan tidak ditampilkan lagi.",
  "s4.akun.berakhir": "Token berakhir pada",
  "s4.akun.simpan": "Simpan akun",
  "s4.akun.sambungTanya": "Sambungkan akun {{platform}} ini?",
  "s4.akun.sambungAkibat": "Pesan dari akun ini mulai masuk ke tenant ini.",
  "s4.akun.gantiTanya": "Ganti akun {{platform}} tenant ini?",
  "s4.akun.gantiAkibat": "Akun lama dimatikan. Kalau token diisi, token lama diganti dan tidak bisa dipasang lagi dari sini.",
  "s4.akun.toast": "Akun {{platform}} disimpan",
  "s4.akun.toastToken": "Akun {{platform}} disimpan, tokennya diganti",
  "s4.akun.peringatan": "Tersimpan, dengan catatan",
  "s4.tukar.judul": "Tukar token Meta",
  "s4.tukar.ket": "Token pengguna berumur pendek ditukar jadi token Halaman yang berumur panjang, lalu disimpan.",
  "s4.tukar.token": "Token pengguna",
  "s4.tukar.halaman": "ID Halaman",
  "s4.tukar.halamanKet": "Kosongkan kalau tokennya hanya punya satu Halaman.",
  "s4.tukar.tombol": "Tukar dan simpan",
  "s4.tukar.toast": "Token Halaman disimpan",
  "s4.tukar.hasil": "Token untuk {{nama}} tersimpan",
  "s4.tukar.berakhir": "Berakhir {{tanggal}}.",
  "s4.tukar.tanpaAkhir": "Tanpa tanggal berakhir.",
  "s4.grup.ket": "Tempat notifikasi tim dikirim.",
  "s4.grup.gagal": "Grup tidak termuat",
  "s4.grup.kosong": "Belum ada grup. Tanpa grup, tim tidak menerima notifikasi.",
  "s4.grup.sebutan": "Grup {{nama}}",
  "s4.grup.chat": "chat_id grup",
  "s4.grup.chatKet": "Angka, biasanya diawali -100.",
  "s4.grup.label": "Nama grup",
  "s4.grup.tambah": "Tambah grup",
  "s4.grup.toast": "Grup ditambahkan",
  "s4.kred.judul": "Kredensial",
  "s4.kred.ket": "Disimpan terenkripsi. Isinya tidak pernah ditampilkan lagi.",
  "s4.kred.gagal": "Kredensial tidak termuat",
  "s4.kred.kosong": "Belum ada kredensial yang dimuat.",
  "s4.kred.muat": "Muat kunci",
  "s4.kred.diisi": "dimuat {{tanggal}}",
  "s4.kred.berakhir": "berakhir {{tanggal}}",
  "s4.kred.tanpaAkhir": "tanpa tanggal berakhir",
  "s4.kred.berlaku": "Berlaku",
  "s4.kred.kedaluwarsa": "Kedaluwarsa",
  "s4.kred.lama": "Sudah diganti",
  "s4.kred.penyedia": "Penyedia",
  "s4.kred.berakhirPada": "Berakhir pada",
  "s4.kred.nilai": "Kunci atau token",
  "s4.kred.simpan": "Simpan kunci",
  "s4.kred.tanya": "Ganti kunci {{penyedia}} tenant ini?",
  "s4.kred.akibat": "Kunci lama berhenti dipakai dan tidak bisa dipasang lagi dari sini.",
  "s4.kred.toast": "Kunci {{penyedia}} disimpan",
  "s4.uji.judul": "Akun uji",
  "s4.uji.ket": "Hanya akun ini yang dibalas bot saat tenant di mode Uji.",
  "s4.uji.gagal": "Akun uji tidak termuat",
  "s4.uji.kosong": "Belum ada akun uji. Di mode Uji, bot diam untuk semua orang.",
  "s4.uji.baru": "Akun uji baru",
  "s4.uji.tambah": "Tambah akun uji",
  "s4.uji.hapus": "Hapus akun uji {{akun}}",
  "s4.uji.toastTambah": "{{akun}} jadi akun uji",
  "s4.uji.toastHapus": "{{akun}} bukan akun uji lagi",
  "s6.ket": "Belanja AI semua tenant, {{bulan}}",
  "s6.angka.total": "Belanja bulan ini",
  "s6.angka.lewat": "Tenant melewati ambang",
  "s6.angka.lewatKet": "Di ambang peringatan atau di atas pagunya.",
  "s6.tenant.judul": "Per tenant",
  "s6.tenant.ket": "Bulan ini, dibanding pagu masing-masing. Pagu diubah di detail tenant.",
  "s6.rinci.judul": "Rincian satu tenant",
  "s6.rinci.tenant": "Tenant",
  "s7.ket": "Fitur dan model AI yang bisa dipakai tenant",
  "s7.tab.label": "Bagian Katalog",
  "s7.tab.fitur": "Fitur",
  "s7.tab.model": "Model AI",
  "s7.dipakai": "dipakai {{n}} tenant",
  "s7.fitur.judul": "Fitur",
  "s7.fitur.ket": "Daftar ini berubah lewat rilis Smova, bukan dari layar ini. Menyalakan fitur untuk satu tenant ada di detail tenant, tab Paket & pagu.",
  "s7.fitur.gagal": "Katalog fitur tidak termuat",
  "s7.fitur.kosong": "Katalog fitur kosong",
  "s7.fitur.butuh": "butuh",
  "s7.fitur.ditawarkan": "Ditawarkan",
  "s7.fitur.ditarik": "Ditarik",
  "s7.model.judul": "Model AI",
  "s7.model.ket": "Yang aktif bisa dipilih Tenant Admin untuk keperluannya.",
  "s7.model.gagal": "Katalog model tidak termuat",
  "s7.model.kosong": "Belum ada model di katalog",
  "s7.model.tambah": "Tambah model",
  "s7.model.id": "ID model di penyedia",
  "s7.model.nama": "Nama yang ditampilkan",
  "s7.model.penyedia": "Penyedia",
  "s7.model.peran": "Muncul di",
  "s7.model.tingkat": "Tingkat",
  "s7.model.tanpaTingkat": "Tanpa tingkat",
  "s7.tingkat.hemat": "Hemat",
  "s7.tingkat.seimbang": "Seimbang",
  "s7.tingkat.terbaik": "Terbaik",
  "s7.model.formKet": "ID model dan tempat munculnya tidak bisa diubah sesudah disimpan: model yang salah dinonaktifkan lalu didaftarkan lagi. Tarif boleh menyusul.",
  "s7.model.toastTambah": "{{nama}} ditambahkan ke katalog",
  "s7.model.rasio": "Rasio bawaan",
  "s7.model.rasioPenyedia": "Ikut penyedia",
  "s7.model.simpanRasio": "Simpan rasio",
  "s7.model.toastRasio": "Rasio bawaan {{nama}} disimpan",
  "s7.model.nonaktifkan": "Nonaktifkan",
  "s7.model.aktifkan": "Aktifkan",
  "s7.model.nonaktifTanya": "Nonaktifkan {{nama}}?",
  "s7.model.nonaktifDipakai": "{{n}} tenant sedang memakainya. Model ini akan dilewati: mereka pindah ke cadangan berikutnya, atau ke bawaan Smova kalau tidak punya cadangan.",
  "s7.model.nonaktifBebas": "Belum ada tenant yang memakainya. Model ini hilang dari pilihan Tenant Admin.",
  "s7.model.toastNonaktif": "{{nama}} dinonaktifkan",
  "s7.model.toastAktif": "{{nama}} diaktifkan",
  "s7.tarif.kosong": "Tarif belum diisi",
  "s7.tarif.input_per_juta": "Tarif masuk per 1 juta token (US$)",
  "s7.tarif.output_per_juta": "Tarif keluar per 1 juta token (US$)",
  "s7.tarif.per_gambar": "Tarif per gambar (US$)",
  "s7.tarif.per_detik": "Tarif per detik video (US$)",
  "s7.harga.input_per_juta": "{{harga}} masuk per 1 juta token",
  "s7.harga.output_per_juta": "{{harga}} keluar per 1 juta token",
  "s7.harga.per_gambar": "{{harga}} per gambar",
  "s7.harga.per_detik": "{{harga}} per detik video",
  "s7.kem.referensi": "menerima gambar referensi",
  "s7.kem.rasioDiabaikan": "rasio diabaikan saat memakai referensi",
  "s7.kem.detik": "{{nilai}} detik",
  "s7.kem.belumSinkron": "kemampuan belum disinkron",
  "s8.ket": "Kesehatan layanan dan akun operator",
  "s8.ketLingkungan": "Kesehatan layanan dan akun operator · lingkungan {{lingkungan}}",
  "s8.gagal": "Kesehatan sistem tidak termuat",
  "s8.periksa.judul": "Pemeriksaan",
  "s8.periksa.ket": "Dibaca dari data yang sudah tercatat. Membuka layar ini tidak memanggil penyedia mana pun.",
  "s8.nada.ok": "Baik",
  "s8.nada.warn": "Perlu dilihat",
  "s8.nada.bad": "Bermasalah",
  "s8.cek.migrasi.nama": "Migrasi database",
  "s8.cek.migrasi.ket": "Revisi skema yang sedang berlaku di database ini.",
  "s8.cek.tenant.nama": "Tenant per mode",
  "s8.cek.tenant.ket": "Hanya tenant live yang mengirim sesuatu keluar.",
  "s8.cek.webhook.nama": "Webhook masuk, 24 jam",
  "s8.cek.webhook.ket": "Yang tanpa tenant datang ke akun yang belum didaftarkan, dan selalu perlu ditindaklanjuti.",
  "s8.cek.biaya.nama": "Panggilan tanpa tarif, 30 hari",
  "s8.cek.biaya.ket": "Selama di atas nol, angka biaya di mana pun adalah batas bawah, bukan total.",
  "s8.cek.model.nama": "Model aktif tanpa tarif",
  "s8.cek.model.ket": "Tarifnya diisi dari daftar harga penyedia, lewat skrip tarif di server.",
  "s8.cek.timer_terbit.nama": "Timer terbit",
  "s8.cek.timer_terbit.ket": "Tiap 10 menit. Disebut terlambat sesudah 30 menit tanpa detak.",
  "s8.cek.timer_scraping.nama": "Timer cari bahan",
  "s8.cek.timer_scraping.ket": "Tiap jam; jadwal tiap tenant yang memutuskan dikerjakan atau tidak. Terlambat sesudah 3 jam.",
  "s8.cek.timer_pengingat.nama": "Pengingat H-1",
  "s8.cek.timer_pengingat.ket": "Tiap hari 08.00. Terlambat sesudah 26 jam.",
  "s8.cek.timer_sapu.nama": "Sapu media & konsep",
  "s8.cek.timer_sapu.ket": "Tiap hari 03.00: media yatim, konsep basi, dan catatan jalan lewat 90 hari. Terlambat sesudah 26 jam.",
  "s8.timer.berhasil": "Terakhir jalan {{kapan}}",
  "s8.timer.gagal": "Terakhir jalan {{kapan}}, dan gagal",
  "s8.timer.terlambat": "Terlambat: terakhir jalan {{kapan}}",
  "s8.timer.belum": "Belum pernah tercatat jalan",
  "s8.webhook": "Webhook terakhir diterima {{kapan}}.",
  "s8.webhookBelum": "Belum pernah ada webhook yang diterima.",
  "s8.operator.judul": "Operator Smova",
  "s8.operator.ket": "Akun yang bisa membuka semua tenant.",
  "s8.operator.kosong": "Tidak ada akun operator",
  "s8.operator.masuk": "terakhir masuk {{kapan}}",
  "s8.operator.belumMasuk": "belum pernah masuk",
  "s5.ket": "Setiap alur meninggalkan catatan jalan, dari pemicu sampai kiriman keluar",
  "s5.tab.label": "Bagian Jejak alur",
  "s5.tab.jalan": "Catatan jalan",
  "s5.tab.masuk": "Pesan masuk",
  "s5.tenant": "Tenant",
  "s5.semuaTenant": "Semua tenant",
  "s5.saring.label": "Saring menurut keadaan",
  "s5.saring.semua": "Semua",
  "s5.saring.dengan": "{{nama}} · {{n}}",
  "s5.jalan.judul": "Catatan jalan",
  "s5.langkah": "Langkah {{nama}}",
  "s5.gagal": "Catatan jalan tidak termuat",
  "s5.kosong": "Belum ada catatan jalan",
  "s5.kosongKet": "Barisnya muncul begitu ada DM masuk, timer yang mengerjakan sesuatu, atau kiriman dari layar.",
  "s5.kosongSaring": "Tidak ada alur di saringan ini",
  "s5.kosongSaringKet": "Pilih saringan lain.",
  "s5.sebagian": "Menampilkan {{n}} dari {{total}} jalan.",
  "s5.lagi": "Tampilkan lebih banyak",
  "s5.status.berhasil": "Berhasil",
  "s5.status.gagal": "Gagal",
  "s5.status.ditahan": "Ditahan",
  "s5.status.berjalan": "Berjalan",
  "s5.keadaan.ok": "selesai",
  "s5.keadaan.warn": "perlu dilihat",
  "s5.keadaan.bad": "gagal",
  "s5.keadaan.idle": "tidak dikerjakan",
  "s5.alur.dm": "DM masuk",
  "s5.alur.komentar": "Komentar masuk",
  "s5.alur.telegram": "Telegram",
  "s5.alur.tombol": "Tombol Telegram",
  "s5.alur.rekaman": "Rekaman meeting",
  "s5.alur.terbit": "Terbit terjadwal",
  "s5.alur.pengingat": "Pengingat H-1",
  "s5.alur.scraping": "Cari bahan",
  "s5.alur.sapu_konsep": "Sapu konsep",
  "s5.alur.kabar_meeting": "Kabar meeting ke grup",
  "s5.alur.kabar_jadwal_prospek": "DM jadwal ke prospek",
  "s5.alur.tawaran_meeting": "Tawaran meeting",
  "s5.masuk.tenant": "Tenant",
  "s5.masuk.semuaTenant": "Semua tenant",
  "s5.masuk.tanpaTenant": "Tanpa tenant",
  "s5.masuk.saring": "Saring menurut keadaan",
  "s5.masuk.hitungGagal": "Hitungan kejadian tidak termuat",
  "s5.masuk.kejadian.judul": "Kejadian",
  "s5.masuk.kejadian.ket": "Terbaru di atas, tanpa isi pesan. Membuka isi sebuah kejadian dicatat di jejak audit: siapa, kapan, dan kejadian mana.",
  "s5.masuk.gagal": "Daftar kejadian tidak termuat",
  "s5.masuk.kosong": "Tidak ada kejadian yang cocok",
  "s5.masuk.kosongKet": "Longgarkan saringannya, atau tunggu webhook berikutnya.",
  "s5.masuk.buka": "Buka isi",
  "s5.masuk.tutup": "Tutup isi",
  "s5.masuk.isi": "Isi mentah kejadian",
  "s5.masuk.isiGagal": "Isi kejadian tidak termuat",
  "s5.masuk.sebagian": "Menampilkan {{n}} dari {{total}} kejadian.",
  "s5.masuk.lagi": "Tampilkan lebih banyak",
  "k6.tolakTanya": "Tolak konten ini?",
  "k6.tolakKet": "Konten ini hilang dari daftar dan tidak diterbitkan di platform mana pun. Sesudahnya masih bisa diurungkan dari notifikasinya.",
  "k7.gambar.perbesar": "Lihat gambar ukuran penuh",
  "k7.gambar.tabBaru": "Buka di tab baru",
  "umum.ubah": "Ubah",
  "k4.catatanSebut": "catatan {{meeting}}",
  "k4.catatanAjak": "Belum ada catatan. Tulis apa yang dibicarakan dan disepakati.",
  "k4.catatanMeetingContoh": "Apa yang dibicarakan dan disepakati?",
  "k4.catatanMeetingKet": "Hanya untuk tim. Tidak dikirim ke siapa pun.",
  "k4.toast.catatanMeetingHapus": "Catatan {{meeting}} dihapus",
  "k4.rekamanNanti": "Rekaman bisa ditambahkan mulai hari meetingnya.",
  "k4.tanpaRekaman": "Tanpa rekaman",
  "k4.aksiLain": "Aksi lain {{meeting}}",
  "k4.kelompok.perlu": "Perlu tindakan",
  "k4.kelompok.datang": "Akan datang",
  "k4.kelompok.riwayat": "Riwayat",
  "k4.keadaan.terjadwal": "Terjadwal",
  "k4.keadaan.perluDitutup": "Belum ditutup",
  "k4.keadaan.tanpaTanggal": "Belum bertanggal",
  "k4.pesertaBelum": "Belum ada peserta",
  "k4.salahCatat": "Hasilnya salah dicatat?",
  "k4.saring.label": "Saring catatan",
  "k4.saring.semua": "Semua {{n}}",
  "k4.saring.jenis": "{{jenis}} {{n}}",
  "k4.saringKosong": "Belum ada catatan jenis ini.",
  "k4.jenis.tim": "Catatan tim",
  "k4.jenis.meeting": "Catatan meeting",
  "k4.jenis.bot": "Dari bot",
  "k4.catatanRincian": "Rincian catatan",
  "k4.toast.catatanUbah": "Catatan diubah",
  "k4.catatanHapus": "Hapus catatan",
  "k4.catatanHapusTanya": "Hapus catatan \"{{judul}}\"?",
  "k4.catatanHapusKet": "Catatannya hilang dari halaman ini dan tidak bisa dikembalikan.",
  "k4.toast.catatanHapus": "Catatan dihapus",
  "k4.lihatMeeting": "Lihat meetingnya",
  "k4.kamus.judul": "Tiga jenis catatan",
  "k4.kamus.ket": "Semuanya hanya untuk tim. Tidak ada yang dikirim ke prospek.",
  "k4.kamus.tim": "Yang terjadi di luar chat dan meeting: telepon, proposal, kunjungan. Ditulis tim di tab ini.",
  "k4.kamus.meeting": "Apa yang dibicarakan dan disepakati di satu meeting. Ditulis di kartu meetingnya, dan ikut tampil di sini.",
  "k4.kamus.bot": "Ditulis bot saat menyerahkan sesuatu ke tim, misalnya prospek meminta jadwal di luar pilihan.",
  "k9.terima.ketKirim": "Pesan ini langsung dikirim ke orangnya, selama masih dalam 24 jam sejak pesan terakhirnya:",
  "k9.terima.ketPindah": "Calon ini pindah ke Prospek. Kalau pesannya tidak bisa dikirim, bot menawarkannya begitu ia membalas lagi.",
  "k9.terima.kirim": "Terima dan kirim tawaran",
  "k9.toast.terimaHasil": "{{nama}} diterima. {{hasil}}",
  "k1.grup.judul": "Anda belum di grup Telegram tim",
  "k1.grup.masuk": "Masuk grup tim lewat tautan ini:",
  "k1.grup.masukNama": "Masuk grup {{grup}} lewat tautan ini:",
  "k1.grup.tanpaTautan": "Tautan grupnya belum diisi operator Smova. Minta tautannya ke Tenant Admin Anda.",
  "k1.grup.join": "Ketik /join KODE sekali di grup. Kodenya dari Tenant Admin Anda.",
  "k1.grup.joinAdmin": "Ketik /join KODE sekali di grup. Buat kodenya di Tim, tombol ⋯ di baris Anda, Buat kode /join.",
  "p5.grupTautan": "Tautan masuk grup:",
  "p6.grup.tanpaTautan": "Belum ada tautan undangan. Diisi operator Smova.",
  "s4.grup.tautan": "Tautan undangan {{nama}}",
  "s4.grup.tautanKet": "Dari Telegram: info grup › Undang lewat tautan. Ditunjukkan ke tim yang belum /join, di Sambungan, Tim, dan Hari ini.",
  "s4.grup.tautanSimpan": "Simpan tautan",
  "s4.grup.tautanToast": "Tautan undangan disimpan",
  "s4.grup.tautanCabut": "Tautan undangan dicabut",
  "hapusOrang.menu": "Hapus orang ini…",
  "hapusOrang.menuLabel": "Aksi lain untuk {{nama}}",
  "hapusOrang.tanya": "Hapus {{nama}} permanen?",
  "hapusOrang.menghitung": "Menghitung yang ikut terhapus…",
  "hapusOrang.gagalHitung": "Yang ikut terhapus tidak bisa dihitung",
  "hapusOrang.ditahan": "{{nama}} belum bisa dihapus",
  "hapusOrang.ikut": "Ikut terhapus: {{rincian}}.",
  "hapusOrang.jumlah": "{{apa}}: {{n}}",
  "hapusOrang.apa.pesan": "Pesan masuk",
  "hapusOrang.apa.balasan_tim": "Balasan tim",
  "hapusOrang.apa.prospek": "Prospek",
  "hapusOrang.apa.meeting": "Meeting",
  "hapusOrang.apa.catatan_proses": "Catatan",
  "hapusOrang.apa.jejak": "Jejak",
  "hapusOrang.ket": "Semua DM dan komentarnya di Smova, data prospeknya, meeting beserta rekamannya, dan catatannya hilang, dan tidak bisa diurungkan. Kalau ia menulis lagi, bot menganggapnya orang baru. DM aslinya di Instagram atau Facebook dan kartunya di grup Telegram tidak ikut terhapus.",
  "hapusOrang.ya": "Hapus permanen",
  "hapusOrang.toast": "{{nama}} dihapus permanen",
  "landing.judulHalaman": "Smova oleh Seleris · Asisten DM Instagram",
  "landing.oleh": "oleh",
  "landing.nav.label": "Navigasi utama",
  "landing.nav.merekAtas": "Smova oleh Seleris, ke atas halaman",
  "landing.nav.caraKerja": "Cara kerja",
  "landing.nav.konten": "Konten",
  "landing.nav.tanyaJawab": "Tanya jawab",
  "landing.nav.kontak": "Kontak",
  "landing.nav.masuk": "Masuk",
  "landing.mintaDemo": "Minta demo",
  "landing.mintaDemoWa": "Minta demo lewat WhatsApp",
  "landing.waPesan": "Halo Seleris, saya ingin melihat demo Smova",
  "landing.contohKet": "Contoh. Calon klien dan isi percakapan karangan; jawaban dari dokumen Seleris.",
  "landing.hero.pil": "Asisten DM Instagram, dipasang dan dirawat Seleris",
  "landing.hero.judul1": "Chat masuk Sabtu malam.",
  "landing.hero.judul2": "Senin pagi, jadwal meetingnya",
  "landing.hero.judul3": "sudah ada di grup tim Anda.",
  "landing.hero.lede": "Smova menjawab DM Instagram perusahaan Anda dari dokumen produk Anda sendiri, menanyakan data calon klien satu per satu, lalu memesan jam meeting dari jadwal yang Anda atur.",
  "landing.hero.waKet": "Membuka WhatsApp dengan pesan yang sudah terisi.",
  "landing.hero.status": "Hari ini: membalas DM Instagram, dan menerbitkan konten ke Instagram dan Facebook.",
  "landing.jaga.judul": "Yang selalu dijaga bot",
  "landing.jaga.1": "Hanya menyebut produk yang ada di dokumen Anda.",
  "landing.jaga.2": "Memeriksa ulang jadwal sebelum memesan meeting.",
  "landing.jaga.3": "Tidak mengaku manusia, dan tidak menjanjikan hal di luar pengaturan.",
  "landing.panggung.cip1": "Sabtu 21.47 · kantor tutup",
  "landing.panggung.cip2": "Senin 10.00 WIB · presentasi tercatat",
  "landing.panggung.cip3": "Dijawab dari dokumen Seleris",
  "landing.panggung.maskot": "Maskot astronaut Seleris melambaikan tangan",
  "landing.ponsel.label": "Contoh DM Instagram: Rina Kartika bertanya tentang Seleris Care, lalu Asisten Seleris menjawab dari dokumen Seleris dan menanyakan nama perusahaannya",
  "landing.ponsel.dm": "DM Instagram",
  "landing.ponsel.waktu": "Sabtu 21.47",
  "landing.ponsel.labelKlien": "Rina Kartika · calon klien",
  "landing.ponsel.klien1": "Malam. Kami ingin cek kesehatan 400 karyawan di 5 cabang. Seleris Care bisa untuk perusahaan? Bisa presentasi minggu depan?",
  "landing.ponsel.labelBot": "Asisten Seleris · bot",
  "landing.ponsel.bot1": "Selamat malam, Bu. Bisa. Untuk perusahaan ada Seleris Care paket Prime: pemeriksaannya lewat video wajah sekitar 30 detik dari kamera smartphone, tanpa alat medis dan tanpa kontak fisik. Supaya presentasinya pas, boleh saya tahu nama perusahaan Ibu?",
  "landing.ponsel.klien2": "PT Mitra Niaga Logistik.",
  "landing.ponsel.tulis": "Tulis pesan…",
  "landing.ck.pil": "Cara kerja, dengan contoh yang sama",
  "landing.ck.judul1": "Dari satu DM Sabtu malam",
  "landing.ck.judul2": "sampai ringkasan sesudah meeting.",
  "landing.ck.sub": "Anda menyiapkan dokumen produk dan aturan jadwal. Bot memakai keduanya saat menjawab, dan tim Anda dikabari lewat grup Telegram.",
  "landing.ck.l1Tag": "Sabtu 21.47",
  "landing.ck.l1Judul": "DM dijawab dari dokumen",
  "landing.ck.l1Ket": "Rina bertanya soal Seleris Care. Bot menjawab dari dokumen produk Seleris.",
  "landing.ck.l2Tag": "Di percakapan yang sama",
  "landing.ck.l2Judul": "Data ditanyakan satu per satu",
  "landing.ck.l2Ket": "Perusahaan, alamat, PIC, email, telepon, dan pertanyaan Anda sendiri.",
  "landing.ck.l3Tag": "Dari jadwal Anda",
  "landing.ck.l3Judul": "Jam meeting dipesan",
  "landing.ck.l3Ket": "Bot menawarkan jam yang masih kosong, memeriksa ulang, lalu memesannya.",
  "landing.ck.l4Tag": "Saat meeting dipesan",
  "landing.ck.l4Judul": "Tim dikabari di Telegram",
  "landing.ck.l4Ket": "Satu urusan, satu kartu di grup tim, dan kartu itu yang diperbarui.",
  "landing.ck.l5Tag": "Senin 11.05",
  "landing.ck.l5Judul": "Ringkasan sesudah meeting",
  "landing.ck.l5Ket": "Voice note di grup atau rekaman audio yang diunggah menjadi transkrip dan ringkasan.",
  "landing.ck.dataJudul": "Data calon klien",
  "landing.ck.dataKet": "Langkah 2 dan 3, terkumpul dari DM",
  "landing.data.perusahaan": "Perusahaan",
  "landing.data.perusahaanIsi": "PT Mitra Niaga Logistik",
  "landing.data.alamat": "Alamat",
  "landing.data.alamatIsi": "Jl. Raya Cakung, Jakarta Timur",
  "landing.data.pic": "PIC",
  "landing.data.picIsi": "Rina Kartika, Manajer HR",
  "landing.data.email": "Email",
  "landing.data.emailIsi": "rina•••@•••.co.id",
  "landing.data.telepon": "Telepon",
  "landing.data.teleponIsi": "0813 •••• 2290",
  "landing.data.karyawan": "Karyawan",
  "landing.data.karyawanIsi": "400 karyawan di 5 cabang",
  "landing.data.tambahan": "pertanyaan tambahan Anda",
  "landing.ck.hariJudul": "Hari yang ditawarkan bot",
  "landing.ck.senin": "Senin",
  "landing.ck.selasa": "Selasa",
  "landing.ck.rabu": "Rabu",
  "landing.ck.jamKet": "Jam mulai yang kosong hari Senin: 08.00–15.30 WIB. Rina memilih pukul 10.00.",
  "landing.ck.tercatat": "Presentasi online Seleris Care Senin pukul 10.00 WIB sudah tercatat.",
  "landing.grup.nama": "Tim Seleris",
  "landing.grup.ket": "Grup Telegram tim",
  "landing.grup.ketLangkah": "Grup Telegram tim · langkah 4 dan 5",
  "landing.grup.meetingJudul": "Meeting baru terjadwal",
  "landing.grup.meetingWaktu": "Senin pukul 10.00 WIB",
  "landing.grup.meetingAjak": "Silakan pilih siapa saja yang akan ikut meeting di Smova.",
  "landing.grup.waktuSesudah": "Senin 11.05",
  "landing.grup.suara": "Voice note sesudah meeting",
  "landing.ringkas.kepala": "Halaman calon klien · PT Mitra Niaga Logistik",
  "landing.ringkas.label": "Ringkasan",
  "landing.ringkas.isi": "Tim HR ingin Seleris Care Prime untuk 400 karyawan di 5 cabang. Minta penawaran harga dan contoh laporan.",
  "landing.ringkas.ket": "Transkripnya tersimpan di halaman yang sama.",
  "landing.ck.bawah": "Kalau ada DM yang perlu manusia, kartu “DM perlu manusia” datang ke grup.",
  "landing.ck.bawahTautan": "Lihat bagaimana tim mengambil alih",
  "landing.po.pil": "Saat jawabannya harus dari orang",
  "landing.po.judul1": "Bot tahu kapan berhenti.",
  "landing.po.judul2": "Tim dipanggil lewat satu kartu.",
  "landing.po.sub": "Senin siang, Rina menulis lagi dan meminta penawaran harga untuk 400 karyawan. Penawaran harga, keluhan, permintaan bicara dengan orang, dan pesan titipan untuk seseorang bukan urusan bot. Smova meneruskannya ke grup tim, lengkap dengan sebabnya.",
  "landing.po.b1Judul": "Ambil & Tangani",
  "landing.po.b1Ket": "Satu ketukan di grup, dan percakapan itu menjadi tanggungan Anda. Bot berhenti membalas orang itu sampai Anda mengembalikannya. Balasannya diketik di dashboard Smova, dari laptop atau HP.",
  "landing.po.b2Judul": "Satu urusan, satu kartu",
  "landing.po.b2Ket": "Kalau orangnya menulis lagi, kartu yang sama diperbarui, bukan pesan baru. Siapa yang menangani tertulis di kartunya, jadi grup tetap mudah dibaca.",
  "landing.po.b3Judul": "Tamu tidak ditinggal",
  "landing.po.b3Ket": "Untuk pesan titipan, bot memberi tahu bahwa pesannya sudah diteruskan ke tim, tanpa menjanjikan siapa atau kapan, lalu tetap menawarkan bantuan seputar perusahaan Anda.",
  "landing.tg.label": "Smova · 13.05",
  "landing.tg.judul": "DM perlu manusia",
  "landing.tg.sebab": "Bot sudah membalas, tapi ini perlu orang: meminta penawaran harga.",
  "landing.tg.kutip": "“Untuk 400 karyawan, kira-kira biayanya berapa?”",
  "landing.tg.baruKepala": "1 pesan baru sejak kartu ini · terakhir 13.15, menunggu tim:",
  "landing.tg.baruIsi": "“Ditunggu penawarannya, ya.”",
  "landing.tg.ambil": "Ambil & Tangani",
  "landing.tg.buka": "Buka di Smova",
  "landing.tg.ditangani": "Ditangani oleh Dita · 13.08",
  "landing.tg.diam": "Bot diam untuk @rina.mitraniaga sampai dikembalikan di Smova.",
  "landing.tg.pengatur": "Keadaan kartu contoh",
  "landing.tg.kartuMasuk": "Kartu masuk",
  "landing.tg.diambilDita": "Diambil Dita",
  "landing.tg.rinaMenulisLagi": "Rina menulis lagi",
  "landing.tg.ket": "Kartu yang sama diperbarui; tidak ada pesan baru di grup. Contoh: nama dan isi karangan.",
  "landing.konten.pil": "Konten Instagram dan Facebook",
  "landing.konten.judul1": "Konten rutin sudah disusun,",
  "landing.konten.judul2": "tim tinggal menyetujui.",
  "landing.konten.sub": "AI menyusun caption dan gambarnya, berupa foto atau carousel 2–10 slide. Bingkai dan logo merek ditempel dari berkas aslinya. Sesudah tim Anda menyetujui, konten terbit terjadwal ke Instagram dan Facebook menurut jam WIB.",
  "landing.konten.alur": "Alur konten",
  "landing.konten.alur1": "Disusun AI",
  "landing.konten.alur2": "Disetujui tim",
  "landing.konten.alur3": "Terbit terjadwal, WIB",
  "landing.konten.gambar1": "Konten Instagram Seleris berjudul Manfaat tidur cukup bagi daya tahan tubuh, membandingkan kamar berlabel Tidur berantakan dan Tidur yang cukup, dengan maskot astronaut, logo Seleris, dan kontak seleris.ai di bawahnya",
  "landing.konten.gambar2": "Konten Instagram Seleris berjudul Kenapa cek kesehatan rutin sebelum usia 40, dengan maskot astronaut memegang kaca pembesar di samping alat pemeriksaan",
  "landing.konten.ket": "Contoh konten yang disusun Smova untuk Seleris: caption, gambar, dan bingkai mereknya.",
  "landing.batas.pil": "Batas yang jelas",
  "landing.batas.judul1": "Bot menjawab atas nama perusahaan Anda.",
  "landing.batas.judul2": "Anda yang mengatur batasnya.",
  "landing.batas.aturJudul": "Yang Anda atur",
  "landing.batas.atur1": "Nama bot dan gaya bicaranya: formal, ramah, atau santai.",
  "landing.batas.atur2": "Siapa yang dilayani. Kalau Anda hanya melayani perusahaan, bot menyampaikan dengan sopan kepada pembeli perorangan bahwa layanan Anda untuk perusahaan.",
  "landing.batas.atur3": "Kapan bot membalas: 24 jam, atau hanya pada hari dan jam tertentu. Di luar jam itu bot diam atau mengirim satu pesan yang Anda tulis, dan percakapannya tetap masuk ke daftar tim.",
  "landing.batas.atur4": "Data yang ditanyakan sebelum meeting, beserta urutannya.",
  "landing.batas.atur5": "Hari, jam, lama, dan batas meeting per hari, serta tanggal libur.",
  "landing.batas.biayaJudul": "Biaya AI terkendali",
  "landing.batas.biayaKet": "Belanja AI diberi batas bulanan. Kalau batas itu tersentuh, pembuatan gambar berhenti lebih dulu, lalu penyusunan konten. Balasan chat ke pelanggan berhenti paling akhir. Belanjanya terlihat per hari di Smova.",
  "landing.batas.bisaJudul": "Yang sudah bisa hari ini",
  "landing.batas.kemampuan": "Kemampuan",
  "landing.batas.fb": "Halaman Facebook",
  "landing.batas.membalasDm": "Membalas DM",
  "landing.batas.membalasKomentar": "Membalas komentar",
  "landing.batas.menerbitkan": "Menerbitkan konten",
  "landing.batas.angka": "Angka tiap postingan",
  "landing.batas.bisa": "Bisa",
  "landing.batas.belum": "Belum",
  "landing.batas.tunggu": "Menunggu izin Meta",
  "landing.batas.catatan1": "Belum: platformnya mengizinkan, tetapi Smova belum mengerjakannya.",
  "landing.batas.catatan2": "LinkedIn dan TikTok belum tersedia. Bot tidak membalas chat WhatsApp.",
  "landing.batas.catatan3": "Aturan Instagram: DM hanya bisa dibalas dari Smova dalam 24 jam sejak pesan terakhir orangnya.",
  "landing.batas.catatan4": "Jam meeting dan jam terbit dihitung dalam WIB.",
  "landing.tj.pil": "Tanya jawab",
  "landing.tj.judul1": "Yang biasanya ditanyakan",
  "landing.tj.judul2": "sebelum mulai.",
  "landing.tj.tanya1": "Berapa biayanya?",
  "landing.tj.jawab1": "Seleris menyampaikan biayanya setelah tahu fitur yang Anda perlukan.",
  "landing.tj.jawab1Lanjut": "Pemakaian AI diberi batas bulanan, dan belanjanya terlihat per hari di Smova.",
  "landing.tj.tanya2": "Berapa lama sampai bot menjawab pelanggan?",
  "landing.tj.jawab2": "Tergantung kesiapan bahan Anda, terutama dokumen produknya. Seleris menyebut perkiraannya setelah melihat bahan Anda.",
  "landing.tj.tanya3": "Apa yang perlu kami siapkan?",
  "landing.tj.jawab3_1": "Akun Instagram bisnis dan Halaman Facebook perusahaan.",
  "landing.tj.jawab3_2": "Dokumen teks berisi profil perusahaan, produk, harga, dan pertanyaan yang sering muncul. Berkas PDF dan Word perlu disimpan sebagai teks dulu.",
  "landing.tj.jawab3_3": "Satu grup Telegram untuk tim.",
  "landing.tj.jawab3_4": "Nama dan email setiap orang yang akan memakai Smova.",
  "landing.tj.jawab3_5": "Satu atau dua akun Instagram pribadi untuk uji coba.",
  "landing.tj.tanya4": "Apakah tim kami harus memakai Telegram?",
  "landing.tj.jawab4": "Ya, untuk kabar tim. Pesan yang perlu dijawab orang, calon klien baru, meeting baru, dan konten yang menunggu persetujuan dikirim ke satu grup Telegram, lengkap dengan tombolnya. Setiap anggota menyambungkan akunnya sekali dengan kode dari admin. Membalas pelanggan dan mengatur bot dikerjakan di dashboard Smova lewat browser.",
  "landing.tj.tanya5": "Apakah kami harus memakai semua fitur?",
  "landing.tj.jawab5": "Tidak. Fitur dinyalakan sesuai kebutuhan, misalnya hanya membalas chat, membalas chat sampai jadwal meeting, atau konten rutin dari ide tim sendiri. Fitur yang saling bergantung dijaga sistem, jadi tidak ada fitur yang menyala tanpa fitur yang dibutuhkannya.",
  "landing.tj.tanya6": "Bagaimana kalau bot menjawab keliru?",
  "landing.tj.jawab6": "Bot menjawab dari dokumen Anda, jadi perbaikannya biasanya ada di dokumen itu: betulkan atau tambahkan bagiannya, lalu periksa lagi dengan Uji jawaban di Smova. Selama itu, tim bisa mengambil alih percakapan kapan saja, dan bot diam untuk orang itu sampai dikembalikan.",
  "landing.tj.tanya7": "Apa yang terjadi sesudah meeting dijadwalkan?",
  "landing.tj.jawab7": "Sehari sebelum meeting, grup tim menerima daftar meeting besok. Pengingat ini untuk tim; calon klien tidak diingatkan otomatis. Sesudah meeting, balas pesan meeting itu di grup dengan voice note, atau unggah rekaman audionya di Smova. Smova menulis transkrip dan ringkasannya di halaman calon klien itu.",
  "landing.tj.tanya8": "Bagaimana dengan data pelanggan kami?",
  "landing.tj.jawab8": "Data tiap perusahaan terpisah dari perusahaan lain. Yang bisa melihatnya adalah orang di perusahaan Anda, masing-masing dengan akunnya sendiri, dan tim Seleris yang merawat layanannya. Perubahan pengaturan bot, jadwal, dan aturan meeting tercatat beserta siapa yang mengubahnya.",
  "landing.mulai.judul": "Cara mulai",
  "landing.mulai.tahap1": "Persiapan",
  "landing.mulai.tahap1Ket": "bot diam",
  "landing.mulai.tahap2": "Uji coba tertutup",
  "landing.mulai.tahap2Ket": "bot hanya menjawab akun uji",
  "landing.mulai.tahap3": "Berjalan",
  "landing.mulai.tegas": "Tidak ada yang terkirim ke pelanggan atau terbit di akun Anda sebelum tahap ketiga.",
  "landing.pegang.seleris": "Yang dipegang Seleris",
  "landing.pegang.seleris1": "Sambungan Instagram, Halaman Facebook, dan grup Telegram",
  "landing.pegang.seleris2": "Akun tiap orang di tim",
  "landing.pegang.seleris3": "Fitur yang menyala dan batas belanja AI",
  "landing.pegang.seleris4": "Kapan bot mulai menjawab semua orang",
  "landing.pegang.seleris5": "Pemantauan dan penanganan gangguan",
  "landing.pegang.tim": "Yang dipegang tim Anda",
  "landing.pegang.tim1": "Isi dokumen produk",
  "landing.pegang.tim2": "Nama, gaya bicara, dan jam balas bot",
  "landing.pegang.tim3": "Aturan meeting dan tanggal libur",
  "landing.pegang.tim4": "Arah konten, gambar merek, dan jam terbit",
  "landing.pegang.tim5": "Setiap keputusan: membalas, menerima calon klien, dan menyetujui konten",
  "landing.kontak.maskot": "Maskot astronaut Seleris mengedipkan mata dan mengacungkan jempol sambil memegang tablet",
  "landing.kontak.judul1": "Ingin DM Instagram Anda",
  "landing.kontak.judul2": "dijawab seperti ini?",
  "landing.kontak.sub": "Ceritakan bidang usaha Anda dan cara tim Anda menjual. Smova dipasang dan dirawat oleh Seleris.",
  "landing.ph.biaya": "[ketentuan biaya dan kerja sama Seleris]",
  "landing.ph.lamaPasang": "[perkiraan waktu pemasangan dari Seleris]",
  "landing.ph.nomorWa": "[nomor WhatsApp Seleris]",
  "landing.kaki.merekAtas": "Smova, ke atas halaman",
  "landing.kaki.logo": "Logo Seleris, Risk Reimagined",
  "landing.kaki.dirawat": "Dipasang dan dirawat oleh Seleris",
  "landing.kaki.masuk": "Masuk ke dashboard"
}
